(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6IT3i", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4e518e571360fc84$export$6503ec6e8aabbaf; }, function (v) { return $4e518e571360fc84$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4e518e571360fc84$export$f7ad0328861e2f03; }, function (v) { return $4e518e571360fc84$export$f7ad0328861e2f03 = v; });
var $4e518e571360fc84$export$6503ec6e8aabbaf;
var $4e518e571360fc84$export$f7ad0328861e2f03;
"use strict";
var $4e518e571360fc84$var$mapping = new Map();
function $4e518e571360fc84$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4e518e571360fc84$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4e518e571360fc84$var$resolve(id) {
    var resolved = $4e518e571360fc84$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4e518e571360fc84$export$6503ec6e8aabbaf = $4e518e571360fc84$var$register;
$4e518e571360fc84$export$f7ad0328861e2f03 = $4e518e571360fc84$var$resolve;

});

parcelRegister("4vTas", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $3494d9d0ce7a7ef9$export$bdfd709ae4826697; }, function (v) { return $3494d9d0ce7a7ef9$export$bdfd709ae4826697 = v; });
var $3494d9d0ce7a7ef9$export$bdfd709ae4826697;
var $3494d9d0ce7a7ef9$export$c9e73fbda7da57b6;
var $3494d9d0ce7a7ef9$export$5a759dc7a1cfb72a;
"use strict";
var $3494d9d0ce7a7ef9$var$bundleURL = {};
function $3494d9d0ce7a7ef9$var$getBundleURLCached(id) {
    var value = $3494d9d0ce7a7ef9$var$bundleURL[id];
    if (!value) {
        value = $3494d9d0ce7a7ef9$var$getBundleURL();
        $3494d9d0ce7a7ef9$var$bundleURL[id] = value;
    }
    return value;
}
function $3494d9d0ce7a7ef9$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $3494d9d0ce7a7ef9$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $3494d9d0ce7a7ef9$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $3494d9d0ce7a7ef9$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$3494d9d0ce7a7ef9$export$bdfd709ae4826697 = $3494d9d0ce7a7ef9$var$getBundleURLCached;
$3494d9d0ce7a7ef9$export$c9e73fbda7da57b6 = $3494d9d0ce7a7ef9$var$getBaseURL;
$3494d9d0ce7a7ef9$export$5a759dc7a1cfb72a = $3494d9d0ce7a7ef9$var$getOrigin;

});

parcelRegister("22qX1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1Doq0"));

});
parcelRegister("1Doq0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $130c5ff929a347ed$export$ffb0004e005737fa; }, function (v) { return $130c5ff929a347ed$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $130c5ff929a347ed$export$34b9dba7ce09269b; }, function (v) { return $130c5ff929a347ed$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $130c5ff929a347ed$export$25062201e9e25d76; }, function (v) { return $130c5ff929a347ed$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $130c5ff929a347ed$export$ffb0004e005737fa;
var $130c5ff929a347ed$export$34b9dba7ce09269b;
var $130c5ff929a347ed$export$25062201e9e25d76;
'use strict';

var $eN0cn = parcelRequire("eN0cn");
var $130c5ff929a347ed$var$k = Symbol["for"]("react.element"), $130c5ff929a347ed$var$l = Symbol["for"]("react.fragment"), $130c5ff929a347ed$var$m = Object.prototype.hasOwnProperty, $130c5ff929a347ed$var$n = $eN0cn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $130c5ff929a347ed$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $130c5ff929a347ed$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$130c5ff929a347ed$var$m.call(a, b) && !$130c5ff929a347ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $130c5ff929a347ed$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $130c5ff929a347ed$var$n.current
    };
}
$130c5ff929a347ed$export$ffb0004e005737fa = $130c5ff929a347ed$var$l;
$130c5ff929a347ed$export$34b9dba7ce09269b = $130c5ff929a347ed$var$q;
$130c5ff929a347ed$export$25062201e9e25d76 = $130c5ff929a347ed$var$q;

});
parcelRegister("eN0cn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lyEmn"));

});
parcelRegister("lyEmn", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $fb1c1493f0d4c431$export$dca3b0875bd9a954; }, function (v) { return $fb1c1493f0d4c431$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $fb1c1493f0d4c431$export$16fa2f45be04daa8; }, function (v) { return $fb1c1493f0d4c431$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fb1c1493f0d4c431$export$ffb0004e005737fa; }, function (v) { return $fb1c1493f0d4c431$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $fb1c1493f0d4c431$export$e2c29f18771995cb; }, function (v) { return $fb1c1493f0d4c431$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $fb1c1493f0d4c431$export$221d75b3f55bb0bd; }, function (v) { return $fb1c1493f0d4c431$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fb1c1493f0d4c431$export$5f8d39834fd61797; }, function (v) { return $fb1c1493f0d4c431$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fb1c1493f0d4c431$export$74bf444e3cd11ea5; }, function (v) { return $fb1c1493f0d4c431$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fb1c1493f0d4c431$export$ae55be85d98224ed; }, function (v) { return $fb1c1493f0d4c431$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $fb1c1493f0d4c431$export$e530037191fcd5d7; }, function (v) { return $fb1c1493f0d4c431$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $fb1c1493f0d4c431$export$fd42f52fd3ae1109; }, function (v) { return $fb1c1493f0d4c431$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $fb1c1493f0d4c431$export$c8a8987d4410bf2d; }, function (v) { return $fb1c1493f0d4c431$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $fb1c1493f0d4c431$export$d38cd72104c1f0e9; }, function (v) { return $fb1c1493f0d4c431$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $fb1c1493f0d4c431$export$7d1e3a5e95ceca43; }, function (v) { return $fb1c1493f0d4c431$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $fb1c1493f0d4c431$export$257a8862b851cb5b; }, function (v) { return $fb1c1493f0d4c431$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $fb1c1493f0d4c431$export$a8257692ac88316c; }, function (v) { return $fb1c1493f0d4c431$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $fb1c1493f0d4c431$export$488013bae63b21da; }, function (v) { return $fb1c1493f0d4c431$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $fb1c1493f0d4c431$export$7c73462e0d25e514; }, function (v) { return $fb1c1493f0d4c431$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $fb1c1493f0d4c431$export$7568632d0d33d16d; }, function (v) { return $fb1c1493f0d4c431$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $fb1c1493f0d4c431$export$88948ce120ea2619; }, function (v) { return $fb1c1493f0d4c431$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $fb1c1493f0d4c431$export$35808ee640e87ca7; }, function (v) { return $fb1c1493f0d4c431$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $fb1c1493f0d4c431$export$fae74005e78b1a27; }, function (v) { return $fb1c1493f0d4c431$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $fb1c1493f0d4c431$export$dc8fbce3eb94dc1e; }, function (v) { return $fb1c1493f0d4c431$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $fb1c1493f0d4c431$export$6a7bc4e911dc01cf; }, function (v) { return $fb1c1493f0d4c431$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $fb1c1493f0d4c431$export$6d9c69b0de29b591; }, function (v) { return $fb1c1493f0d4c431$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $fb1c1493f0d4c431$export$f680877a34711e37; }, function (v) { return $fb1c1493f0d4c431$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $fb1c1493f0d4c431$export$d5a552a76deda3c2; }, function (v) { return $fb1c1493f0d4c431$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $fb1c1493f0d4c431$export$aaabe4eda9ed9969; }, function (v) { return $fb1c1493f0d4c431$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $fb1c1493f0d4c431$export$e5c5a5f917a5871c; }, function (v) { return $fb1c1493f0d4c431$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $fb1c1493f0d4c431$export$1538c33de8887b59; }, function (v) { return $fb1c1493f0d4c431$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $fb1c1493f0d4c431$export$13e3392192263954; }, function (v) { return $fb1c1493f0d4c431$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $fb1c1493f0d4c431$export$b8f5890fc79d6aca; }, function (v) { return $fb1c1493f0d4c431$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $fb1c1493f0d4c431$export$60241385465d0a34; }, function (v) { return $fb1c1493f0d4c431$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $fb1c1493f0d4c431$export$306c0aa65ff9ec16; }, function (v) { return $fb1c1493f0d4c431$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $fb1c1493f0d4c431$export$7b286972b8d8ccbf; }, function (v) { return $fb1c1493f0d4c431$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $fb1c1493f0d4c431$export$83d89fbfd8236492; }, function (v) { return $fb1c1493f0d4c431$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $k4vcf = parcelRequire("k4vcf");
var $fb1c1493f0d4c431$export$dca3b0875bd9a954;
var $fb1c1493f0d4c431$export$16fa2f45be04daa8;
var $fb1c1493f0d4c431$export$ffb0004e005737fa;
var $fb1c1493f0d4c431$export$e2c29f18771995cb;
var $fb1c1493f0d4c431$export$221d75b3f55bb0bd;
var $fb1c1493f0d4c431$export$5f8d39834fd61797;
var $fb1c1493f0d4c431$export$74bf444e3cd11ea5;
var $fb1c1493f0d4c431$export$ae55be85d98224ed;
var $fb1c1493f0d4c431$export$e530037191fcd5d7;
var $fb1c1493f0d4c431$export$fd42f52fd3ae1109;
var $fb1c1493f0d4c431$export$c8a8987d4410bf2d;
var $fb1c1493f0d4c431$export$d38cd72104c1f0e9;
var $fb1c1493f0d4c431$export$7d1e3a5e95ceca43;
var $fb1c1493f0d4c431$export$257a8862b851cb5b;
var $fb1c1493f0d4c431$export$a8257692ac88316c;
var $fb1c1493f0d4c431$export$488013bae63b21da;
var $fb1c1493f0d4c431$export$7c73462e0d25e514;
var $fb1c1493f0d4c431$export$7568632d0d33d16d;
var $fb1c1493f0d4c431$export$88948ce120ea2619;
var $fb1c1493f0d4c431$export$35808ee640e87ca7;
var $fb1c1493f0d4c431$export$fae74005e78b1a27;
var $fb1c1493f0d4c431$export$dc8fbce3eb94dc1e;
var $fb1c1493f0d4c431$export$6a7bc4e911dc01cf;
var $fb1c1493f0d4c431$export$6d9c69b0de29b591;
var $fb1c1493f0d4c431$export$f680877a34711e37;
var $fb1c1493f0d4c431$export$d5a552a76deda3c2;
var $fb1c1493f0d4c431$export$aaabe4eda9ed9969;
var $fb1c1493f0d4c431$export$e5c5a5f917a5871c;
var $fb1c1493f0d4c431$export$1538c33de8887b59;
var $fb1c1493f0d4c431$export$13e3392192263954;
var $fb1c1493f0d4c431$export$b8f5890fc79d6aca;
var $fb1c1493f0d4c431$export$60241385465d0a34;
var $fb1c1493f0d4c431$export$306c0aa65ff9ec16;
var $fb1c1493f0d4c431$export$7b286972b8d8ccbf;
var $fb1c1493f0d4c431$export$83d89fbfd8236492;
'use strict';
var $fb1c1493f0d4c431$var$l = Symbol["for"]("react.element"), $fb1c1493f0d4c431$var$n = Symbol["for"]("react.portal"), $fb1c1493f0d4c431$var$p = Symbol["for"]("react.fragment"), $fb1c1493f0d4c431$var$q = Symbol["for"]("react.strict_mode"), $fb1c1493f0d4c431$var$r = Symbol["for"]("react.profiler"), $fb1c1493f0d4c431$var$t = Symbol["for"]("react.provider"), $fb1c1493f0d4c431$var$u = Symbol["for"]("react.context"), $fb1c1493f0d4c431$var$v = Symbol["for"]("react.forward_ref"), $fb1c1493f0d4c431$var$w = Symbol["for"]("react.suspense"), $fb1c1493f0d4c431$var$x = Symbol["for"]("react.memo"), $fb1c1493f0d4c431$var$y = Symbol["for"]("react.lazy"), $fb1c1493f0d4c431$var$z = Symbol.iterator;
function $fb1c1493f0d4c431$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a))) return null;
    a = $fb1c1493f0d4c431$var$z && a[$fb1c1493f0d4c431$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fb1c1493f0d4c431$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $fb1c1493f0d4c431$var$C = Object.assign, $fb1c1493f0d4c431$var$D = {};
function $fb1c1493f0d4c431$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fb1c1493f0d4c431$var$D;
    this.updater = e || $fb1c1493f0d4c431$var$B;
}
$fb1c1493f0d4c431$var$E.prototype.isReactComponent = {};
$fb1c1493f0d4c431$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$fb1c1493f0d4c431$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $fb1c1493f0d4c431$var$F() {}
$fb1c1493f0d4c431$var$F.prototype = $fb1c1493f0d4c431$var$E.prototype;
function $fb1c1493f0d4c431$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fb1c1493f0d4c431$var$D;
    this.updater = e || $fb1c1493f0d4c431$var$B;
}
var $fb1c1493f0d4c431$var$H = $fb1c1493f0d4c431$var$G.prototype = new $fb1c1493f0d4c431$var$F;
$fb1c1493f0d4c431$var$H.constructor = $fb1c1493f0d4c431$var$G;
$fb1c1493f0d4c431$var$C($fb1c1493f0d4c431$var$H, $fb1c1493f0d4c431$var$E.prototype);
$fb1c1493f0d4c431$var$H.isPureReactComponent = !0;
var $fb1c1493f0d4c431$var$I = Array.isArray, $fb1c1493f0d4c431$var$J = Object.prototype.hasOwnProperty, $fb1c1493f0d4c431$var$K = {
    current: null
}, $fb1c1493f0d4c431$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fb1c1493f0d4c431$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$fb1c1493f0d4c431$var$J.call(b, d) && !$fb1c1493f0d4c431$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $fb1c1493f0d4c431$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $fb1c1493f0d4c431$var$K.current
    };
}
function $fb1c1493f0d4c431$var$N(a, b) {
    return {
        $$typeof: $fb1c1493f0d4c431$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $fb1c1493f0d4c431$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)) && null !== a && a.$$typeof === $fb1c1493f0d4c431$var$l;
}
function $fb1c1493f0d4c431$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $fb1c1493f0d4c431$var$P = /\/+/g;
function $fb1c1493f0d4c431$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)) && null !== a && null != a.key ? $fb1c1493f0d4c431$var$escape("" + a.key) : b.toString(36);
}
function $fb1c1493f0d4c431$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $fb1c1493f0d4c431$var$l:
                case $fb1c1493f0d4c431$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $fb1c1493f0d4c431$var$Q(h, 0) : d, $fb1c1493f0d4c431$var$I(c) ? (e = "", null != a && (e = a.replace($fb1c1493f0d4c431$var$P, "$&/") + "/"), $fb1c1493f0d4c431$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($fb1c1493f0d4c431$var$O(c) && (c = $fb1c1493f0d4c431$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($fb1c1493f0d4c431$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($fb1c1493f0d4c431$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $fb1c1493f0d4c431$var$Q(k, g);
        h += $fb1c1493f0d4c431$var$R(k, b, e, f, c);
    }
    else if (f = $fb1c1493f0d4c431$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $fb1c1493f0d4c431$var$Q(k, g++), h += $fb1c1493f0d4c431$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $fb1c1493f0d4c431$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $fb1c1493f0d4c431$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $fb1c1493f0d4c431$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result["default"];
    throw a._result;
}
var $fb1c1493f0d4c431$var$U = {
    current: null
}, $fb1c1493f0d4c431$var$V = {
    transition: null
}, $fb1c1493f0d4c431$var$W = {
    ReactCurrentDispatcher: $fb1c1493f0d4c431$var$U,
    ReactCurrentBatchConfig: $fb1c1493f0d4c431$var$V,
    ReactCurrentOwner: $fb1c1493f0d4c431$var$K
};
$fb1c1493f0d4c431$export$dca3b0875bd9a954 = {
    map: $fb1c1493f0d4c431$var$S,
    forEach: function forEach(a, b, e) {
        $fb1c1493f0d4c431$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $fb1c1493f0d4c431$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $fb1c1493f0d4c431$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$fb1c1493f0d4c431$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$fb1c1493f0d4c431$export$16fa2f45be04daa8 = $fb1c1493f0d4c431$var$E;
$fb1c1493f0d4c431$export$ffb0004e005737fa = $fb1c1493f0d4c431$var$p;
$fb1c1493f0d4c431$export$e2c29f18771995cb = $fb1c1493f0d4c431$var$r;
$fb1c1493f0d4c431$export$221d75b3f55bb0bd = $fb1c1493f0d4c431$var$G;
$fb1c1493f0d4c431$export$5f8d39834fd61797 = $fb1c1493f0d4c431$var$q;
$fb1c1493f0d4c431$export$74bf444e3cd11ea5 = $fb1c1493f0d4c431$var$w;
$fb1c1493f0d4c431$export$ae55be85d98224ed = $fb1c1493f0d4c431$var$W;
$fb1c1493f0d4c431$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $fb1c1493f0d4c431$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $fb1c1493f0d4c431$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$fb1c1493f0d4c431$var$J.call(b, f) && !$fb1c1493f0d4c431$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $fb1c1493f0d4c431$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$fb1c1493f0d4c431$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $fb1c1493f0d4c431$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $fb1c1493f0d4c431$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$fb1c1493f0d4c431$export$c8a8987d4410bf2d = $fb1c1493f0d4c431$var$M;
$fb1c1493f0d4c431$export$d38cd72104c1f0e9 = function(a) {
    var b = $fb1c1493f0d4c431$var$M.bind(null, a);
    b.type = a;
    return b;
};
$fb1c1493f0d4c431$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$fb1c1493f0d4c431$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $fb1c1493f0d4c431$var$v,
        render: a
    };
};
$fb1c1493f0d4c431$export$a8257692ac88316c = $fb1c1493f0d4c431$var$O;
$fb1c1493f0d4c431$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $fb1c1493f0d4c431$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $fb1c1493f0d4c431$var$T
    };
};
$fb1c1493f0d4c431$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $fb1c1493f0d4c431$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$fb1c1493f0d4c431$export$7568632d0d33d16d = function(a) {
    var b = $fb1c1493f0d4c431$var$V.transition;
    $fb1c1493f0d4c431$var$V.transition = {};
    try {
        a();
    } finally{
        $fb1c1493f0d4c431$var$V.transition = b;
    }
};
$fb1c1493f0d4c431$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$fb1c1493f0d4c431$export$35808ee640e87ca7 = function(a, b) {
    return $fb1c1493f0d4c431$var$U.current.useCallback(a, b);
};
$fb1c1493f0d4c431$export$fae74005e78b1a27 = function(a) {
    return $fb1c1493f0d4c431$var$U.current.useContext(a);
};
$fb1c1493f0d4c431$export$dc8fbce3eb94dc1e = function() {};
$fb1c1493f0d4c431$export$6a7bc4e911dc01cf = function(a) {
    return $fb1c1493f0d4c431$var$U.current.useDeferredValue(a);
};
$fb1c1493f0d4c431$export$6d9c69b0de29b591 = function(a, b) {
    return $fb1c1493f0d4c431$var$U.current.useEffect(a, b);
};
$fb1c1493f0d4c431$export$f680877a34711e37 = function() {
    return $fb1c1493f0d4c431$var$U.current.useId();
};
$fb1c1493f0d4c431$export$d5a552a76deda3c2 = function(a, b, e) {
    return $fb1c1493f0d4c431$var$U.current.useImperativeHandle(a, b, e);
};
$fb1c1493f0d4c431$export$aaabe4eda9ed9969 = function(a, b) {
    return $fb1c1493f0d4c431$var$U.current.useInsertionEffect(a, b);
};
$fb1c1493f0d4c431$export$e5c5a5f917a5871c = function(a, b) {
    return $fb1c1493f0d4c431$var$U.current.useLayoutEffect(a, b);
};
$fb1c1493f0d4c431$export$1538c33de8887b59 = function(a, b) {
    return $fb1c1493f0d4c431$var$U.current.useMemo(a, b);
};
$fb1c1493f0d4c431$export$13e3392192263954 = function(a, b, e) {
    return $fb1c1493f0d4c431$var$U.current.useReducer(a, b, e);
};
$fb1c1493f0d4c431$export$b8f5890fc79d6aca = function(a) {
    return $fb1c1493f0d4c431$var$U.current.useRef(a);
};
$fb1c1493f0d4c431$export$60241385465d0a34 = function(a) {
    return $fb1c1493f0d4c431$var$U.current.useState(a);
};
$fb1c1493f0d4c431$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $fb1c1493f0d4c431$var$U.current.useSyncExternalStore(a, b, e);
};
$fb1c1493f0d4c431$export$7b286972b8d8ccbf = function() {
    return $fb1c1493f0d4c431$var$U.current.useTransition();
};
$fb1c1493f0d4c431$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("k4vcf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e9cc6155791e61da$export$71511d61b312f219; });
function $e9cc6155791e61da$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("hPUkI", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $cfc2e5a80c7c6d5c$export$ae55be85d98224ed; }, function (v) { return $cfc2e5a80c7c6d5c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $cfc2e5a80c7c6d5c$export$d39a5bbd09211389; }, function (v) { return $cfc2e5a80c7c6d5c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $cfc2e5a80c7c6d5c$export$882461b6382ed46c; }, function (v) { return $cfc2e5a80c7c6d5c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $cfc2e5a80c7c6d5c$export$466bfc07425424d5; }, function (v) { return $cfc2e5a80c7c6d5c$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $cfc2e5a80c7c6d5c$export$cd75ccfd720a3cd4; }, function (v) { return $cfc2e5a80c7c6d5c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $cfc2e5a80c7c6d5c$export$fa8d919ba61d84db; }, function (v) { return $cfc2e5a80c7c6d5c$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $cfc2e5a80c7c6d5c$export$757ceba2d55c277e; }, function (v) { return $cfc2e5a80c7c6d5c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $cfc2e5a80c7c6d5c$export$b3890eb0ae9dca99; }, function (v) { return $cfc2e5a80c7c6d5c$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $cfc2e5a80c7c6d5c$export$502457920280e6be; }, function (v) { return $cfc2e5a80c7c6d5c$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $cfc2e5a80c7c6d5c$export$c78a37762a8d58e1; }, function (v) { return $cfc2e5a80c7c6d5c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $cfc2e5a80c7c6d5c$export$dc54d992c10e8a18; }, function (v) { return $cfc2e5a80c7c6d5c$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $cfc2e5a80c7c6d5c$export$83d89fbfd8236492; }, function (v) { return $cfc2e5a80c7c6d5c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $k4vcf = parcelRequire("k4vcf");
var $cfc2e5a80c7c6d5c$export$ae55be85d98224ed;
var $cfc2e5a80c7c6d5c$export$d39a5bbd09211389;
var $cfc2e5a80c7c6d5c$export$882461b6382ed46c;
var $cfc2e5a80c7c6d5c$export$466bfc07425424d5;
var $cfc2e5a80c7c6d5c$export$cd75ccfd720a3cd4;
var $cfc2e5a80c7c6d5c$export$fa8d919ba61d84db;
var $cfc2e5a80c7c6d5c$export$757ceba2d55c277e;
var $cfc2e5a80c7c6d5c$export$b3890eb0ae9dca99;
var $cfc2e5a80c7c6d5c$export$502457920280e6be;
var $cfc2e5a80c7c6d5c$export$c78a37762a8d58e1;
var $cfc2e5a80c7c6d5c$export$dc54d992c10e8a18;
var $cfc2e5a80c7c6d5c$export$83d89fbfd8236492;
'use strict';

var $eN0cn = parcelRequire("eN0cn");

var $hIoV8 = parcelRequire("hIoV8");
function $cfc2e5a80c7c6d5c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $cfc2e5a80c7c6d5c$var$da = new Set, $cfc2e5a80c7c6d5c$var$ea = {};
function $cfc2e5a80c7c6d5c$var$fa(a, b) {
    $cfc2e5a80c7c6d5c$var$ha(a, b);
    $cfc2e5a80c7c6d5c$var$ha(a + "Capture", b);
}
function $cfc2e5a80c7c6d5c$var$ha(a, b) {
    $cfc2e5a80c7c6d5c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$cfc2e5a80c7c6d5c$var$da.add(b[a]);
}
var $cfc2e5a80c7c6d5c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $cfc2e5a80c7c6d5c$var$ja = Object.prototype.hasOwnProperty, $cfc2e5a80c7c6d5c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $cfc2e5a80c7c6d5c$var$la = {}, $cfc2e5a80c7c6d5c$var$ma = {};
function $cfc2e5a80c7c6d5c$var$oa(a) {
    if ($cfc2e5a80c7c6d5c$var$ja.call($cfc2e5a80c7c6d5c$var$ma, a)) return !0;
    if ($cfc2e5a80c7c6d5c$var$ja.call($cfc2e5a80c7c6d5c$var$la, a)) return !1;
    if ($cfc2e5a80c7c6d5c$var$ka.test(a)) return $cfc2e5a80c7c6d5c$var$ma[a] = !0;
    $cfc2e5a80c7c6d5c$var$la[a] = !0;
    return !1;
}
function $cfc2e5a80c7c6d5c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $k4vcf._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $cfc2e5a80c7c6d5c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $cfc2e5a80c7c6d5c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $cfc2e5a80c7c6d5c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $cfc2e5a80c7c6d5c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $cfc2e5a80c7c6d5c$var$z[b] = new $cfc2e5a80c7c6d5c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $cfc2e5a80c7c6d5c$var$ra = /[\-:]([a-z])/g;
function $cfc2e5a80c7c6d5c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($cfc2e5a80c7c6d5c$var$ra, $cfc2e5a80c7c6d5c$var$sa);
    $cfc2e5a80c7c6d5c$var$z[b] = new $cfc2e5a80c7c6d5c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($cfc2e5a80c7c6d5c$var$ra, $cfc2e5a80c7c6d5c$var$sa);
    $cfc2e5a80c7c6d5c$var$z[b] = new $cfc2e5a80c7c6d5c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($cfc2e5a80c7c6d5c$var$ra, $cfc2e5a80c7c6d5c$var$sa);
    $cfc2e5a80c7c6d5c$var$z[b] = new $cfc2e5a80c7c6d5c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$cfc2e5a80c7c6d5c$var$z.xlinkHref = new $cfc2e5a80c7c6d5c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$z[a] = new $cfc2e5a80c7c6d5c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $cfc2e5a80c7c6d5c$var$ta(a, b, c, d) {
    var e = $cfc2e5a80c7c6d5c$var$z.hasOwnProperty(b) ? $cfc2e5a80c7c6d5c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $cfc2e5a80c7c6d5c$var$qa(b, c, e, d) && (c = null), d || null === e ? $cfc2e5a80c7c6d5c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $cfc2e5a80c7c6d5c$var$ua = $eN0cn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $cfc2e5a80c7c6d5c$var$va = Symbol["for"]("react.element"), $cfc2e5a80c7c6d5c$var$wa = Symbol["for"]("react.portal"), $cfc2e5a80c7c6d5c$var$ya = Symbol["for"]("react.fragment"), $cfc2e5a80c7c6d5c$var$za = Symbol["for"]("react.strict_mode"), $cfc2e5a80c7c6d5c$var$Aa = Symbol["for"]("react.profiler"), $cfc2e5a80c7c6d5c$var$Ba = Symbol["for"]("react.provider"), $cfc2e5a80c7c6d5c$var$Ca = Symbol["for"]("react.context"), $cfc2e5a80c7c6d5c$var$Da = Symbol["for"]("react.forward_ref"), $cfc2e5a80c7c6d5c$var$Ea = Symbol["for"]("react.suspense"), $cfc2e5a80c7c6d5c$var$Fa = Symbol["for"]("react.suspense_list"), $cfc2e5a80c7c6d5c$var$Ga = Symbol["for"]("react.memo"), $cfc2e5a80c7c6d5c$var$Ha = Symbol["for"]("react.lazy");
Symbol["for"]("react.scope");
Symbol["for"]("react.debug_trace_mode");
var $cfc2e5a80c7c6d5c$var$Ia = Symbol["for"]("react.offscreen");
Symbol["for"]("react.legacy_hidden");
Symbol["for"]("react.cache");
Symbol["for"]("react.tracing_marker");
var $cfc2e5a80c7c6d5c$var$Ja = Symbol.iterator;
function $cfc2e5a80c7c6d5c$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a))) return null;
    a = $cfc2e5a80c7c6d5c$var$Ja && a[$cfc2e5a80c7c6d5c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cfc2e5a80c7c6d5c$var$A = Object.assign, $cfc2e5a80c7c6d5c$var$La;
function $cfc2e5a80c7c6d5c$var$Ma(a) {
    if (void 0 === $cfc2e5a80c7c6d5c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $cfc2e5a80c7c6d5c$var$La = b && b[1] || "";
    }
    return "\n" + $cfc2e5a80c7c6d5c$var$La + a;
}
var $cfc2e5a80c7c6d5c$var$Na = !1;
function $cfc2e5a80c7c6d5c$var$Oa(a, b) {
    if (!a || $cfc2e5a80c7c6d5c$var$Na) return "";
    $cfc2e5a80c7c6d5c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $k4vcf._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $cfc2e5a80c7c6d5c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $cfc2e5a80c7c6d5c$var$Ma(a) : "";
}
function $cfc2e5a80c7c6d5c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $cfc2e5a80c7c6d5c$var$Ma(a.type);
        case 16:
            return $cfc2e5a80c7c6d5c$var$Ma("Lazy");
        case 13:
            return $cfc2e5a80c7c6d5c$var$Ma("Suspense");
        case 19:
            return $cfc2e5a80c7c6d5c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $cfc2e5a80c7c6d5c$var$Oa(a.type, !1), a;
        case 11:
            return a = $cfc2e5a80c7c6d5c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $cfc2e5a80c7c6d5c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $cfc2e5a80c7c6d5c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $cfc2e5a80c7c6d5c$var$ya:
            return "Fragment";
        case $cfc2e5a80c7c6d5c$var$wa:
            return "Portal";
        case $cfc2e5a80c7c6d5c$var$Aa:
            return "Profiler";
        case $cfc2e5a80c7c6d5c$var$za:
            return "StrictMode";
        case $cfc2e5a80c7c6d5c$var$Ea:
            return "Suspense";
        case $cfc2e5a80c7c6d5c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a))) switch(a.$$typeof){
        case $cfc2e5a80c7c6d5c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $cfc2e5a80c7c6d5c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $cfc2e5a80c7c6d5c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $cfc2e5a80c7c6d5c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $cfc2e5a80c7c6d5c$var$Qa(a.type) || "Memo";
        case $cfc2e5a80c7c6d5c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $cfc2e5a80c7c6d5c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $cfc2e5a80c7c6d5c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $cfc2e5a80c7c6d5c$var$Qa(b);
        case 8:
            return b === $cfc2e5a80c7c6d5c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $cfc2e5a80c7c6d5c$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $cfc2e5a80c7c6d5c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $cfc2e5a80c7c6d5c$var$Ua(a) {
    var b = $cfc2e5a80c7c6d5c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $cfc2e5a80c7c6d5c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $cfc2e5a80c7c6d5c$var$Ua(a));
}
function $cfc2e5a80c7c6d5c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $cfc2e5a80c7c6d5c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $cfc2e5a80c7c6d5c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $cfc2e5a80c7c6d5c$var$Ya(a, b) {
    var c = b.checked;
    return $cfc2e5a80c7c6d5c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $cfc2e5a80c7c6d5c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $cfc2e5a80c7c6d5c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $cfc2e5a80c7c6d5c$var$ab(a, b) {
    b = b.checked;
    null != b && $cfc2e5a80c7c6d5c$var$ta(a, "checked", b, !1);
}
function $cfc2e5a80c7c6d5c$var$bb(a, b) {
    $cfc2e5a80c7c6d5c$var$ab(a, b);
    var c = $cfc2e5a80c7c6d5c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $cfc2e5a80c7c6d5c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $cfc2e5a80c7c6d5c$var$cb(a, b.type, $cfc2e5a80c7c6d5c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $cfc2e5a80c7c6d5c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $cfc2e5a80c7c6d5c$var$cb(a, b, c) {
    if ("number" !== b || $cfc2e5a80c7c6d5c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $cfc2e5a80c7c6d5c$var$eb = Array.isArray;
function $cfc2e5a80c7c6d5c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $cfc2e5a80c7c6d5c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $cfc2e5a80c7c6d5c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($cfc2e5a80c7c6d5c$var$p(91));
    return $cfc2e5a80c7c6d5c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $cfc2e5a80c7c6d5c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($cfc2e5a80c7c6d5c$var$p(92));
            if ($cfc2e5a80c7c6d5c$var$eb(c)) {
                if (1 < c.length) throw Error($cfc2e5a80c7c6d5c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $cfc2e5a80c7c6d5c$var$Sa(c)
    };
}
function $cfc2e5a80c7c6d5c$var$ib(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$Sa(b.value), d = $cfc2e5a80c7c6d5c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $cfc2e5a80c7c6d5c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $cfc2e5a80c7c6d5c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $cfc2e5a80c7c6d5c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $cfc2e5a80c7c6d5c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $cfc2e5a80c7c6d5c$var$mb, $cfc2e5a80c7c6d5c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $cfc2e5a80c7c6d5c$var$mb = $cfc2e5a80c7c6d5c$var$mb || document.createElement("div");
        $cfc2e5a80c7c6d5c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $cfc2e5a80c7c6d5c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $cfc2e5a80c7c6d5c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $cfc2e5a80c7c6d5c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $cfc2e5a80c7c6d5c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($cfc2e5a80c7c6d5c$var$pb).forEach(function(a) {
    $cfc2e5a80c7c6d5c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $cfc2e5a80c7c6d5c$var$pb[b] = $cfc2e5a80c7c6d5c$var$pb[a];
    });
});
function $cfc2e5a80c7c6d5c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $cfc2e5a80c7c6d5c$var$pb.hasOwnProperty(a) && $cfc2e5a80c7c6d5c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $cfc2e5a80c7c6d5c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $cfc2e5a80c7c6d5c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $cfc2e5a80c7c6d5c$var$tb = $cfc2e5a80c7c6d5c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $cfc2e5a80c7c6d5c$var$ub(a, b) {
    if (b) {
        if ($cfc2e5a80c7c6d5c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($cfc2e5a80c7c6d5c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($cfc2e5a80c7c6d5c$var$p(60));
            if ("object" !== (0, $k4vcf._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($cfc2e5a80c7c6d5c$var$p(61));
        }
        if (null != b.style && "object" !== (0, $k4vcf._)(b.style)) throw Error($cfc2e5a80c7c6d5c$var$p(62));
    }
}
function $cfc2e5a80c7c6d5c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $cfc2e5a80c7c6d5c$var$wb = null;
function $cfc2e5a80c7c6d5c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $cfc2e5a80c7c6d5c$var$yb = null, $cfc2e5a80c7c6d5c$var$zb = null, $cfc2e5a80c7c6d5c$var$Ab = null;
function $cfc2e5a80c7c6d5c$var$Bb(a) {
    if (a = $cfc2e5a80c7c6d5c$var$Cb(a)) {
        if ("function" !== typeof $cfc2e5a80c7c6d5c$var$yb) throw Error($cfc2e5a80c7c6d5c$var$p(280));
        var b = a.stateNode;
        b && (b = $cfc2e5a80c7c6d5c$var$Db(b), $cfc2e5a80c7c6d5c$var$yb(a.stateNode, a.type, b));
    }
}
function $cfc2e5a80c7c6d5c$var$Eb(a) {
    $cfc2e5a80c7c6d5c$var$zb ? $cfc2e5a80c7c6d5c$var$Ab ? $cfc2e5a80c7c6d5c$var$Ab.push(a) : $cfc2e5a80c7c6d5c$var$Ab = [
        a
    ] : $cfc2e5a80c7c6d5c$var$zb = a;
}
function $cfc2e5a80c7c6d5c$var$Fb() {
    if ($cfc2e5a80c7c6d5c$var$zb) {
        var a = $cfc2e5a80c7c6d5c$var$zb, b = $cfc2e5a80c7c6d5c$var$Ab;
        $cfc2e5a80c7c6d5c$var$Ab = $cfc2e5a80c7c6d5c$var$zb = null;
        $cfc2e5a80c7c6d5c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$cfc2e5a80c7c6d5c$var$Bb(b[a]);
    }
}
function $cfc2e5a80c7c6d5c$var$Gb(a, b) {
    return a(b);
}
function $cfc2e5a80c7c6d5c$var$Hb() {}
var $cfc2e5a80c7c6d5c$var$Ib = !1;
function $cfc2e5a80c7c6d5c$var$Jb(a, b, c) {
    if ($cfc2e5a80c7c6d5c$var$Ib) return a(b, c);
    $cfc2e5a80c7c6d5c$var$Ib = !0;
    try {
        return $cfc2e5a80c7c6d5c$var$Gb(a, b, c);
    } finally{
        if ($cfc2e5a80c7c6d5c$var$Ib = !1, null !== $cfc2e5a80c7c6d5c$var$zb || null !== $cfc2e5a80c7c6d5c$var$Ab) $cfc2e5a80c7c6d5c$var$Hb(), $cfc2e5a80c7c6d5c$var$Fb();
    }
}
function $cfc2e5a80c7c6d5c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $cfc2e5a80c7c6d5c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($cfc2e5a80c7c6d5c$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $k4vcf._)(c)));
    return c;
}
var $cfc2e5a80c7c6d5c$var$Lb = !1;
if ($cfc2e5a80c7c6d5c$var$ia) try {
    var $cfc2e5a80c7c6d5c$var$Mb = {};
    Object.defineProperty($cfc2e5a80c7c6d5c$var$Mb, "passive", {
        get: function get() {
            $cfc2e5a80c7c6d5c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $cfc2e5a80c7c6d5c$var$Mb, $cfc2e5a80c7c6d5c$var$Mb);
    window.removeEventListener("test", $cfc2e5a80c7c6d5c$var$Mb, $cfc2e5a80c7c6d5c$var$Mb);
} catch (a) {
    $cfc2e5a80c7c6d5c$var$Lb = !1;
}
function $cfc2e5a80c7c6d5c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $cfc2e5a80c7c6d5c$var$Ob = !1, $cfc2e5a80c7c6d5c$var$Pb = null, $cfc2e5a80c7c6d5c$var$Qb = !1, $cfc2e5a80c7c6d5c$var$Rb = null, $cfc2e5a80c7c6d5c$var$Sb = {
    onError: function onError(a) {
        $cfc2e5a80c7c6d5c$var$Ob = !0;
        $cfc2e5a80c7c6d5c$var$Pb = a;
    }
};
function $cfc2e5a80c7c6d5c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $cfc2e5a80c7c6d5c$var$Ob = !1;
    $cfc2e5a80c7c6d5c$var$Pb = null;
    $cfc2e5a80c7c6d5c$var$Nb.apply($cfc2e5a80c7c6d5c$var$Sb, arguments);
}
function $cfc2e5a80c7c6d5c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $cfc2e5a80c7c6d5c$var$Tb.apply(this, arguments);
    if ($cfc2e5a80c7c6d5c$var$Ob) {
        if ($cfc2e5a80c7c6d5c$var$Ob) {
            var l = $cfc2e5a80c7c6d5c$var$Pb;
            $cfc2e5a80c7c6d5c$var$Ob = !1;
            $cfc2e5a80c7c6d5c$var$Pb = null;
        } else throw Error($cfc2e5a80c7c6d5c$var$p(198));
        $cfc2e5a80c7c6d5c$var$Qb || ($cfc2e5a80c7c6d5c$var$Qb = !0, $cfc2e5a80c7c6d5c$var$Rb = l);
    }
}
function $cfc2e5a80c7c6d5c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b["return"];)b = b["return"];
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $cfc2e5a80c7c6d5c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $cfc2e5a80c7c6d5c$var$Xb(a) {
    if ($cfc2e5a80c7c6d5c$var$Vb(a) !== a) throw Error($cfc2e5a80c7c6d5c$var$p(188));
}
function $cfc2e5a80c7c6d5c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $cfc2e5a80c7c6d5c$var$Vb(a);
        if (null === b) throw Error($cfc2e5a80c7c6d5c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c["return"];
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e["return"];
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $cfc2e5a80c7c6d5c$var$Xb(e), a;
                if (f === d) return $cfc2e5a80c7c6d5c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($cfc2e5a80c7c6d5c$var$p(188));
        }
        if (c["return"] !== d["return"]) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($cfc2e5a80c7c6d5c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($cfc2e5a80c7c6d5c$var$p(190));
    }
    if (3 !== c.tag) throw Error($cfc2e5a80c7c6d5c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $cfc2e5a80c7c6d5c$var$Zb(a) {
    a = $cfc2e5a80c7c6d5c$var$Yb(a);
    return null !== a ? $cfc2e5a80c7c6d5c$var$$b(a) : null;
}
function $cfc2e5a80c7c6d5c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $cfc2e5a80c7c6d5c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $cfc2e5a80c7c6d5c$var$ac = $hIoV8.unstable_scheduleCallback, $cfc2e5a80c7c6d5c$var$bc = $hIoV8.unstable_cancelCallback, $cfc2e5a80c7c6d5c$var$cc = $hIoV8.unstable_shouldYield, $cfc2e5a80c7c6d5c$var$dc = $hIoV8.unstable_requestPaint, $cfc2e5a80c7c6d5c$var$B = $hIoV8.unstable_now, $cfc2e5a80c7c6d5c$var$ec = $hIoV8.unstable_getCurrentPriorityLevel, $cfc2e5a80c7c6d5c$var$fc = $hIoV8.unstable_ImmediatePriority, $cfc2e5a80c7c6d5c$var$gc = $hIoV8.unstable_UserBlockingPriority, $cfc2e5a80c7c6d5c$var$hc = $hIoV8.unstable_NormalPriority, $cfc2e5a80c7c6d5c$var$ic = $hIoV8.unstable_LowPriority, $cfc2e5a80c7c6d5c$var$jc = $hIoV8.unstable_IdlePriority, $cfc2e5a80c7c6d5c$var$kc = null, $cfc2e5a80c7c6d5c$var$lc = null;
function $cfc2e5a80c7c6d5c$var$mc(a) {
    if ($cfc2e5a80c7c6d5c$var$lc && "function" === typeof $cfc2e5a80c7c6d5c$var$lc.onCommitFiberRoot) try {
        $cfc2e5a80c7c6d5c$var$lc.onCommitFiberRoot($cfc2e5a80c7c6d5c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $cfc2e5a80c7c6d5c$var$oc = Math.clz32 ? Math.clz32 : $cfc2e5a80c7c6d5c$var$nc, $cfc2e5a80c7c6d5c$var$pc = Math.log, $cfc2e5a80c7c6d5c$var$qc = Math.LN2;
function $cfc2e5a80c7c6d5c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($cfc2e5a80c7c6d5c$var$pc(a) / $cfc2e5a80c7c6d5c$var$qc | 0) | 0;
}
var $cfc2e5a80c7c6d5c$var$rc = 64, $cfc2e5a80c7c6d5c$var$sc = 4194304;
function $cfc2e5a80c7c6d5c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $cfc2e5a80c7c6d5c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $cfc2e5a80c7c6d5c$var$tc(h) : (f &= g, 0 !== f && (d = $cfc2e5a80c7c6d5c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $cfc2e5a80c7c6d5c$var$tc(g) : 0 !== f && (d = $cfc2e5a80c7c6d5c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $cfc2e5a80c7c6d5c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $cfc2e5a80c7c6d5c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $cfc2e5a80c7c6d5c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $cfc2e5a80c7c6d5c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $cfc2e5a80c7c6d5c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $cfc2e5a80c7c6d5c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $cfc2e5a80c7c6d5c$var$yc() {
    var a = $cfc2e5a80c7c6d5c$var$rc;
    $cfc2e5a80c7c6d5c$var$rc <<= 1;
    0 === ($cfc2e5a80c7c6d5c$var$rc & 4194240) && ($cfc2e5a80c7c6d5c$var$rc = 64);
    return a;
}
function $cfc2e5a80c7c6d5c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $cfc2e5a80c7c6d5c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $cfc2e5a80c7c6d5c$var$oc(b);
    a[b] = c;
}
function $cfc2e5a80c7c6d5c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $cfc2e5a80c7c6d5c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $cfc2e5a80c7c6d5c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $cfc2e5a80c7c6d5c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $cfc2e5a80c7c6d5c$var$C = 0;
function $cfc2e5a80c7c6d5c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $cfc2e5a80c7c6d5c$var$Ec, $cfc2e5a80c7c6d5c$var$Fc, $cfc2e5a80c7c6d5c$var$Gc, $cfc2e5a80c7c6d5c$var$Hc, $cfc2e5a80c7c6d5c$var$Ic, $cfc2e5a80c7c6d5c$var$Jc = !1, $cfc2e5a80c7c6d5c$var$Kc = [], $cfc2e5a80c7c6d5c$var$Lc = null, $cfc2e5a80c7c6d5c$var$Mc = null, $cfc2e5a80c7c6d5c$var$Nc = null, $cfc2e5a80c7c6d5c$var$Oc = new Map, $cfc2e5a80c7c6d5c$var$Pc = new Map, $cfc2e5a80c7c6d5c$var$Qc = [], $cfc2e5a80c7c6d5c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $cfc2e5a80c7c6d5c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $cfc2e5a80c7c6d5c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $cfc2e5a80c7c6d5c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $cfc2e5a80c7c6d5c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $cfc2e5a80c7c6d5c$var$Oc["delete"](b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $cfc2e5a80c7c6d5c$var$Pc["delete"](b.pointerId);
    }
}
function $cfc2e5a80c7c6d5c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $cfc2e5a80c7c6d5c$var$Cb(b), null !== b && $cfc2e5a80c7c6d5c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $cfc2e5a80c7c6d5c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $cfc2e5a80c7c6d5c$var$Lc = $cfc2e5a80c7c6d5c$var$Tc($cfc2e5a80c7c6d5c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $cfc2e5a80c7c6d5c$var$Mc = $cfc2e5a80c7c6d5c$var$Tc($cfc2e5a80c7c6d5c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $cfc2e5a80c7c6d5c$var$Nc = $cfc2e5a80c7c6d5c$var$Tc($cfc2e5a80c7c6d5c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $cfc2e5a80c7c6d5c$var$Oc.set(f, $cfc2e5a80c7c6d5c$var$Tc($cfc2e5a80c7c6d5c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $cfc2e5a80c7c6d5c$var$Pc.set(f, $cfc2e5a80c7c6d5c$var$Tc($cfc2e5a80c7c6d5c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $cfc2e5a80c7c6d5c$var$Vc(a) {
    var b = $cfc2e5a80c7c6d5c$var$Wc(a.target);
    if (null !== b) {
        var c = $cfc2e5a80c7c6d5c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $cfc2e5a80c7c6d5c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $cfc2e5a80c7c6d5c$var$Ic(a.priority, function() {
                        $cfc2e5a80c7c6d5c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $cfc2e5a80c7c6d5c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $cfc2e5a80c7c6d5c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $cfc2e5a80c7c6d5c$var$wb = d;
            c.target.dispatchEvent(d);
            $cfc2e5a80c7c6d5c$var$wb = null;
        } else return b = $cfc2e5a80c7c6d5c$var$Cb(c), null !== b && $cfc2e5a80c7c6d5c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $cfc2e5a80c7c6d5c$var$Zc(a, b, c) {
    $cfc2e5a80c7c6d5c$var$Xc(a) && c["delete"](b);
}
function $cfc2e5a80c7c6d5c$var$$c() {
    $cfc2e5a80c7c6d5c$var$Jc = !1;
    null !== $cfc2e5a80c7c6d5c$var$Lc && $cfc2e5a80c7c6d5c$var$Xc($cfc2e5a80c7c6d5c$var$Lc) && ($cfc2e5a80c7c6d5c$var$Lc = null);
    null !== $cfc2e5a80c7c6d5c$var$Mc && $cfc2e5a80c7c6d5c$var$Xc($cfc2e5a80c7c6d5c$var$Mc) && ($cfc2e5a80c7c6d5c$var$Mc = null);
    null !== $cfc2e5a80c7c6d5c$var$Nc && $cfc2e5a80c7c6d5c$var$Xc($cfc2e5a80c7c6d5c$var$Nc) && ($cfc2e5a80c7c6d5c$var$Nc = null);
    $cfc2e5a80c7c6d5c$var$Oc.forEach($cfc2e5a80c7c6d5c$var$Zc);
    $cfc2e5a80c7c6d5c$var$Pc.forEach($cfc2e5a80c7c6d5c$var$Zc);
}
function $cfc2e5a80c7c6d5c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $cfc2e5a80c7c6d5c$var$Jc || ($cfc2e5a80c7c6d5c$var$Jc = !0, $hIoV8.unstable_scheduleCallback($hIoV8.unstable_NormalPriority, $cfc2e5a80c7c6d5c$var$$c)));
}
function $cfc2e5a80c7c6d5c$var$bd(a) {
    function b(b) {
        return $cfc2e5a80c7c6d5c$var$ad(b, a);
    }
    if (0 < $cfc2e5a80c7c6d5c$var$Kc.length) {
        $cfc2e5a80c7c6d5c$var$ad($cfc2e5a80c7c6d5c$var$Kc[0], a);
        for(var c = 1; c < $cfc2e5a80c7c6d5c$var$Kc.length; c++){
            var d = $cfc2e5a80c7c6d5c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $cfc2e5a80c7c6d5c$var$Lc && $cfc2e5a80c7c6d5c$var$ad($cfc2e5a80c7c6d5c$var$Lc, a);
    null !== $cfc2e5a80c7c6d5c$var$Mc && $cfc2e5a80c7c6d5c$var$ad($cfc2e5a80c7c6d5c$var$Mc, a);
    null !== $cfc2e5a80c7c6d5c$var$Nc && $cfc2e5a80c7c6d5c$var$ad($cfc2e5a80c7c6d5c$var$Nc, a);
    $cfc2e5a80c7c6d5c$var$Oc.forEach(b);
    $cfc2e5a80c7c6d5c$var$Pc.forEach(b);
    for(c = 0; c < $cfc2e5a80c7c6d5c$var$Qc.length; c++)d = $cfc2e5a80c7c6d5c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $cfc2e5a80c7c6d5c$var$Qc.length && (c = $cfc2e5a80c7c6d5c$var$Qc[0], null === c.blockedOn);)$cfc2e5a80c7c6d5c$var$Vc(c), null === c.blockedOn && $cfc2e5a80c7c6d5c$var$Qc.shift();
}
var $cfc2e5a80c7c6d5c$var$cd = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentBatchConfig, $cfc2e5a80c7c6d5c$var$dd = !0;
function $cfc2e5a80c7c6d5c$var$ed(a, b, c, d) {
    var e = $cfc2e5a80c7c6d5c$var$C, f = $cfc2e5a80c7c6d5c$var$cd.transition;
    $cfc2e5a80c7c6d5c$var$cd.transition = null;
    try {
        $cfc2e5a80c7c6d5c$var$C = 1, $cfc2e5a80c7c6d5c$var$fd(a, b, c, d);
    } finally{
        $cfc2e5a80c7c6d5c$var$C = e, $cfc2e5a80c7c6d5c$var$cd.transition = f;
    }
}
function $cfc2e5a80c7c6d5c$var$gd(a, b, c, d) {
    var e = $cfc2e5a80c7c6d5c$var$C, f = $cfc2e5a80c7c6d5c$var$cd.transition;
    $cfc2e5a80c7c6d5c$var$cd.transition = null;
    try {
        $cfc2e5a80c7c6d5c$var$C = 4, $cfc2e5a80c7c6d5c$var$fd(a, b, c, d);
    } finally{
        $cfc2e5a80c7c6d5c$var$C = e, $cfc2e5a80c7c6d5c$var$cd.transition = f;
    }
}
function $cfc2e5a80c7c6d5c$var$fd(a, b, c, d) {
    if ($cfc2e5a80c7c6d5c$var$dd) {
        var e = $cfc2e5a80c7c6d5c$var$Yc(a, b, c, d);
        if (null === e) $cfc2e5a80c7c6d5c$var$hd(a, b, d, $cfc2e5a80c7c6d5c$var$id, c), $cfc2e5a80c7c6d5c$var$Sc(a, d);
        else if ($cfc2e5a80c7c6d5c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($cfc2e5a80c7c6d5c$var$Sc(a, d), b & 4 && -1 < $cfc2e5a80c7c6d5c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $cfc2e5a80c7c6d5c$var$Cb(e);
                null !== f && $cfc2e5a80c7c6d5c$var$Ec(f);
                f = $cfc2e5a80c7c6d5c$var$Yc(a, b, c, d);
                null === f && $cfc2e5a80c7c6d5c$var$hd(a, b, d, $cfc2e5a80c7c6d5c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $cfc2e5a80c7c6d5c$var$hd(a, b, d, null, c);
    }
}
var $cfc2e5a80c7c6d5c$var$id = null;
function $cfc2e5a80c7c6d5c$var$Yc(a, b, c, d) {
    $cfc2e5a80c7c6d5c$var$id = null;
    a = $cfc2e5a80c7c6d5c$var$xb(d);
    a = $cfc2e5a80c7c6d5c$var$Wc(a);
    if (null !== a) {
        if (b = $cfc2e5a80c7c6d5c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $cfc2e5a80c7c6d5c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $cfc2e5a80c7c6d5c$var$id = a;
    return null;
}
function $cfc2e5a80c7c6d5c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($cfc2e5a80c7c6d5c$var$ec()){
                case $cfc2e5a80c7c6d5c$var$fc:
                    return 1;
                case $cfc2e5a80c7c6d5c$var$gc:
                    return 4;
                case $cfc2e5a80c7c6d5c$var$hc:
                case $cfc2e5a80c7c6d5c$var$ic:
                    return 16;
                case $cfc2e5a80c7c6d5c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $cfc2e5a80c7c6d5c$var$kd = null, $cfc2e5a80c7c6d5c$var$ld = null, $cfc2e5a80c7c6d5c$var$md = null;
function $cfc2e5a80c7c6d5c$var$nd() {
    if ($cfc2e5a80c7c6d5c$var$md) return $cfc2e5a80c7c6d5c$var$md;
    var a, b = $cfc2e5a80c7c6d5c$var$ld, c = b.length, d, e = "value" in $cfc2e5a80c7c6d5c$var$kd ? $cfc2e5a80c7c6d5c$var$kd.value : $cfc2e5a80c7c6d5c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $cfc2e5a80c7c6d5c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $cfc2e5a80c7c6d5c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $cfc2e5a80c7c6d5c$var$pd() {
    return !0;
}
function $cfc2e5a80c7c6d5c$var$qd() {
    return !1;
}
function $cfc2e5a80c7c6d5c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $cfc2e5a80c7c6d5c$var$pd : $cfc2e5a80c7c6d5c$var$qd;
        this.isPropagationStopped = $cfc2e5a80c7c6d5c$var$qd;
        return this;
    }
    $cfc2e5a80c7c6d5c$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $k4vcf._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $cfc2e5a80c7c6d5c$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $k4vcf._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $cfc2e5a80c7c6d5c$var$pd);
        },
        persist: function persist() {},
        isPersistent: $cfc2e5a80c7c6d5c$var$pd
    });
    return b;
}
var $cfc2e5a80c7c6d5c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $cfc2e5a80c7c6d5c$var$td = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$sd), $cfc2e5a80c7c6d5c$var$ud = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$sd, {
    view: 0,
    detail: 0
}), $cfc2e5a80c7c6d5c$var$vd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$ud), $cfc2e5a80c7c6d5c$var$wd, $cfc2e5a80c7c6d5c$var$xd, $cfc2e5a80c7c6d5c$var$yd, $cfc2e5a80c7c6d5c$var$Ad = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $cfc2e5a80c7c6d5c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $cfc2e5a80c7c6d5c$var$yd && ($cfc2e5a80c7c6d5c$var$yd && "mousemove" === a.type ? ($cfc2e5a80c7c6d5c$var$wd = a.screenX - $cfc2e5a80c7c6d5c$var$yd.screenX, $cfc2e5a80c7c6d5c$var$xd = a.screenY - $cfc2e5a80c7c6d5c$var$yd.screenY) : $cfc2e5a80c7c6d5c$var$xd = $cfc2e5a80c7c6d5c$var$wd = 0, $cfc2e5a80c7c6d5c$var$yd = a);
        return $cfc2e5a80c7c6d5c$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $cfc2e5a80c7c6d5c$var$xd;
    }
}), $cfc2e5a80c7c6d5c$var$Bd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Ad), $cfc2e5a80c7c6d5c$var$Cd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$Ad, {
    dataTransfer: 0
}), $cfc2e5a80c7c6d5c$var$Dd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Cd), $cfc2e5a80c7c6d5c$var$Ed = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$ud, {
    relatedTarget: 0
}), $cfc2e5a80c7c6d5c$var$Fd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Ed), $cfc2e5a80c7c6d5c$var$Gd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cfc2e5a80c7c6d5c$var$Hd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Gd), $cfc2e5a80c7c6d5c$var$Id = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $cfc2e5a80c7c6d5c$var$Jd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Id), $cfc2e5a80c7c6d5c$var$Kd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$sd, {
    data: 0
}), $cfc2e5a80c7c6d5c$var$Ld = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Kd), $cfc2e5a80c7c6d5c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $cfc2e5a80c7c6d5c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $cfc2e5a80c7c6d5c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $cfc2e5a80c7c6d5c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $cfc2e5a80c7c6d5c$var$Od[a]) ? !!b[a] : !1;
}
function $cfc2e5a80c7c6d5c$var$zd() {
    return $cfc2e5a80c7c6d5c$var$Pd;
}
var $cfc2e5a80c7c6d5c$var$Qd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $cfc2e5a80c7c6d5c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $cfc2e5a80c7c6d5c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $cfc2e5a80c7c6d5c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $cfc2e5a80c7c6d5c$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $cfc2e5a80c7c6d5c$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $cfc2e5a80c7c6d5c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $cfc2e5a80c7c6d5c$var$Rd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Qd), $cfc2e5a80c7c6d5c$var$Sd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $cfc2e5a80c7c6d5c$var$Td = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Sd), $cfc2e5a80c7c6d5c$var$Ud = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $cfc2e5a80c7c6d5c$var$zd
}), $cfc2e5a80c7c6d5c$var$Vd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Ud), $cfc2e5a80c7c6d5c$var$Wd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cfc2e5a80c7c6d5c$var$Xd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Wd), $cfc2e5a80c7c6d5c$var$Yd = $cfc2e5a80c7c6d5c$var$A({}, $cfc2e5a80c7c6d5c$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $cfc2e5a80c7c6d5c$var$Zd = $cfc2e5a80c7c6d5c$var$rd($cfc2e5a80c7c6d5c$var$Yd), $cfc2e5a80c7c6d5c$var$$d = [
    9,
    13,
    27,
    32
], $cfc2e5a80c7c6d5c$var$ae = $cfc2e5a80c7c6d5c$var$ia && "CompositionEvent" in window, $cfc2e5a80c7c6d5c$var$be = null;
$cfc2e5a80c7c6d5c$var$ia && "documentMode" in document && ($cfc2e5a80c7c6d5c$var$be = document.documentMode);
var $cfc2e5a80c7c6d5c$var$ce = $cfc2e5a80c7c6d5c$var$ia && "TextEvent" in window && !$cfc2e5a80c7c6d5c$var$be, $cfc2e5a80c7c6d5c$var$de = $cfc2e5a80c7c6d5c$var$ia && (!$cfc2e5a80c7c6d5c$var$ae || $cfc2e5a80c7c6d5c$var$be && 8 < $cfc2e5a80c7c6d5c$var$be && 11 >= $cfc2e5a80c7c6d5c$var$be), $cfc2e5a80c7c6d5c$var$ee = String.fromCharCode(32), $cfc2e5a80c7c6d5c$var$fe = !1;
function $cfc2e5a80c7c6d5c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $cfc2e5a80c7c6d5c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $cfc2e5a80c7c6d5c$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)) && "data" in a ? a.data : null;
}
var $cfc2e5a80c7c6d5c$var$ie = !1;
function $cfc2e5a80c7c6d5c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $cfc2e5a80c7c6d5c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $cfc2e5a80c7c6d5c$var$fe = !0;
            return $cfc2e5a80c7c6d5c$var$ee;
        case "textInput":
            return a = b.data, a === $cfc2e5a80c7c6d5c$var$ee && $cfc2e5a80c7c6d5c$var$fe ? null : a;
        default:
            return null;
    }
}
function $cfc2e5a80c7c6d5c$var$ke(a, b) {
    if ($cfc2e5a80c7c6d5c$var$ie) return "compositionend" === a || !$cfc2e5a80c7c6d5c$var$ae && $cfc2e5a80c7c6d5c$var$ge(a, b) ? (a = $cfc2e5a80c7c6d5c$var$nd(), $cfc2e5a80c7c6d5c$var$md = $cfc2e5a80c7c6d5c$var$ld = $cfc2e5a80c7c6d5c$var$kd = null, $cfc2e5a80c7c6d5c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b["char"] && 1 < b["char"].length) return b["char"];
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $cfc2e5a80c7c6d5c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $cfc2e5a80c7c6d5c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $cfc2e5a80c7c6d5c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$cfc2e5a80c7c6d5c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $cfc2e5a80c7c6d5c$var$ne(a, b, c, d) {
    $cfc2e5a80c7c6d5c$var$Eb(d);
    b = $cfc2e5a80c7c6d5c$var$oe(b, "onChange");
    0 < b.length && (c = new $cfc2e5a80c7c6d5c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $cfc2e5a80c7c6d5c$var$pe = null, $cfc2e5a80c7c6d5c$var$qe = null;
function $cfc2e5a80c7c6d5c$var$re(a) {
    $cfc2e5a80c7c6d5c$var$se(a, 0);
}
function $cfc2e5a80c7c6d5c$var$te(a) {
    var b = $cfc2e5a80c7c6d5c$var$ue(a);
    if ($cfc2e5a80c7c6d5c$var$Wa(b)) return a;
}
function $cfc2e5a80c7c6d5c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $cfc2e5a80c7c6d5c$var$we = !1;
if ($cfc2e5a80c7c6d5c$var$ia) {
    var $cfc2e5a80c7c6d5c$var$xe;
    if ($cfc2e5a80c7c6d5c$var$ia) {
        var $cfc2e5a80c7c6d5c$var$ye = "oninput" in document;
        if (!$cfc2e5a80c7c6d5c$var$ye) {
            var $cfc2e5a80c7c6d5c$var$ze = document.createElement("div");
            $cfc2e5a80c7c6d5c$var$ze.setAttribute("oninput", "return;");
            $cfc2e5a80c7c6d5c$var$ye = "function" === typeof $cfc2e5a80c7c6d5c$var$ze.oninput;
        }
        $cfc2e5a80c7c6d5c$var$xe = $cfc2e5a80c7c6d5c$var$ye;
    } else $cfc2e5a80c7c6d5c$var$xe = !1;
    $cfc2e5a80c7c6d5c$var$we = $cfc2e5a80c7c6d5c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $cfc2e5a80c7c6d5c$var$Ae() {
    $cfc2e5a80c7c6d5c$var$pe && ($cfc2e5a80c7c6d5c$var$pe.detachEvent("onpropertychange", $cfc2e5a80c7c6d5c$var$Be), $cfc2e5a80c7c6d5c$var$qe = $cfc2e5a80c7c6d5c$var$pe = null);
}
function $cfc2e5a80c7c6d5c$var$Be(a) {
    if ("value" === a.propertyName && $cfc2e5a80c7c6d5c$var$te($cfc2e5a80c7c6d5c$var$qe)) {
        var b = [];
        $cfc2e5a80c7c6d5c$var$ne(b, $cfc2e5a80c7c6d5c$var$qe, a, $cfc2e5a80c7c6d5c$var$xb(a));
        $cfc2e5a80c7c6d5c$var$Jb($cfc2e5a80c7c6d5c$var$re, b);
    }
}
function $cfc2e5a80c7c6d5c$var$Ce(a, b, c) {
    "focusin" === a ? ($cfc2e5a80c7c6d5c$var$Ae(), $cfc2e5a80c7c6d5c$var$pe = b, $cfc2e5a80c7c6d5c$var$qe = c, $cfc2e5a80c7c6d5c$var$pe.attachEvent("onpropertychange", $cfc2e5a80c7c6d5c$var$Be)) : "focusout" === a && $cfc2e5a80c7c6d5c$var$Ae();
}
function $cfc2e5a80c7c6d5c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $cfc2e5a80c7c6d5c$var$te($cfc2e5a80c7c6d5c$var$qe);
}
function $cfc2e5a80c7c6d5c$var$Ee(a, b) {
    if ("click" === a) return $cfc2e5a80c7c6d5c$var$te(b);
}
function $cfc2e5a80c7c6d5c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $cfc2e5a80c7c6d5c$var$te(b);
}
function $cfc2e5a80c7c6d5c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $cfc2e5a80c7c6d5c$var$He = "function" === typeof Object.is ? Object.is : $cfc2e5a80c7c6d5c$var$Ge;
function $cfc2e5a80c7c6d5c$var$Ie(a, b) {
    if ($cfc2e5a80c7c6d5c$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $k4vcf._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$cfc2e5a80c7c6d5c$var$ja.call(b, e) || !$cfc2e5a80c7c6d5c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $cfc2e5a80c7c6d5c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $cfc2e5a80c7c6d5c$var$Ke(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $cfc2e5a80c7c6d5c$var$Je(c);
    }
}
function $cfc2e5a80c7c6d5c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $cfc2e5a80c7c6d5c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $cfc2e5a80c7c6d5c$var$Me() {
    for(var a = window, b = $cfc2e5a80c7c6d5c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $cfc2e5a80c7c6d5c$var$Xa(a.document);
    }
    return b;
}
function $cfc2e5a80c7c6d5c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $cfc2e5a80c7c6d5c$var$Oe(a) {
    var b = $cfc2e5a80c7c6d5c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $cfc2e5a80c7c6d5c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $cfc2e5a80c7c6d5c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $cfc2e5a80c7c6d5c$var$Ke(c, f);
                var g = $cfc2e5a80c7c6d5c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $cfc2e5a80c7c6d5c$var$Pe = $cfc2e5a80c7c6d5c$var$ia && "documentMode" in document && 11 >= document.documentMode, $cfc2e5a80c7c6d5c$var$Qe = null, $cfc2e5a80c7c6d5c$var$Re = null, $cfc2e5a80c7c6d5c$var$Se = null, $cfc2e5a80c7c6d5c$var$Te = !1;
function $cfc2e5a80c7c6d5c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $cfc2e5a80c7c6d5c$var$Te || null == $cfc2e5a80c7c6d5c$var$Qe || $cfc2e5a80c7c6d5c$var$Qe !== $cfc2e5a80c7c6d5c$var$Xa(d) || (d = $cfc2e5a80c7c6d5c$var$Qe, "selectionStart" in d && $cfc2e5a80c7c6d5c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $cfc2e5a80c7c6d5c$var$Se && $cfc2e5a80c7c6d5c$var$Ie($cfc2e5a80c7c6d5c$var$Se, d) || ($cfc2e5a80c7c6d5c$var$Se = d, d = $cfc2e5a80c7c6d5c$var$oe($cfc2e5a80c7c6d5c$var$Re, "onSelect"), 0 < d.length && (b = new $cfc2e5a80c7c6d5c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $cfc2e5a80c7c6d5c$var$Qe)));
}
function $cfc2e5a80c7c6d5c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $cfc2e5a80c7c6d5c$var$We = {
    animationend: $cfc2e5a80c7c6d5c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $cfc2e5a80c7c6d5c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $cfc2e5a80c7c6d5c$var$Ve("Animation", "AnimationStart"),
    transitionend: $cfc2e5a80c7c6d5c$var$Ve("Transition", "TransitionEnd")
}, $cfc2e5a80c7c6d5c$var$Xe = {}, $cfc2e5a80c7c6d5c$var$Ye = {};
$cfc2e5a80c7c6d5c$var$ia && ($cfc2e5a80c7c6d5c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $cfc2e5a80c7c6d5c$var$We.animationend.animation, delete $cfc2e5a80c7c6d5c$var$We.animationiteration.animation, delete $cfc2e5a80c7c6d5c$var$We.animationstart.animation), "TransitionEvent" in window || delete $cfc2e5a80c7c6d5c$var$We.transitionend.transition);
function $cfc2e5a80c7c6d5c$var$Ze(a) {
    if ($cfc2e5a80c7c6d5c$var$Xe[a]) return $cfc2e5a80c7c6d5c$var$Xe[a];
    if (!$cfc2e5a80c7c6d5c$var$We[a]) return a;
    var b = $cfc2e5a80c7c6d5c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $cfc2e5a80c7c6d5c$var$Ye) return $cfc2e5a80c7c6d5c$var$Xe[a] = b[c];
    return a;
}
var $cfc2e5a80c7c6d5c$var$$e = $cfc2e5a80c7c6d5c$var$Ze("animationend"), $cfc2e5a80c7c6d5c$var$af = $cfc2e5a80c7c6d5c$var$Ze("animationiteration"), $cfc2e5a80c7c6d5c$var$bf = $cfc2e5a80c7c6d5c$var$Ze("animationstart"), $cfc2e5a80c7c6d5c$var$cf = $cfc2e5a80c7c6d5c$var$Ze("transitionend"), $cfc2e5a80c7c6d5c$var$df = new Map, $cfc2e5a80c7c6d5c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $cfc2e5a80c7c6d5c$var$ff(a, b) {
    $cfc2e5a80c7c6d5c$var$df.set(a, b);
    $cfc2e5a80c7c6d5c$var$fa(b, [
        a
    ]);
}
for(var $cfc2e5a80c7c6d5c$var$gf = 0; $cfc2e5a80c7c6d5c$var$gf < $cfc2e5a80c7c6d5c$var$ef.length; $cfc2e5a80c7c6d5c$var$gf++){
    var $cfc2e5a80c7c6d5c$var$hf = $cfc2e5a80c7c6d5c$var$ef[$cfc2e5a80c7c6d5c$var$gf], $cfc2e5a80c7c6d5c$var$jf = $cfc2e5a80c7c6d5c$var$hf.toLowerCase(), $cfc2e5a80c7c6d5c$var$kf = $cfc2e5a80c7c6d5c$var$hf[0].toUpperCase() + $cfc2e5a80c7c6d5c$var$hf.slice(1);
    $cfc2e5a80c7c6d5c$var$ff($cfc2e5a80c7c6d5c$var$jf, "on" + $cfc2e5a80c7c6d5c$var$kf);
}
$cfc2e5a80c7c6d5c$var$ff($cfc2e5a80c7c6d5c$var$$e, "onAnimationEnd");
$cfc2e5a80c7c6d5c$var$ff($cfc2e5a80c7c6d5c$var$af, "onAnimationIteration");
$cfc2e5a80c7c6d5c$var$ff($cfc2e5a80c7c6d5c$var$bf, "onAnimationStart");
$cfc2e5a80c7c6d5c$var$ff("dblclick", "onDoubleClick");
$cfc2e5a80c7c6d5c$var$ff("focusin", "onFocus");
$cfc2e5a80c7c6d5c$var$ff("focusout", "onBlur");
$cfc2e5a80c7c6d5c$var$ff($cfc2e5a80c7c6d5c$var$cf, "onTransitionEnd");
$cfc2e5a80c7c6d5c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$cfc2e5a80c7c6d5c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$cfc2e5a80c7c6d5c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$cfc2e5a80c7c6d5c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$cfc2e5a80c7c6d5c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$cfc2e5a80c7c6d5c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$cfc2e5a80c7c6d5c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$cfc2e5a80c7c6d5c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$cfc2e5a80c7c6d5c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$cfc2e5a80c7c6d5c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $cfc2e5a80c7c6d5c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $cfc2e5a80c7c6d5c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($cfc2e5a80c7c6d5c$var$lf));
function $cfc2e5a80c7c6d5c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $cfc2e5a80c7c6d5c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $cfc2e5a80c7c6d5c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $cfc2e5a80c7c6d5c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $cfc2e5a80c7c6d5c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($cfc2e5a80c7c6d5c$var$Qb) throw a = $cfc2e5a80c7c6d5c$var$Rb, $cfc2e5a80c7c6d5c$var$Qb = !1, $cfc2e5a80c7c6d5c$var$Rb = null, a;
}
function $cfc2e5a80c7c6d5c$var$D(a, b) {
    var c = b[$cfc2e5a80c7c6d5c$var$of];
    void 0 === c && (c = b[$cfc2e5a80c7c6d5c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($cfc2e5a80c7c6d5c$var$pf(b, a, 2, !1), c.add(d));
}
function $cfc2e5a80c7c6d5c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $cfc2e5a80c7c6d5c$var$pf(c, a, d, b);
}
var $cfc2e5a80c7c6d5c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $cfc2e5a80c7c6d5c$var$sf(a) {
    if (!a[$cfc2e5a80c7c6d5c$var$rf]) {
        a[$cfc2e5a80c7c6d5c$var$rf] = !0;
        $cfc2e5a80c7c6d5c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($cfc2e5a80c7c6d5c$var$mf.has(b) || $cfc2e5a80c7c6d5c$var$qf(b, !1, a), $cfc2e5a80c7c6d5c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$cfc2e5a80c7c6d5c$var$rf] || (b[$cfc2e5a80c7c6d5c$var$rf] = !0, $cfc2e5a80c7c6d5c$var$qf("selectionchange", !1, b));
    }
}
function $cfc2e5a80c7c6d5c$var$pf(a, b, c, d) {
    switch($cfc2e5a80c7c6d5c$var$jd(b)){
        case 1:
            var e = $cfc2e5a80c7c6d5c$var$ed;
            break;
        case 4:
            e = $cfc2e5a80c7c6d5c$var$gd;
            break;
        default:
            e = $cfc2e5a80c7c6d5c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$cfc2e5a80c7c6d5c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $cfc2e5a80c7c6d5c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d["return"]; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g["return"];
            }
            for(; null !== h;){
                g = $cfc2e5a80c7c6d5c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d["return"];
    }
    $cfc2e5a80c7c6d5c$var$Jb(function() {
        var _$d = f, _$e = $cfc2e5a80c7c6d5c$var$xb(c), g = [];
        a: {
            var h = $cfc2e5a80c7c6d5c$var$df.get(a);
            if (void 0 !== h) {
                var k = $cfc2e5a80c7c6d5c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $cfc2e5a80c7c6d5c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $cfc2e5a80c7c6d5c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $cfc2e5a80c7c6d5c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $cfc2e5a80c7c6d5c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $cfc2e5a80c7c6d5c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $cfc2e5a80c7c6d5c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $cfc2e5a80c7c6d5c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $cfc2e5a80c7c6d5c$var$Vd;
                        break;
                    case $cfc2e5a80c7c6d5c$var$$e:
                    case $cfc2e5a80c7c6d5c$var$af:
                    case $cfc2e5a80c7c6d5c$var$bf:
                        k = $cfc2e5a80c7c6d5c$var$Hd;
                        break;
                    case $cfc2e5a80c7c6d5c$var$cf:
                        k = $cfc2e5a80c7c6d5c$var$Xd;
                        break;
                    case "scroll":
                        k = $cfc2e5a80c7c6d5c$var$vd;
                        break;
                    case "wheel":
                        k = $cfc2e5a80c7c6d5c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $cfc2e5a80c7c6d5c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $cfc2e5a80c7c6d5c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $cfc2e5a80c7c6d5c$var$Kb(w, x), null != F && t.push($cfc2e5a80c7c6d5c$var$tf(w, F, u))));
                    if (J) break;
                    w = w["return"];
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $cfc2e5a80c7c6d5c$var$wb && (n = c.relatedTarget || c.fromElement) && ($cfc2e5a80c7c6d5c$var$Wc(n) || n[$cfc2e5a80c7c6d5c$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $cfc2e5a80c7c6d5c$var$Wc(n) : null, null !== n && (J = $cfc2e5a80c7c6d5c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $cfc2e5a80c7c6d5c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $cfc2e5a80c7c6d5c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $cfc2e5a80c7c6d5c$var$ue(k);
                        u = null == n ? h : $cfc2e5a80c7c6d5c$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $cfc2e5a80c7c6d5c$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $cfc2e5a80c7c6d5c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $cfc2e5a80c7c6d5c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $cfc2e5a80c7c6d5c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $cfc2e5a80c7c6d5c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $cfc2e5a80c7c6d5c$var$vf(t);
                                x = $cfc2e5a80c7c6d5c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $cfc2e5a80c7c6d5c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $cfc2e5a80c7c6d5c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $cfc2e5a80c7c6d5c$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $cfc2e5a80c7c6d5c$var$ve;
                else if ($cfc2e5a80c7c6d5c$var$me(h)) {
                    if ($cfc2e5a80c7c6d5c$var$we) na = $cfc2e5a80c7c6d5c$var$Fe;
                    else {
                        na = $cfc2e5a80c7c6d5c$var$De;
                        var xa = $cfc2e5a80c7c6d5c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $cfc2e5a80c7c6d5c$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $cfc2e5a80c7c6d5c$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $cfc2e5a80c7c6d5c$var$cb(h, "number", h.value);
            }
            xa = _$d ? $cfc2e5a80c7c6d5c$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($cfc2e5a80c7c6d5c$var$me(xa) || "true" === xa.contentEditable) $cfc2e5a80c7c6d5c$var$Qe = xa, $cfc2e5a80c7c6d5c$var$Re = _$d, $cfc2e5a80c7c6d5c$var$Se = null;
                    break;
                case "focusout":
                    $cfc2e5a80c7c6d5c$var$Se = $cfc2e5a80c7c6d5c$var$Re = $cfc2e5a80c7c6d5c$var$Qe = null;
                    break;
                case "mousedown":
                    $cfc2e5a80c7c6d5c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $cfc2e5a80c7c6d5c$var$Te = !1;
                    $cfc2e5a80c7c6d5c$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($cfc2e5a80c7c6d5c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $cfc2e5a80c7c6d5c$var$Ue(g, c, _$e);
            }
            var $a;
            if ($cfc2e5a80c7c6d5c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $cfc2e5a80c7c6d5c$var$ie ? $cfc2e5a80c7c6d5c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($cfc2e5a80c7c6d5c$var$de && "ko" !== c.locale && ($cfc2e5a80c7c6d5c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $cfc2e5a80c7c6d5c$var$ie && ($a = $cfc2e5a80c7c6d5c$var$nd()) : ($cfc2e5a80c7c6d5c$var$kd = _$e, $cfc2e5a80c7c6d5c$var$ld = "value" in $cfc2e5a80c7c6d5c$var$kd ? $cfc2e5a80c7c6d5c$var$kd.value : $cfc2e5a80c7c6d5c$var$kd.textContent, $cfc2e5a80c7c6d5c$var$ie = !0)), xa = $cfc2e5a80c7c6d5c$var$oe(_$d, ba), 0 < xa.length && (ba = new $cfc2e5a80c7c6d5c$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $cfc2e5a80c7c6d5c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $cfc2e5a80c7c6d5c$var$ce ? $cfc2e5a80c7c6d5c$var$je(a, c) : $cfc2e5a80c7c6d5c$var$ke(a, c)) _$d = $cfc2e5a80c7c6d5c$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $cfc2e5a80c7c6d5c$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $cfc2e5a80c7c6d5c$var$se(g, b);
    });
}
function $cfc2e5a80c7c6d5c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $cfc2e5a80c7c6d5c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $cfc2e5a80c7c6d5c$var$Kb(a, c), null != f && d.unshift($cfc2e5a80c7c6d5c$var$tf(a, f, e)), f = $cfc2e5a80c7c6d5c$var$Kb(a, b), null != f && d.push($cfc2e5a80c7c6d5c$var$tf(a, f, e)));
        a = a["return"];
    }
    return d;
}
function $cfc2e5a80c7c6d5c$var$vf(a) {
    if (null === a) return null;
    do a = a["return"];
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $cfc2e5a80c7c6d5c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $cfc2e5a80c7c6d5c$var$Kb(c, f), null != k && g.unshift($cfc2e5a80c7c6d5c$var$tf(c, k, h))) : e || (k = $cfc2e5a80c7c6d5c$var$Kb(c, f), null != k && g.push($cfc2e5a80c7c6d5c$var$tf(c, k, h))));
        c = c["return"];
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $cfc2e5a80c7c6d5c$var$xf = /\r\n?/g, $cfc2e5a80c7c6d5c$var$yf = /\u0000|\uFFFD/g;
function $cfc2e5a80c7c6d5c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($cfc2e5a80c7c6d5c$var$xf, "\n").replace($cfc2e5a80c7c6d5c$var$yf, "");
}
function $cfc2e5a80c7c6d5c$var$Af(a, b, c) {
    b = $cfc2e5a80c7c6d5c$var$zf(b);
    if ($cfc2e5a80c7c6d5c$var$zf(a) !== b && c) throw Error($cfc2e5a80c7c6d5c$var$p(425));
}
function $cfc2e5a80c7c6d5c$var$Bf() {}
var $cfc2e5a80c7c6d5c$var$Cf = null, $cfc2e5a80c7c6d5c$var$Df = null;
function $cfc2e5a80c7c6d5c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $k4vcf._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $cfc2e5a80c7c6d5c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $cfc2e5a80c7c6d5c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $cfc2e5a80c7c6d5c$var$Hf = "function" === typeof Promise ? Promise : void 0, $cfc2e5a80c7c6d5c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $cfc2e5a80c7c6d5c$var$Hf ? function Jf(a) {
    return $cfc2e5a80c7c6d5c$var$Hf.resolve(null).then(a)["catch"]($cfc2e5a80c7c6d5c$var$If);
} : $cfc2e5a80c7c6d5c$var$Ff;
function $cfc2e5a80c7c6d5c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $cfc2e5a80c7c6d5c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $cfc2e5a80c7c6d5c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $cfc2e5a80c7c6d5c$var$bd(b);
}
function $cfc2e5a80c7c6d5c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $cfc2e5a80c7c6d5c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $cfc2e5a80c7c6d5c$var$Nf = Math.random().toString(36).slice(2), $cfc2e5a80c7c6d5c$var$Of = "__reactFiber$" + $cfc2e5a80c7c6d5c$var$Nf, $cfc2e5a80c7c6d5c$var$Pf = "__reactProps$" + $cfc2e5a80c7c6d5c$var$Nf, $cfc2e5a80c7c6d5c$var$uf = "__reactContainer$" + $cfc2e5a80c7c6d5c$var$Nf, $cfc2e5a80c7c6d5c$var$of = "__reactEvents$" + $cfc2e5a80c7c6d5c$var$Nf, $cfc2e5a80c7c6d5c$var$Qf = "__reactListeners$" + $cfc2e5a80c7c6d5c$var$Nf, $cfc2e5a80c7c6d5c$var$Rf = "__reactHandles$" + $cfc2e5a80c7c6d5c$var$Nf;
function $cfc2e5a80c7c6d5c$var$Wc(a) {
    var b = a[$cfc2e5a80c7c6d5c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$cfc2e5a80c7c6d5c$var$uf] || c[$cfc2e5a80c7c6d5c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $cfc2e5a80c7c6d5c$var$Mf(a); null !== a;){
                if (c = a[$cfc2e5a80c7c6d5c$var$Of]) return c;
                a = $cfc2e5a80c7c6d5c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $cfc2e5a80c7c6d5c$var$Cb(a) {
    a = a[$cfc2e5a80c7c6d5c$var$Of] || a[$cfc2e5a80c7c6d5c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $cfc2e5a80c7c6d5c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($cfc2e5a80c7c6d5c$var$p(33));
}
function $cfc2e5a80c7c6d5c$var$Db(a) {
    return a[$cfc2e5a80c7c6d5c$var$Pf] || null;
}
var $cfc2e5a80c7c6d5c$var$Sf = [], $cfc2e5a80c7c6d5c$var$Tf = -1;
function $cfc2e5a80c7c6d5c$var$Uf(a) {
    return {
        current: a
    };
}
function $cfc2e5a80c7c6d5c$var$E(a) {
    0 > $cfc2e5a80c7c6d5c$var$Tf || (a.current = $cfc2e5a80c7c6d5c$var$Sf[$cfc2e5a80c7c6d5c$var$Tf], $cfc2e5a80c7c6d5c$var$Sf[$cfc2e5a80c7c6d5c$var$Tf] = null, $cfc2e5a80c7c6d5c$var$Tf--);
}
function $cfc2e5a80c7c6d5c$var$G(a, b) {
    $cfc2e5a80c7c6d5c$var$Tf++;
    $cfc2e5a80c7c6d5c$var$Sf[$cfc2e5a80c7c6d5c$var$Tf] = a.current;
    a.current = b;
}
var $cfc2e5a80c7c6d5c$var$Vf = {}, $cfc2e5a80c7c6d5c$var$H = $cfc2e5a80c7c6d5c$var$Uf($cfc2e5a80c7c6d5c$var$Vf), $cfc2e5a80c7c6d5c$var$Wf = $cfc2e5a80c7c6d5c$var$Uf(!1), $cfc2e5a80c7c6d5c$var$Xf = $cfc2e5a80c7c6d5c$var$Vf;
function $cfc2e5a80c7c6d5c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $cfc2e5a80c7c6d5c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $cfc2e5a80c7c6d5c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $cfc2e5a80c7c6d5c$var$$f() {
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Wf);
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$H);
}
function $cfc2e5a80c7c6d5c$var$ag(a, b, c) {
    if ($cfc2e5a80c7c6d5c$var$H.current !== $cfc2e5a80c7c6d5c$var$Vf) throw Error($cfc2e5a80c7c6d5c$var$p(168));
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$H, b);
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Wf, c);
}
function $cfc2e5a80c7c6d5c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($cfc2e5a80c7c6d5c$var$p(108, $cfc2e5a80c7c6d5c$var$Ra(a) || "Unknown", e));
    return $cfc2e5a80c7c6d5c$var$A({}, c, d);
}
function $cfc2e5a80c7c6d5c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $cfc2e5a80c7c6d5c$var$Vf;
    $cfc2e5a80c7c6d5c$var$Xf = $cfc2e5a80c7c6d5c$var$H.current;
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$H, a);
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Wf, $cfc2e5a80c7c6d5c$var$Wf.current);
    return !0;
}
function $cfc2e5a80c7c6d5c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($cfc2e5a80c7c6d5c$var$p(169));
    c ? (a = $cfc2e5a80c7c6d5c$var$bg(a, b, $cfc2e5a80c7c6d5c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Wf), $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$H), $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$H, a)) : $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Wf);
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Wf, c);
}
var $cfc2e5a80c7c6d5c$var$eg = null, $cfc2e5a80c7c6d5c$var$fg = !1, $cfc2e5a80c7c6d5c$var$gg = !1;
function $cfc2e5a80c7c6d5c$var$hg(a) {
    null === $cfc2e5a80c7c6d5c$var$eg ? $cfc2e5a80c7c6d5c$var$eg = [
        a
    ] : $cfc2e5a80c7c6d5c$var$eg.push(a);
}
function $cfc2e5a80c7c6d5c$var$ig(a) {
    $cfc2e5a80c7c6d5c$var$fg = !0;
    $cfc2e5a80c7c6d5c$var$hg(a);
}
function $cfc2e5a80c7c6d5c$var$jg() {
    if (!$cfc2e5a80c7c6d5c$var$gg && null !== $cfc2e5a80c7c6d5c$var$eg) {
        $cfc2e5a80c7c6d5c$var$gg = !0;
        var a = 0, b = $cfc2e5a80c7c6d5c$var$C;
        try {
            var c = $cfc2e5a80c7c6d5c$var$eg;
            for($cfc2e5a80c7c6d5c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $cfc2e5a80c7c6d5c$var$eg = null;
            $cfc2e5a80c7c6d5c$var$fg = !1;
        } catch (e) {
            throw null !== $cfc2e5a80c7c6d5c$var$eg && ($cfc2e5a80c7c6d5c$var$eg = $cfc2e5a80c7c6d5c$var$eg.slice(a + 1)), $cfc2e5a80c7c6d5c$var$ac($cfc2e5a80c7c6d5c$var$fc, $cfc2e5a80c7c6d5c$var$jg), e;
        } finally{
            $cfc2e5a80c7c6d5c$var$C = b, $cfc2e5a80c7c6d5c$var$gg = !1;
        }
    }
    return null;
}
var $cfc2e5a80c7c6d5c$var$kg = [], $cfc2e5a80c7c6d5c$var$lg = 0, $cfc2e5a80c7c6d5c$var$mg = null, $cfc2e5a80c7c6d5c$var$ng = 0, $cfc2e5a80c7c6d5c$var$og = [], $cfc2e5a80c7c6d5c$var$pg = 0, $cfc2e5a80c7c6d5c$var$qg = null, $cfc2e5a80c7c6d5c$var$rg = 1, $cfc2e5a80c7c6d5c$var$sg = "";
function $cfc2e5a80c7c6d5c$var$tg(a, b) {
    $cfc2e5a80c7c6d5c$var$kg[$cfc2e5a80c7c6d5c$var$lg++] = $cfc2e5a80c7c6d5c$var$ng;
    $cfc2e5a80c7c6d5c$var$kg[$cfc2e5a80c7c6d5c$var$lg++] = $cfc2e5a80c7c6d5c$var$mg;
    $cfc2e5a80c7c6d5c$var$mg = a;
    $cfc2e5a80c7c6d5c$var$ng = b;
}
function $cfc2e5a80c7c6d5c$var$ug(a, b, c) {
    $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg++] = $cfc2e5a80c7c6d5c$var$rg;
    $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg++] = $cfc2e5a80c7c6d5c$var$sg;
    $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg++] = $cfc2e5a80c7c6d5c$var$qg;
    $cfc2e5a80c7c6d5c$var$qg = a;
    var d = $cfc2e5a80c7c6d5c$var$rg;
    a = $cfc2e5a80c7c6d5c$var$sg;
    var e = 32 - $cfc2e5a80c7c6d5c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $cfc2e5a80c7c6d5c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $cfc2e5a80c7c6d5c$var$rg = 1 << 32 - $cfc2e5a80c7c6d5c$var$oc(b) + e | c << e | d;
        $cfc2e5a80c7c6d5c$var$sg = f + a;
    } else $cfc2e5a80c7c6d5c$var$rg = 1 << f | c << e | d, $cfc2e5a80c7c6d5c$var$sg = a;
}
function $cfc2e5a80c7c6d5c$var$vg(a) {
    null !== a["return"] && ($cfc2e5a80c7c6d5c$var$tg(a, 1), $cfc2e5a80c7c6d5c$var$ug(a, 1, 0));
}
function $cfc2e5a80c7c6d5c$var$wg(a) {
    for(; a === $cfc2e5a80c7c6d5c$var$mg;)$cfc2e5a80c7c6d5c$var$mg = $cfc2e5a80c7c6d5c$var$kg[--$cfc2e5a80c7c6d5c$var$lg], $cfc2e5a80c7c6d5c$var$kg[$cfc2e5a80c7c6d5c$var$lg] = null, $cfc2e5a80c7c6d5c$var$ng = $cfc2e5a80c7c6d5c$var$kg[--$cfc2e5a80c7c6d5c$var$lg], $cfc2e5a80c7c6d5c$var$kg[$cfc2e5a80c7c6d5c$var$lg] = null;
    for(; a === $cfc2e5a80c7c6d5c$var$qg;)$cfc2e5a80c7c6d5c$var$qg = $cfc2e5a80c7c6d5c$var$og[--$cfc2e5a80c7c6d5c$var$pg], $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg] = null, $cfc2e5a80c7c6d5c$var$sg = $cfc2e5a80c7c6d5c$var$og[--$cfc2e5a80c7c6d5c$var$pg], $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg] = null, $cfc2e5a80c7c6d5c$var$rg = $cfc2e5a80c7c6d5c$var$og[--$cfc2e5a80c7c6d5c$var$pg], $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg] = null;
}
var $cfc2e5a80c7c6d5c$var$xg = null, $cfc2e5a80c7c6d5c$var$yg = null, $cfc2e5a80c7c6d5c$var$I = !1, $cfc2e5a80c7c6d5c$var$zg = null;
function $cfc2e5a80c7c6d5c$var$Ag(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $cfc2e5a80c7c6d5c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $cfc2e5a80c7c6d5c$var$xg = a, $cfc2e5a80c7c6d5c$var$yg = $cfc2e5a80c7c6d5c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $cfc2e5a80c7c6d5c$var$xg = a, $cfc2e5a80c7c6d5c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $cfc2e5a80c7c6d5c$var$qg ? {
                id: $cfc2e5a80c7c6d5c$var$rg,
                overflow: $cfc2e5a80c7c6d5c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $cfc2e5a80c7c6d5c$var$Bg(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, $cfc2e5a80c7c6d5c$var$xg = a, $cfc2e5a80c7c6d5c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $cfc2e5a80c7c6d5c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $cfc2e5a80c7c6d5c$var$Eg(a) {
    if ($cfc2e5a80c7c6d5c$var$I) {
        var b = $cfc2e5a80c7c6d5c$var$yg;
        if (b) {
            var c = b;
            if (!$cfc2e5a80c7c6d5c$var$Cg(a, b)) {
                if ($cfc2e5a80c7c6d5c$var$Dg(a)) throw Error($cfc2e5a80c7c6d5c$var$p(418));
                b = $cfc2e5a80c7c6d5c$var$Lf(c.nextSibling);
                var d = $cfc2e5a80c7c6d5c$var$xg;
                b && $cfc2e5a80c7c6d5c$var$Cg(a, b) ? $cfc2e5a80c7c6d5c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $cfc2e5a80c7c6d5c$var$I = !1, $cfc2e5a80c7c6d5c$var$xg = a);
            }
        } else {
            if ($cfc2e5a80c7c6d5c$var$Dg(a)) throw Error($cfc2e5a80c7c6d5c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $cfc2e5a80c7c6d5c$var$I = !1;
            $cfc2e5a80c7c6d5c$var$xg = a;
        }
    }
}
function $cfc2e5a80c7c6d5c$var$Fg(a) {
    for(a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a["return"];
    $cfc2e5a80c7c6d5c$var$xg = a;
}
function $cfc2e5a80c7c6d5c$var$Gg(a) {
    if (a !== $cfc2e5a80c7c6d5c$var$xg) return !1;
    if (!$cfc2e5a80c7c6d5c$var$I) return $cfc2e5a80c7c6d5c$var$Fg(a), $cfc2e5a80c7c6d5c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$cfc2e5a80c7c6d5c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $cfc2e5a80c7c6d5c$var$yg)) {
        if ($cfc2e5a80c7c6d5c$var$Dg(a)) throw $cfc2e5a80c7c6d5c$var$Hg(), Error($cfc2e5a80c7c6d5c$var$p(418));
        for(; b;)$cfc2e5a80c7c6d5c$var$Ag(a, b), b = $cfc2e5a80c7c6d5c$var$Lf(b.nextSibling);
    }
    $cfc2e5a80c7c6d5c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($cfc2e5a80c7c6d5c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $cfc2e5a80c7c6d5c$var$yg = $cfc2e5a80c7c6d5c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $cfc2e5a80c7c6d5c$var$yg = null;
        }
    } else $cfc2e5a80c7c6d5c$var$yg = $cfc2e5a80c7c6d5c$var$xg ? $cfc2e5a80c7c6d5c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $cfc2e5a80c7c6d5c$var$Hg() {
    for(var a = $cfc2e5a80c7c6d5c$var$yg; a;)a = $cfc2e5a80c7c6d5c$var$Lf(a.nextSibling);
}
function $cfc2e5a80c7c6d5c$var$Ig() {
    $cfc2e5a80c7c6d5c$var$yg = $cfc2e5a80c7c6d5c$var$xg = null;
    $cfc2e5a80c7c6d5c$var$I = !1;
}
function $cfc2e5a80c7c6d5c$var$Jg(a) {
    null === $cfc2e5a80c7c6d5c$var$zg ? $cfc2e5a80c7c6d5c$var$zg = [
        a
    ] : $cfc2e5a80c7c6d5c$var$zg.push(a);
}
var $cfc2e5a80c7c6d5c$var$Kg = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentBatchConfig;
function $cfc2e5a80c7c6d5c$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $cfc2e5a80c7c6d5c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $cfc2e5a80c7c6d5c$var$Mg = $cfc2e5a80c7c6d5c$var$Uf(null), $cfc2e5a80c7c6d5c$var$Ng = null, $cfc2e5a80c7c6d5c$var$Og = null, $cfc2e5a80c7c6d5c$var$Pg = null;
function $cfc2e5a80c7c6d5c$var$Qg() {
    $cfc2e5a80c7c6d5c$var$Pg = $cfc2e5a80c7c6d5c$var$Og = $cfc2e5a80c7c6d5c$var$Ng = null;
}
function $cfc2e5a80c7c6d5c$var$Rg(a) {
    var b = $cfc2e5a80c7c6d5c$var$Mg.current;
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Mg);
    a._currentValue = b;
}
function $cfc2e5a80c7c6d5c$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a["return"];
    }
}
function $cfc2e5a80c7c6d5c$var$Tg(a, b) {
    $cfc2e5a80c7c6d5c$var$Ng = a;
    $cfc2e5a80c7c6d5c$var$Pg = $cfc2e5a80c7c6d5c$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($cfc2e5a80c7c6d5c$var$Ug = !0), a.firstContext = null);
}
function $cfc2e5a80c7c6d5c$var$Vg(a) {
    var b = a._currentValue;
    if ($cfc2e5a80c7c6d5c$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $cfc2e5a80c7c6d5c$var$Og) {
            if (null === $cfc2e5a80c7c6d5c$var$Ng) throw Error($cfc2e5a80c7c6d5c$var$p(308));
            $cfc2e5a80c7c6d5c$var$Og = a;
            $cfc2e5a80c7c6d5c$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $cfc2e5a80c7c6d5c$var$Og = $cfc2e5a80c7c6d5c$var$Og.next = a;
    }
    return b;
}
var $cfc2e5a80c7c6d5c$var$Wg = null;
function $cfc2e5a80c7c6d5c$var$Xg(a) {
    null === $cfc2e5a80c7c6d5c$var$Wg ? $cfc2e5a80c7c6d5c$var$Wg = [
        a
    ] : $cfc2e5a80c7c6d5c$var$Wg.push(a);
}
function $cfc2e5a80c7c6d5c$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $cfc2e5a80c7c6d5c$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $cfc2e5a80c7c6d5c$var$Zg(a, d);
}
function $cfc2e5a80c7c6d5c$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a["return"]; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
    return 3 === c.tag ? c.stateNode : null;
}
var $cfc2e5a80c7c6d5c$var$$g = !1;
function $cfc2e5a80c7c6d5c$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $cfc2e5a80c7c6d5c$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $cfc2e5a80c7c6d5c$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $cfc2e5a80c7c6d5c$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($cfc2e5a80c7c6d5c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $cfc2e5a80c7c6d5c$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $cfc2e5a80c7c6d5c$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $cfc2e5a80c7c6d5c$var$Zg(a, c);
}
function $cfc2e5a80c7c6d5c$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $cfc2e5a80c7c6d5c$var$Cc(a, c);
    }
}
function $cfc2e5a80c7c6d5c$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $cfc2e5a80c7c6d5c$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $cfc2e5a80c7c6d5c$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $cfc2e5a80c7c6d5c$var$A({}, q, r);
                            break a;
                        case 2:
                            $cfc2e5a80c7c6d5c$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $cfc2e5a80c7c6d5c$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $cfc2e5a80c7c6d5c$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($cfc2e5a80c7c6d5c$var$p(191, e));
            e.call(d);
        }
    }
}
var $cfc2e5a80c7c6d5c$var$jh = (new $eN0cn.Component).refs;
function $cfc2e5a80c7c6d5c$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $cfc2e5a80c7c6d5c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $cfc2e5a80c7c6d5c$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $cfc2e5a80c7c6d5c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $cfc2e5a80c7c6d5c$var$L(), e = $cfc2e5a80c7c6d5c$var$lh(a), f = $cfc2e5a80c7c6d5c$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $cfc2e5a80c7c6d5c$var$dh(a, f, e);
        null !== b && ($cfc2e5a80c7c6d5c$var$mh(b, a, e, d), $cfc2e5a80c7c6d5c$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $cfc2e5a80c7c6d5c$var$L(), e = $cfc2e5a80c7c6d5c$var$lh(a), f = $cfc2e5a80c7c6d5c$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $cfc2e5a80c7c6d5c$var$dh(a, f, e);
        null !== b && ($cfc2e5a80c7c6d5c$var$mh(b, a, e, d), $cfc2e5a80c7c6d5c$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $cfc2e5a80c7c6d5c$var$L(), d = $cfc2e5a80c7c6d5c$var$lh(a), e = $cfc2e5a80c7c6d5c$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $cfc2e5a80c7c6d5c$var$dh(a, e, d);
        null !== b && ($cfc2e5a80c7c6d5c$var$mh(b, a, d, c), $cfc2e5a80c7c6d5c$var$eh(b, a, d));
    }
};
function $cfc2e5a80c7c6d5c$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$cfc2e5a80c7c6d5c$var$Ie(c, d) || !$cfc2e5a80c7c6d5c$var$Ie(e, f) : !0;
}
function $cfc2e5a80c7c6d5c$var$ph(a, b, c) {
    var d = !1, e = $cfc2e5a80c7c6d5c$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $k4vcf._)(f)) && null !== f ? f = $cfc2e5a80c7c6d5c$var$Vg(f) : (e = $cfc2e5a80c7c6d5c$var$Zf(b) ? $cfc2e5a80c7c6d5c$var$Xf : $cfc2e5a80c7c6d5c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $cfc2e5a80c7c6d5c$var$Yf(a, e) : $cfc2e5a80c7c6d5c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $cfc2e5a80c7c6d5c$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $cfc2e5a80c7c6d5c$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $cfc2e5a80c7c6d5c$var$nh.enqueueReplaceState(b, b.state, null);
}
function $cfc2e5a80c7c6d5c$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $cfc2e5a80c7c6d5c$var$jh;
    $cfc2e5a80c7c6d5c$var$ah(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $k4vcf._)(f)) && null !== f ? e.context = $cfc2e5a80c7c6d5c$var$Vg(f) : (f = $cfc2e5a80c7c6d5c$var$Zf(b) ? $cfc2e5a80c7c6d5c$var$Xf : $cfc2e5a80c7c6d5c$var$H.current, e.context = $cfc2e5a80c7c6d5c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($cfc2e5a80c7c6d5c$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $cfc2e5a80c7c6d5c$var$nh.enqueueReplaceState(e, e.state, null), $cfc2e5a80c7c6d5c$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $cfc2e5a80c7c6d5c$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($cfc2e5a80c7c6d5c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($cfc2e5a80c7c6d5c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $cfc2e5a80c7c6d5c$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($cfc2e5a80c7c6d5c$var$p(284));
        if (!c._owner) throw Error($cfc2e5a80c7c6d5c$var$p(290, a));
    }
    return a;
}
function $cfc2e5a80c7c6d5c$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($cfc2e5a80c7c6d5c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $cfc2e5a80c7c6d5c$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $cfc2e5a80c7c6d5c$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $cfc2e5a80c7c6d5c$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $cfc2e5a80c7c6d5c$var$xh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $cfc2e5a80c7c6d5c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $k4vcf._)(f)) && null !== f && f.$$typeof === $cfc2e5a80c7c6d5c$var$Ha && $cfc2e5a80c7c6d5c$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $cfc2e5a80c7c6d5c$var$sh(a, b, c), d["return"] = a, d;
        d = $cfc2e5a80c7c6d5c$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $cfc2e5a80c7c6d5c$var$sh(a, b, c);
        d["return"] = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $cfc2e5a80c7c6d5c$var$zh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c.children || []);
        b["return"] = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $cfc2e5a80c7c6d5c$var$Ah(c, a.mode, d, f), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $cfc2e5a80c7c6d5c$var$xh("" + b, a.mode, c), b["return"] = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $k4vcf._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $cfc2e5a80c7c6d5c$var$va:
                    return c = $cfc2e5a80c7c6d5c$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $cfc2e5a80c7c6d5c$var$sh(a, null, b), c["return"] = a, c;
                case $cfc2e5a80c7c6d5c$var$wa:
                    return b = $cfc2e5a80c7c6d5c$var$zh(b, a.mode, c), b["return"] = a, b;
                case $cfc2e5a80c7c6d5c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($cfc2e5a80c7c6d5c$var$eb(b) || $cfc2e5a80c7c6d5c$var$Ka(b)) return b = $cfc2e5a80c7c6d5c$var$Ah(b, a.mode, c, null), b["return"] = a, b;
            $cfc2e5a80c7c6d5c$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $k4vcf._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $cfc2e5a80c7c6d5c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $cfc2e5a80c7c6d5c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $cfc2e5a80c7c6d5c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($cfc2e5a80c7c6d5c$var$eb(c) || $cfc2e5a80c7c6d5c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $cfc2e5a80c7c6d5c$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $k4vcf._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $cfc2e5a80c7c6d5c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $cfc2e5a80c7c6d5c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $cfc2e5a80c7c6d5c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($cfc2e5a80c7c6d5c$var$eb(d) || $cfc2e5a80c7c6d5c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $cfc2e5a80c7c6d5c$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $cfc2e5a80c7c6d5c$var$I && $cfc2e5a80c7c6d5c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $cfc2e5a80c7c6d5c$var$I && $cfc2e5a80c7c6d5c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u["delete"](null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $cfc2e5a80c7c6d5c$var$I && $cfc2e5a80c7c6d5c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $cfc2e5a80c7c6d5c$var$Ka(h);
        if ("function" !== typeof l) throw Error($cfc2e5a80c7c6d5c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($cfc2e5a80c7c6d5c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $cfc2e5a80c7c6d5c$var$I && $cfc2e5a80c7c6d5c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $cfc2e5a80c7c6d5c$var$I && $cfc2e5a80c7c6d5c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m["delete"](null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $cfc2e5a80c7c6d5c$var$I && $cfc2e5a80c7c6d5c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $k4vcf._)(f)) && null !== f && f.type === $cfc2e5a80c7c6d5c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $k4vcf._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $cfc2e5a80c7c6d5c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $cfc2e5a80c7c6d5c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $k4vcf._)(k)) && null !== k && k.$$typeof === $cfc2e5a80c7c6d5c$var$Ha && $cfc2e5a80c7c6d5c$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $cfc2e5a80c7c6d5c$var$sh(a, l, f);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $cfc2e5a80c7c6d5c$var$ya ? (d = $cfc2e5a80c7c6d5c$var$Ah(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = $cfc2e5a80c7c6d5c$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $cfc2e5a80c7c6d5c$var$sh(a, d, f), h["return"] = a, a = h);
                    }
                    return g(a);
                case $cfc2e5a80c7c6d5c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $cfc2e5a80c7c6d5c$var$zh(f, a.mode, h);
                        d["return"] = a;
                        a = d;
                    }
                    return g(a);
                case $cfc2e5a80c7c6d5c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($cfc2e5a80c7c6d5c$var$eb(f)) return n(a, d, f, h);
            if ($cfc2e5a80c7c6d5c$var$Ka(f)) return t(a, d, f, h);
            $cfc2e5a80c7c6d5c$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = $cfc2e5a80c7c6d5c$var$xh(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $cfc2e5a80c7c6d5c$var$Bh = $cfc2e5a80c7c6d5c$var$vh(!0), $cfc2e5a80c7c6d5c$var$Ch = $cfc2e5a80c7c6d5c$var$vh(!1), $cfc2e5a80c7c6d5c$var$Dh = {}, $cfc2e5a80c7c6d5c$var$Eh = $cfc2e5a80c7c6d5c$var$Uf($cfc2e5a80c7c6d5c$var$Dh), $cfc2e5a80c7c6d5c$var$Fh = $cfc2e5a80c7c6d5c$var$Uf($cfc2e5a80c7c6d5c$var$Dh), $cfc2e5a80c7c6d5c$var$Gh = $cfc2e5a80c7c6d5c$var$Uf($cfc2e5a80c7c6d5c$var$Dh);
function $cfc2e5a80c7c6d5c$var$Hh(a) {
    if (a === $cfc2e5a80c7c6d5c$var$Dh) throw Error($cfc2e5a80c7c6d5c$var$p(174));
    return a;
}
function $cfc2e5a80c7c6d5c$var$Ih(a, b) {
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Gh, b);
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Fh, a);
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Eh, $cfc2e5a80c7c6d5c$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $cfc2e5a80c7c6d5c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $cfc2e5a80c7c6d5c$var$lb(b, a);
    }
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Eh);
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Eh, b);
}
function $cfc2e5a80c7c6d5c$var$Jh() {
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Eh);
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Fh);
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Gh);
}
function $cfc2e5a80c7c6d5c$var$Kh(a) {
    $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Gh.current);
    var b = $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Eh.current);
    var c = $cfc2e5a80c7c6d5c$var$lb(b, a.type);
    b !== c && ($cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Fh, a), $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Eh, c));
}
function $cfc2e5a80c7c6d5c$var$Lh(a) {
    $cfc2e5a80c7c6d5c$var$Fh.current === a && ($cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Eh), $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Fh));
}
var $cfc2e5a80c7c6d5c$var$M = $cfc2e5a80c7c6d5c$var$Uf(0);
function $cfc2e5a80c7c6d5c$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child["return"] = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b["return"] || b["return"] === a) return null;
            b = b["return"];
        }
        b.sibling["return"] = b["return"];
        b = b.sibling;
    }
    return null;
}
var $cfc2e5a80c7c6d5c$var$Nh = [];
function $cfc2e5a80c7c6d5c$var$Oh() {
    for(var a = 0; a < $cfc2e5a80c7c6d5c$var$Nh.length; a++)$cfc2e5a80c7c6d5c$var$Nh[a]._workInProgressVersionPrimary = null;
    $cfc2e5a80c7c6d5c$var$Nh.length = 0;
}
var $cfc2e5a80c7c6d5c$var$Ph = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentDispatcher, $cfc2e5a80c7c6d5c$var$Qh = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentBatchConfig, $cfc2e5a80c7c6d5c$var$Rh = 0, $cfc2e5a80c7c6d5c$var$N = null, $cfc2e5a80c7c6d5c$var$O = null, $cfc2e5a80c7c6d5c$var$P = null, $cfc2e5a80c7c6d5c$var$Sh = !1, $cfc2e5a80c7c6d5c$var$Th = !1, $cfc2e5a80c7c6d5c$var$Uh = 0, $cfc2e5a80c7c6d5c$var$Vh = 0;
function $cfc2e5a80c7c6d5c$var$Q() {
    throw Error($cfc2e5a80c7c6d5c$var$p(321));
}
function $cfc2e5a80c7c6d5c$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$cfc2e5a80c7c6d5c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $cfc2e5a80c7c6d5c$var$Xh(a, b, c, d, e, f) {
    $cfc2e5a80c7c6d5c$var$Rh = f;
    $cfc2e5a80c7c6d5c$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $cfc2e5a80c7c6d5c$var$Ph.current = null === a || null === a.memoizedState ? $cfc2e5a80c7c6d5c$var$Yh : $cfc2e5a80c7c6d5c$var$Zh;
    a = c(d, e);
    if ($cfc2e5a80c7c6d5c$var$Th) {
        f = 0;
        do {
            $cfc2e5a80c7c6d5c$var$Th = !1;
            $cfc2e5a80c7c6d5c$var$Uh = 0;
            if (25 <= f) throw Error($cfc2e5a80c7c6d5c$var$p(301));
            f += 1;
            $cfc2e5a80c7c6d5c$var$P = $cfc2e5a80c7c6d5c$var$O = null;
            b.updateQueue = null;
            $cfc2e5a80c7c6d5c$var$Ph.current = $cfc2e5a80c7c6d5c$var$$h;
            a = c(d, e);
        }while ($cfc2e5a80c7c6d5c$var$Th);
    }
    $cfc2e5a80c7c6d5c$var$Ph.current = $cfc2e5a80c7c6d5c$var$ai;
    b = null !== $cfc2e5a80c7c6d5c$var$O && null !== $cfc2e5a80c7c6d5c$var$O.next;
    $cfc2e5a80c7c6d5c$var$Rh = 0;
    $cfc2e5a80c7c6d5c$var$P = $cfc2e5a80c7c6d5c$var$O = $cfc2e5a80c7c6d5c$var$N = null;
    $cfc2e5a80c7c6d5c$var$Sh = !1;
    if (b) throw Error($cfc2e5a80c7c6d5c$var$p(300));
    return a;
}
function $cfc2e5a80c7c6d5c$var$bi() {
    var a = 0 !== $cfc2e5a80c7c6d5c$var$Uh;
    $cfc2e5a80c7c6d5c$var$Uh = 0;
    return a;
}
function $cfc2e5a80c7c6d5c$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $cfc2e5a80c7c6d5c$var$P ? $cfc2e5a80c7c6d5c$var$N.memoizedState = $cfc2e5a80c7c6d5c$var$P = a : $cfc2e5a80c7c6d5c$var$P = $cfc2e5a80c7c6d5c$var$P.next = a;
    return $cfc2e5a80c7c6d5c$var$P;
}
function $cfc2e5a80c7c6d5c$var$di() {
    if (null === $cfc2e5a80c7c6d5c$var$O) {
        var a = $cfc2e5a80c7c6d5c$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $cfc2e5a80c7c6d5c$var$O.next;
    var b = null === $cfc2e5a80c7c6d5c$var$P ? $cfc2e5a80c7c6d5c$var$N.memoizedState : $cfc2e5a80c7c6d5c$var$P.next;
    if (null !== b) $cfc2e5a80c7c6d5c$var$P = b, $cfc2e5a80c7c6d5c$var$O = a;
    else {
        if (null === a) throw Error($cfc2e5a80c7c6d5c$var$p(310));
        $cfc2e5a80c7c6d5c$var$O = a;
        a = {
            memoizedState: $cfc2e5a80c7c6d5c$var$O.memoizedState,
            baseState: $cfc2e5a80c7c6d5c$var$O.baseState,
            baseQueue: $cfc2e5a80c7c6d5c$var$O.baseQueue,
            queue: $cfc2e5a80c7c6d5c$var$O.queue,
            next: null
        };
        null === $cfc2e5a80c7c6d5c$var$P ? $cfc2e5a80c7c6d5c$var$N.memoizedState = $cfc2e5a80c7c6d5c$var$P = a : $cfc2e5a80c7c6d5c$var$P = $cfc2e5a80c7c6d5c$var$P.next = a;
    }
    return $cfc2e5a80c7c6d5c$var$P;
}
function $cfc2e5a80c7c6d5c$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $cfc2e5a80c7c6d5c$var$fi(a) {
    var b = $cfc2e5a80c7c6d5c$var$di(), c = b.queue;
    if (null === c) throw Error($cfc2e5a80c7c6d5c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $cfc2e5a80c7c6d5c$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($cfc2e5a80c7c6d5c$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $cfc2e5a80c7c6d5c$var$N.lanes |= m;
                $cfc2e5a80c7c6d5c$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $cfc2e5a80c7c6d5c$var$He(d, b.memoizedState) || ($cfc2e5a80c7c6d5c$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $cfc2e5a80c7c6d5c$var$N.lanes |= f, $cfc2e5a80c7c6d5c$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $cfc2e5a80c7c6d5c$var$gi(a) {
    var b = $cfc2e5a80c7c6d5c$var$di(), c = b.queue;
    if (null === c) throw Error($cfc2e5a80c7c6d5c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $cfc2e5a80c7c6d5c$var$He(f, b.memoizedState) || ($cfc2e5a80c7c6d5c$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $cfc2e5a80c7c6d5c$var$hi() {}
function $cfc2e5a80c7c6d5c$var$ii(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$N, d = $cfc2e5a80c7c6d5c$var$di(), e = b(), f = !$cfc2e5a80c7c6d5c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $cfc2e5a80c7c6d5c$var$Ug = !0);
    d = d.queue;
    $cfc2e5a80c7c6d5c$var$ji($cfc2e5a80c7c6d5c$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $cfc2e5a80c7c6d5c$var$P && $cfc2e5a80c7c6d5c$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $cfc2e5a80c7c6d5c$var$li(9, $cfc2e5a80c7c6d5c$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $cfc2e5a80c7c6d5c$var$R) throw Error($cfc2e5a80c7c6d5c$var$p(349));
        0 !== ($cfc2e5a80c7c6d5c$var$Rh & 30) || $cfc2e5a80c7c6d5c$var$ni(c, b, e);
    }
    return e;
}
function $cfc2e5a80c7c6d5c$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $cfc2e5a80c7c6d5c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $cfc2e5a80c7c6d5c$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $cfc2e5a80c7c6d5c$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $cfc2e5a80c7c6d5c$var$oi(b) && $cfc2e5a80c7c6d5c$var$pi(a);
}
function $cfc2e5a80c7c6d5c$var$ki(a, b, c) {
    return c(function() {
        $cfc2e5a80c7c6d5c$var$oi(b) && $cfc2e5a80c7c6d5c$var$pi(a);
    });
}
function $cfc2e5a80c7c6d5c$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$cfc2e5a80c7c6d5c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $cfc2e5a80c7c6d5c$var$pi(a) {
    var b = $cfc2e5a80c7c6d5c$var$Zg(a, 1);
    null !== b && $cfc2e5a80c7c6d5c$var$mh(b, a, 1, -1);
}
function $cfc2e5a80c7c6d5c$var$qi(a) {
    var b = $cfc2e5a80c7c6d5c$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cfc2e5a80c7c6d5c$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $cfc2e5a80c7c6d5c$var$ri.bind(null, $cfc2e5a80c7c6d5c$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $cfc2e5a80c7c6d5c$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $cfc2e5a80c7c6d5c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $cfc2e5a80c7c6d5c$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $cfc2e5a80c7c6d5c$var$si() {
    return $cfc2e5a80c7c6d5c$var$di().memoizedState;
}
function $cfc2e5a80c7c6d5c$var$ti(a, b, c, d) {
    var e = $cfc2e5a80c7c6d5c$var$ci();
    $cfc2e5a80c7c6d5c$var$N.flags |= a;
    e.memoizedState = $cfc2e5a80c7c6d5c$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $cfc2e5a80c7c6d5c$var$ui(a, b, c, d) {
    var e = $cfc2e5a80c7c6d5c$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $cfc2e5a80c7c6d5c$var$O) {
        var g = $cfc2e5a80c7c6d5c$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $cfc2e5a80c7c6d5c$var$Wh(d, g.deps)) {
            e.memoizedState = $cfc2e5a80c7c6d5c$var$li(b, c, f, d);
            return;
        }
    }
    $cfc2e5a80c7c6d5c$var$N.flags |= a;
    e.memoizedState = $cfc2e5a80c7c6d5c$var$li(1 | b, c, f, d);
}
function $cfc2e5a80c7c6d5c$var$vi(a, b) {
    return $cfc2e5a80c7c6d5c$var$ti(8390656, 8, a, b);
}
function $cfc2e5a80c7c6d5c$var$ji(a, b) {
    return $cfc2e5a80c7c6d5c$var$ui(2048, 8, a, b);
}
function $cfc2e5a80c7c6d5c$var$wi(a, b) {
    return $cfc2e5a80c7c6d5c$var$ui(4, 2, a, b);
}
function $cfc2e5a80c7c6d5c$var$xi(a, b) {
    return $cfc2e5a80c7c6d5c$var$ui(4, 4, a, b);
}
function $cfc2e5a80c7c6d5c$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $cfc2e5a80c7c6d5c$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $cfc2e5a80c7c6d5c$var$ui(4, 4, $cfc2e5a80c7c6d5c$var$yi.bind(null, b, a), c);
}
function $cfc2e5a80c7c6d5c$var$Ai() {}
function $cfc2e5a80c7c6d5c$var$Bi(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $cfc2e5a80c7c6d5c$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cfc2e5a80c7c6d5c$var$Ci(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $cfc2e5a80c7c6d5c$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cfc2e5a80c7c6d5c$var$Di(a, b, c) {
    if (0 === ($cfc2e5a80c7c6d5c$var$Rh & 21)) return a.baseState && (a.baseState = !1, $cfc2e5a80c7c6d5c$var$Ug = !0), a.memoizedState = c;
    $cfc2e5a80c7c6d5c$var$He(c, b) || (c = $cfc2e5a80c7c6d5c$var$yc(), $cfc2e5a80c7c6d5c$var$N.lanes |= c, $cfc2e5a80c7c6d5c$var$hh |= c, a.baseState = !0);
    return b;
}
function $cfc2e5a80c7c6d5c$var$Ei(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$C;
    $cfc2e5a80c7c6d5c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $cfc2e5a80c7c6d5c$var$Qh.transition;
    $cfc2e5a80c7c6d5c$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $cfc2e5a80c7c6d5c$var$C = c, $cfc2e5a80c7c6d5c$var$Qh.transition = d;
    }
}
function $cfc2e5a80c7c6d5c$var$Fi() {
    return $cfc2e5a80c7c6d5c$var$di().memoizedState;
}
function $cfc2e5a80c7c6d5c$var$Gi(a, b, c) {
    var d = $cfc2e5a80c7c6d5c$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cfc2e5a80c7c6d5c$var$Hi(a)) $cfc2e5a80c7c6d5c$var$Ii(b, c);
    else if (c = $cfc2e5a80c7c6d5c$var$Yg(a, b, c, d), null !== c) {
        var e = $cfc2e5a80c7c6d5c$var$L();
        $cfc2e5a80c7c6d5c$var$mh(c, a, d, e);
        $cfc2e5a80c7c6d5c$var$Ji(c, b, d);
    }
}
function $cfc2e5a80c7c6d5c$var$ri(a, b, c) {
    var d = $cfc2e5a80c7c6d5c$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cfc2e5a80c7c6d5c$var$Hi(a)) $cfc2e5a80c7c6d5c$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($cfc2e5a80c7c6d5c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $cfc2e5a80c7c6d5c$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $cfc2e5a80c7c6d5c$var$Yg(a, b, e, d);
        null !== c && (e = $cfc2e5a80c7c6d5c$var$L(), $cfc2e5a80c7c6d5c$var$mh(c, a, d, e), $cfc2e5a80c7c6d5c$var$Ji(c, b, d));
    }
}
function $cfc2e5a80c7c6d5c$var$Hi(a) {
    var b = a.alternate;
    return a === $cfc2e5a80c7c6d5c$var$N || null !== b && b === $cfc2e5a80c7c6d5c$var$N;
}
function $cfc2e5a80c7c6d5c$var$Ii(a, b) {
    $cfc2e5a80c7c6d5c$var$Th = $cfc2e5a80c7c6d5c$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $cfc2e5a80c7c6d5c$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $cfc2e5a80c7c6d5c$var$Cc(a, c);
    }
}
var $cfc2e5a80c7c6d5c$var$ai = {
    readContext: $cfc2e5a80c7c6d5c$var$Vg,
    useCallback: $cfc2e5a80c7c6d5c$var$Q,
    useContext: $cfc2e5a80c7c6d5c$var$Q,
    useEffect: $cfc2e5a80c7c6d5c$var$Q,
    useImperativeHandle: $cfc2e5a80c7c6d5c$var$Q,
    useInsertionEffect: $cfc2e5a80c7c6d5c$var$Q,
    useLayoutEffect: $cfc2e5a80c7c6d5c$var$Q,
    useMemo: $cfc2e5a80c7c6d5c$var$Q,
    useReducer: $cfc2e5a80c7c6d5c$var$Q,
    useRef: $cfc2e5a80c7c6d5c$var$Q,
    useState: $cfc2e5a80c7c6d5c$var$Q,
    useDebugValue: $cfc2e5a80c7c6d5c$var$Q,
    useDeferredValue: $cfc2e5a80c7c6d5c$var$Q,
    useTransition: $cfc2e5a80c7c6d5c$var$Q,
    useMutableSource: $cfc2e5a80c7c6d5c$var$Q,
    useSyncExternalStore: $cfc2e5a80c7c6d5c$var$Q,
    useId: $cfc2e5a80c7c6d5c$var$Q,
    unstable_isNewReconciler: !1
}, $cfc2e5a80c7c6d5c$var$Yh = {
    readContext: $cfc2e5a80c7c6d5c$var$Vg,
    useCallback: function useCallback(a, b) {
        $cfc2e5a80c7c6d5c$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $cfc2e5a80c7c6d5c$var$Vg,
    useEffect: $cfc2e5a80c7c6d5c$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $cfc2e5a80c7c6d5c$var$ti(4194308, 4, $cfc2e5a80c7c6d5c$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $cfc2e5a80c7c6d5c$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $cfc2e5a80c7c6d5c$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $cfc2e5a80c7c6d5c$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $cfc2e5a80c7c6d5c$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $cfc2e5a80c7c6d5c$var$Gi.bind(null, $cfc2e5a80c7c6d5c$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $cfc2e5a80c7c6d5c$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $cfc2e5a80c7c6d5c$var$qi,
    useDebugValue: $cfc2e5a80c7c6d5c$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $cfc2e5a80c7c6d5c$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $cfc2e5a80c7c6d5c$var$qi(!1), b = a[0];
        a = $cfc2e5a80c7c6d5c$var$Ei.bind(null, a[1]);
        $cfc2e5a80c7c6d5c$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $cfc2e5a80c7c6d5c$var$N, e = $cfc2e5a80c7c6d5c$var$ci();
        if ($cfc2e5a80c7c6d5c$var$I) {
            if (void 0 === c) throw Error($cfc2e5a80c7c6d5c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $cfc2e5a80c7c6d5c$var$R) throw Error($cfc2e5a80c7c6d5c$var$p(349));
            0 !== ($cfc2e5a80c7c6d5c$var$Rh & 30) || $cfc2e5a80c7c6d5c$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $cfc2e5a80c7c6d5c$var$vi($cfc2e5a80c7c6d5c$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $cfc2e5a80c7c6d5c$var$li(9, $cfc2e5a80c7c6d5c$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $cfc2e5a80c7c6d5c$var$ci(), b = $cfc2e5a80c7c6d5c$var$R.identifierPrefix;
        if ($cfc2e5a80c7c6d5c$var$I) {
            var c = $cfc2e5a80c7c6d5c$var$sg;
            var d = $cfc2e5a80c7c6d5c$var$rg;
            c = (d & ~(1 << 32 - $cfc2e5a80c7c6d5c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $cfc2e5a80c7c6d5c$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $cfc2e5a80c7c6d5c$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $cfc2e5a80c7c6d5c$var$Zh = {
    readContext: $cfc2e5a80c7c6d5c$var$Vg,
    useCallback: $cfc2e5a80c7c6d5c$var$Bi,
    useContext: $cfc2e5a80c7c6d5c$var$Vg,
    useEffect: $cfc2e5a80c7c6d5c$var$ji,
    useImperativeHandle: $cfc2e5a80c7c6d5c$var$zi,
    useInsertionEffect: $cfc2e5a80c7c6d5c$var$wi,
    useLayoutEffect: $cfc2e5a80c7c6d5c$var$xi,
    useMemo: $cfc2e5a80c7c6d5c$var$Ci,
    useReducer: $cfc2e5a80c7c6d5c$var$fi,
    useRef: $cfc2e5a80c7c6d5c$var$si,
    useState: function useState() {
        return $cfc2e5a80c7c6d5c$var$fi($cfc2e5a80c7c6d5c$var$ei);
    },
    useDebugValue: $cfc2e5a80c7c6d5c$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $cfc2e5a80c7c6d5c$var$di();
        return $cfc2e5a80c7c6d5c$var$Di(b, $cfc2e5a80c7c6d5c$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $cfc2e5a80c7c6d5c$var$fi($cfc2e5a80c7c6d5c$var$ei)[0], b = $cfc2e5a80c7c6d5c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $cfc2e5a80c7c6d5c$var$hi,
    useSyncExternalStore: $cfc2e5a80c7c6d5c$var$ii,
    useId: $cfc2e5a80c7c6d5c$var$Fi,
    unstable_isNewReconciler: !1
}, $cfc2e5a80c7c6d5c$var$$h = {
    readContext: $cfc2e5a80c7c6d5c$var$Vg,
    useCallback: $cfc2e5a80c7c6d5c$var$Bi,
    useContext: $cfc2e5a80c7c6d5c$var$Vg,
    useEffect: $cfc2e5a80c7c6d5c$var$ji,
    useImperativeHandle: $cfc2e5a80c7c6d5c$var$zi,
    useInsertionEffect: $cfc2e5a80c7c6d5c$var$wi,
    useLayoutEffect: $cfc2e5a80c7c6d5c$var$xi,
    useMemo: $cfc2e5a80c7c6d5c$var$Ci,
    useReducer: $cfc2e5a80c7c6d5c$var$gi,
    useRef: $cfc2e5a80c7c6d5c$var$si,
    useState: function useState() {
        return $cfc2e5a80c7c6d5c$var$gi($cfc2e5a80c7c6d5c$var$ei);
    },
    useDebugValue: $cfc2e5a80c7c6d5c$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $cfc2e5a80c7c6d5c$var$di();
        return null === $cfc2e5a80c7c6d5c$var$O ? b.memoizedState = a : $cfc2e5a80c7c6d5c$var$Di(b, $cfc2e5a80c7c6d5c$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $cfc2e5a80c7c6d5c$var$gi($cfc2e5a80c7c6d5c$var$ei)[0], b = $cfc2e5a80c7c6d5c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $cfc2e5a80c7c6d5c$var$hi,
    useSyncExternalStore: $cfc2e5a80c7c6d5c$var$ii,
    useId: $cfc2e5a80c7c6d5c$var$Fi,
    unstable_isNewReconciler: !1
};
function $cfc2e5a80c7c6d5c$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $cfc2e5a80c7c6d5c$var$Pa(d), d = d["return"];
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $cfc2e5a80c7c6d5c$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $cfc2e5a80c7c6d5c$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $cfc2e5a80c7c6d5c$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $cfc2e5a80c7c6d5c$var$Oi(a, b, c) {
    c = $cfc2e5a80c7c6d5c$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $cfc2e5a80c7c6d5c$var$Pi || ($cfc2e5a80c7c6d5c$var$Pi = !0, $cfc2e5a80c7c6d5c$var$Qi = d);
        $cfc2e5a80c7c6d5c$var$Mi(a, b);
    };
    return c;
}
function $cfc2e5a80c7c6d5c$var$Ri(a, b, c) {
    c = $cfc2e5a80c7c6d5c$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $cfc2e5a80c7c6d5c$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $cfc2e5a80c7c6d5c$var$Mi(a, b);
        "function" !== typeof d && (null === $cfc2e5a80c7c6d5c$var$Si ? $cfc2e5a80c7c6d5c$var$Si = new Set([
            this
        ]) : $cfc2e5a80c7c6d5c$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $cfc2e5a80c7c6d5c$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $cfc2e5a80c7c6d5c$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $cfc2e5a80c7c6d5c$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $cfc2e5a80c7c6d5c$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a["return"];
    }while (null !== a);
    return null;
}
function $cfc2e5a80c7c6d5c$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $cfc2e5a80c7c6d5c$var$ch(-1, 1), b.tag = 2, $cfc2e5a80c7c6d5c$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $cfc2e5a80c7c6d5c$var$Xi = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentOwner, $cfc2e5a80c7c6d5c$var$Ug = !1;
function $cfc2e5a80c7c6d5c$var$Yi(a, b, c, d) {
    b.child = null === a ? $cfc2e5a80c7c6d5c$var$Ch(b, null, c, d) : $cfc2e5a80c7c6d5c$var$Bh(b, a.child, c, d);
}
function $cfc2e5a80c7c6d5c$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $cfc2e5a80c7c6d5c$var$Tg(b, e);
    d = $cfc2e5a80c7c6d5c$var$Xh(a, b, c, d, f, e);
    c = $cfc2e5a80c7c6d5c$var$bi();
    if (null !== a && !$cfc2e5a80c7c6d5c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $cfc2e5a80c7c6d5c$var$$i(a, b, e);
    $cfc2e5a80c7c6d5c$var$I && c && $cfc2e5a80c7c6d5c$var$vg(b);
    b.flags |= 1;
    $cfc2e5a80c7c6d5c$var$Yi(a, b, d, e);
    return b.child;
}
function $cfc2e5a80c7c6d5c$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$cfc2e5a80c7c6d5c$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $cfc2e5a80c7c6d5c$var$cj(a, b, f, d, e);
        a = $cfc2e5a80c7c6d5c$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a["return"] = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $cfc2e5a80c7c6d5c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $cfc2e5a80c7c6d5c$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $cfc2e5a80c7c6d5c$var$wh(f, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
}
function $cfc2e5a80c7c6d5c$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($cfc2e5a80c7c6d5c$var$Ie(f, d) && a.ref === b.ref) {
            if ($cfc2e5a80c7c6d5c$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($cfc2e5a80c7c6d5c$var$Ug = !0);
            else return b.lanes = a.lanes, $cfc2e5a80c7c6d5c$var$$i(a, b, e);
        }
    }
    return $cfc2e5a80c7c6d5c$var$dj(a, b, c, d, e);
}
function $cfc2e5a80c7c6d5c$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$fj, $cfc2e5a80c7c6d5c$var$gj), $cfc2e5a80c7c6d5c$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$fj, $cfc2e5a80c7c6d5c$var$gj), $cfc2e5a80c7c6d5c$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$fj, $cfc2e5a80c7c6d5c$var$gj);
            $cfc2e5a80c7c6d5c$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$fj, $cfc2e5a80c7c6d5c$var$gj), $cfc2e5a80c7c6d5c$var$gj |= d;
    $cfc2e5a80c7c6d5c$var$Yi(a, b, e, c);
    return b.child;
}
function $cfc2e5a80c7c6d5c$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $cfc2e5a80c7c6d5c$var$dj(a, b, c, d, e) {
    var f = $cfc2e5a80c7c6d5c$var$Zf(c) ? $cfc2e5a80c7c6d5c$var$Xf : $cfc2e5a80c7c6d5c$var$H.current;
    f = $cfc2e5a80c7c6d5c$var$Yf(b, f);
    $cfc2e5a80c7c6d5c$var$Tg(b, e);
    c = $cfc2e5a80c7c6d5c$var$Xh(a, b, c, d, f, e);
    d = $cfc2e5a80c7c6d5c$var$bi();
    if (null !== a && !$cfc2e5a80c7c6d5c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $cfc2e5a80c7c6d5c$var$$i(a, b, e);
    $cfc2e5a80c7c6d5c$var$I && d && $cfc2e5a80c7c6d5c$var$vg(b);
    b.flags |= 1;
    $cfc2e5a80c7c6d5c$var$Yi(a, b, c, e);
    return b.child;
}
function $cfc2e5a80c7c6d5c$var$ij(a, b, c, d, e) {
    if ($cfc2e5a80c7c6d5c$var$Zf(c)) {
        var f = !0;
        $cfc2e5a80c7c6d5c$var$cg(b);
    } else f = !1;
    $cfc2e5a80c7c6d5c$var$Tg(b, e);
    if (null === b.stateNode) $cfc2e5a80c7c6d5c$var$jj(a, b), $cfc2e5a80c7c6d5c$var$ph(b, c, d), $cfc2e5a80c7c6d5c$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $k4vcf._)(l)) && null !== l ? l = $cfc2e5a80c7c6d5c$var$Vg(l) : (l = $cfc2e5a80c7c6d5c$var$Zf(c) ? $cfc2e5a80c7c6d5c$var$Xf : $cfc2e5a80c7c6d5c$var$H.current, l = $cfc2e5a80c7c6d5c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $cfc2e5a80c7c6d5c$var$qh(b, g, d, l);
        $cfc2e5a80c7c6d5c$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $cfc2e5a80c7c6d5c$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $cfc2e5a80c7c6d5c$var$Wf.current || $cfc2e5a80c7c6d5c$var$$g ? ("function" === typeof m && ($cfc2e5a80c7c6d5c$var$kh(b, c, m, d), k = b.memoizedState), (h = $cfc2e5a80c7c6d5c$var$$g || $cfc2e5a80c7c6d5c$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $cfc2e5a80c7c6d5c$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $cfc2e5a80c7c6d5c$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $k4vcf._)(k)) && null !== k ? k = $cfc2e5a80c7c6d5c$var$Vg(k) : (k = $cfc2e5a80c7c6d5c$var$Zf(c) ? $cfc2e5a80c7c6d5c$var$Xf : $cfc2e5a80c7c6d5c$var$H.current, k = $cfc2e5a80c7c6d5c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $cfc2e5a80c7c6d5c$var$qh(b, g, d, k);
        $cfc2e5a80c7c6d5c$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $cfc2e5a80c7c6d5c$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $cfc2e5a80c7c6d5c$var$Wf.current || $cfc2e5a80c7c6d5c$var$$g ? ("function" === typeof y && ($cfc2e5a80c7c6d5c$var$kh(b, c, y, d), n = b.memoizedState), (l = $cfc2e5a80c7c6d5c$var$$g || $cfc2e5a80c7c6d5c$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $cfc2e5a80c7c6d5c$var$kj(a, b, c, d, f, e);
}
function $cfc2e5a80c7c6d5c$var$kj(a, b, c, d, e, f) {
    $cfc2e5a80c7c6d5c$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $cfc2e5a80c7c6d5c$var$dg(b, c, !1), $cfc2e5a80c7c6d5c$var$$i(a, b, f);
    d = b.stateNode;
    $cfc2e5a80c7c6d5c$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $cfc2e5a80c7c6d5c$var$Bh(b, a.child, null, f), b.child = $cfc2e5a80c7c6d5c$var$Bh(b, null, h, f)) : $cfc2e5a80c7c6d5c$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $cfc2e5a80c7c6d5c$var$dg(b, c, !0);
    return b.child;
}
function $cfc2e5a80c7c6d5c$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $cfc2e5a80c7c6d5c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $cfc2e5a80c7c6d5c$var$ag(a, b.context, !1);
    $cfc2e5a80c7c6d5c$var$Ih(a, b.containerInfo);
}
function $cfc2e5a80c7c6d5c$var$mj(a, b, c, d, e) {
    $cfc2e5a80c7c6d5c$var$Ig();
    $cfc2e5a80c7c6d5c$var$Jg(e);
    b.flags |= 256;
    $cfc2e5a80c7c6d5c$var$Yi(a, b, c, d);
    return b.child;
}
var $cfc2e5a80c7c6d5c$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $cfc2e5a80c7c6d5c$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $cfc2e5a80c7c6d5c$var$pj(a, b, c) {
    var d = b.pendingProps, e = $cfc2e5a80c7c6d5c$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, e & 1);
    if (null === a) {
        $cfc2e5a80c7c6d5c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $cfc2e5a80c7c6d5c$var$qj(g, d, 0, null), a = $cfc2e5a80c7c6d5c$var$Ah(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = $cfc2e5a80c7c6d5c$var$oj(c), b.memoizedState = $cfc2e5a80c7c6d5c$var$nj, a) : $cfc2e5a80c7c6d5c$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $cfc2e5a80c7c6d5c$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $cfc2e5a80c7c6d5c$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $cfc2e5a80c7c6d5c$var$wh(h, f) : (f = $cfc2e5a80c7c6d5c$var$Ah(f, g, c, null), f.flags |= 2);
        f["return"] = b;
        d["return"] = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $cfc2e5a80c7c6d5c$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $cfc2e5a80c7c6d5c$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $cfc2e5a80c7c6d5c$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d["return"] = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $cfc2e5a80c7c6d5c$var$rj(a, b) {
    b = $cfc2e5a80c7c6d5c$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b["return"] = a;
    return a.child = b;
}
function $cfc2e5a80c7c6d5c$var$tj(a, b, c, d) {
    null !== d && $cfc2e5a80c7c6d5c$var$Jg(d);
    $cfc2e5a80c7c6d5c$var$Bh(b, a.child, null, c);
    a = $cfc2e5a80c7c6d5c$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $cfc2e5a80c7c6d5c$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $cfc2e5a80c7c6d5c$var$Li(Error($cfc2e5a80c7c6d5c$var$p(422))), $cfc2e5a80c7c6d5c$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $cfc2e5a80c7c6d5c$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $cfc2e5a80c7c6d5c$var$Ah(f, e, g, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $cfc2e5a80c7c6d5c$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $cfc2e5a80c7c6d5c$var$oj(g);
        b.memoizedState = $cfc2e5a80c7c6d5c$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $cfc2e5a80c7c6d5c$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($cfc2e5a80c7c6d5c$var$p(419));
        d = $cfc2e5a80c7c6d5c$var$Li(f, d, void 0);
        return $cfc2e5a80c7c6d5c$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($cfc2e5a80c7c6d5c$var$Ug || h) {
        d = $cfc2e5a80c7c6d5c$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $cfc2e5a80c7c6d5c$var$Zg(a, e), $cfc2e5a80c7c6d5c$var$mh(d, a, e, -1));
        }
        $cfc2e5a80c7c6d5c$var$uj();
        d = $cfc2e5a80c7c6d5c$var$Li(Error($cfc2e5a80c7c6d5c$var$p(421)));
        return $cfc2e5a80c7c6d5c$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $cfc2e5a80c7c6d5c$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $cfc2e5a80c7c6d5c$var$yg = $cfc2e5a80c7c6d5c$var$Lf(e.nextSibling);
    $cfc2e5a80c7c6d5c$var$xg = b;
    $cfc2e5a80c7c6d5c$var$I = !0;
    $cfc2e5a80c7c6d5c$var$zg = null;
    null !== a && ($cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg++] = $cfc2e5a80c7c6d5c$var$rg, $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg++] = $cfc2e5a80c7c6d5c$var$sg, $cfc2e5a80c7c6d5c$var$og[$cfc2e5a80c7c6d5c$var$pg++] = $cfc2e5a80c7c6d5c$var$qg, $cfc2e5a80c7c6d5c$var$rg = a.id, $cfc2e5a80c7c6d5c$var$sg = a.overflow, $cfc2e5a80c7c6d5c$var$qg = b);
    b = $cfc2e5a80c7c6d5c$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $cfc2e5a80c7c6d5c$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $cfc2e5a80c7c6d5c$var$Sg(a["return"], b, c);
}
function $cfc2e5a80c7c6d5c$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $cfc2e5a80c7c6d5c$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $cfc2e5a80c7c6d5c$var$Yi(a, b, d.children, c);
    d = $cfc2e5a80c7c6d5c$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $cfc2e5a80c7c6d5c$var$wj(a, c, b);
            else if (19 === a.tag) $cfc2e5a80c7c6d5c$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child["return"] = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a["return"] || a["return"] === b) break a;
                a = a["return"];
            }
            a.sibling["return"] = a["return"];
            a = a.sibling;
        }
        d &= 1;
    }
    $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $cfc2e5a80c7c6d5c$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $cfc2e5a80c7c6d5c$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $cfc2e5a80c7c6d5c$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $cfc2e5a80c7c6d5c$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $cfc2e5a80c7c6d5c$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $cfc2e5a80c7c6d5c$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $cfc2e5a80c7c6d5c$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $cfc2e5a80c7c6d5c$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($cfc2e5a80c7c6d5c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $cfc2e5a80c7c6d5c$var$wh(a, a.pendingProps);
        b.child = c;
        for(c["return"] = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $cfc2e5a80c7c6d5c$var$wh(a, a.pendingProps), c["return"] = b;
        c.sibling = null;
    }
    return b.child;
}
function $cfc2e5a80c7c6d5c$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $cfc2e5a80c7c6d5c$var$lj(b);
            $cfc2e5a80c7c6d5c$var$Ig();
            break;
        case 5:
            $cfc2e5a80c7c6d5c$var$Kh(b);
            break;
        case 1:
            $cfc2e5a80c7c6d5c$var$Zf(b.type) && $cfc2e5a80c7c6d5c$var$cg(b);
            break;
        case 4:
            $cfc2e5a80c7c6d5c$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, $cfc2e5a80c7c6d5c$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $cfc2e5a80c7c6d5c$var$pj(a, b, c);
                $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, $cfc2e5a80c7c6d5c$var$M.current & 1);
                a = $cfc2e5a80c7c6d5c$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, $cfc2e5a80c7c6d5c$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $cfc2e5a80c7c6d5c$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, $cfc2e5a80c7c6d5c$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $cfc2e5a80c7c6d5c$var$ej(a, b, c);
    }
    return $cfc2e5a80c7c6d5c$var$$i(a, b, c);
}
var $cfc2e5a80c7c6d5c$var$Aj, $cfc2e5a80c7c6d5c$var$Bj, $cfc2e5a80c7c6d5c$var$Cj, $cfc2e5a80c7c6d5c$var$Dj;
$cfc2e5a80c7c6d5c$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child["return"] = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c["return"] || c["return"] === b) return;
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        c = c.sibling;
    }
};
$cfc2e5a80c7c6d5c$var$Bj = function Bj() {};
$cfc2e5a80c7c6d5c$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $cfc2e5a80c7c6d5c$var$Ya(a, e);
                d = $cfc2e5a80c7c6d5c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $cfc2e5a80c7c6d5c$var$A({}, e, {
                    value: void 0
                });
                d = $cfc2e5a80c7c6d5c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $cfc2e5a80c7c6d5c$var$gb(a, e);
                d = $cfc2e5a80c7c6d5c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $cfc2e5a80c7c6d5c$var$Bf);
        }
        $cfc2e5a80c7c6d5c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($cfc2e5a80c7c6d5c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($cfc2e5a80c7c6d5c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $cfc2e5a80c7c6d5c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$cfc2e5a80c7c6d5c$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $cfc2e5a80c7c6d5c$var$Ej(a, b) {
    if (!$cfc2e5a80c7c6d5c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $cfc2e5a80c7c6d5c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $cfc2e5a80c7c6d5c$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $cfc2e5a80c7c6d5c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $cfc2e5a80c7c6d5c$var$S(b), null;
        case 1:
            return $cfc2e5a80c7c6d5c$var$Zf(b.type) && $cfc2e5a80c7c6d5c$var$$f(), $cfc2e5a80c7c6d5c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $cfc2e5a80c7c6d5c$var$Jh();
            $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Wf);
            $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$H);
            $cfc2e5a80c7c6d5c$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $cfc2e5a80c7c6d5c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $cfc2e5a80c7c6d5c$var$zg && ($cfc2e5a80c7c6d5c$var$Gj($cfc2e5a80c7c6d5c$var$zg), $cfc2e5a80c7c6d5c$var$zg = null));
            $cfc2e5a80c7c6d5c$var$Bj(a, b);
            $cfc2e5a80c7c6d5c$var$S(b);
            return null;
        case 5:
            $cfc2e5a80c7c6d5c$var$Lh(b);
            var e = $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $cfc2e5a80c7c6d5c$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($cfc2e5a80c7c6d5c$var$p(166));
                    $cfc2e5a80c7c6d5c$var$S(b);
                    return null;
                }
                a = $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Eh.current);
                if ($cfc2e5a80c7c6d5c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$cfc2e5a80c7c6d5c$var$Of] = b;
                    d[$cfc2e5a80c7c6d5c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $cfc2e5a80c7c6d5c$var$D("cancel", d);
                            $cfc2e5a80c7c6d5c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $cfc2e5a80c7c6d5c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $cfc2e5a80c7c6d5c$var$lf.length; e++)$cfc2e5a80c7c6d5c$var$D($cfc2e5a80c7c6d5c$var$lf[e], d);
                            break;
                        case "source":
                            $cfc2e5a80c7c6d5c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $cfc2e5a80c7c6d5c$var$D("error", d);
                            $cfc2e5a80c7c6d5c$var$D("load", d);
                            break;
                        case "details":
                            $cfc2e5a80c7c6d5c$var$D("toggle", d);
                            break;
                        case "input":
                            $cfc2e5a80c7c6d5c$var$Za(d, f);
                            $cfc2e5a80c7c6d5c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $cfc2e5a80c7c6d5c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $cfc2e5a80c7c6d5c$var$hb(d, f), $cfc2e5a80c7c6d5c$var$D("invalid", d);
                    }
                    $cfc2e5a80c7c6d5c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $cfc2e5a80c7c6d5c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $cfc2e5a80c7c6d5c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $cfc2e5a80c7c6d5c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $cfc2e5a80c7c6d5c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $cfc2e5a80c7c6d5c$var$Va(d);
                            $cfc2e5a80c7c6d5c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $cfc2e5a80c7c6d5c$var$Va(d);
                            $cfc2e5a80c7c6d5c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $cfc2e5a80c7c6d5c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $cfc2e5a80c7c6d5c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$cfc2e5a80c7c6d5c$var$Of] = b;
                    a[$cfc2e5a80c7c6d5c$var$Pf] = d;
                    $cfc2e5a80c7c6d5c$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $cfc2e5a80c7c6d5c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $cfc2e5a80c7c6d5c$var$D("cancel", a);
                                $cfc2e5a80c7c6d5c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $cfc2e5a80c7c6d5c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $cfc2e5a80c7c6d5c$var$lf.length; e++)$cfc2e5a80c7c6d5c$var$D($cfc2e5a80c7c6d5c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $cfc2e5a80c7c6d5c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $cfc2e5a80c7c6d5c$var$D("error", a);
                                $cfc2e5a80c7c6d5c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $cfc2e5a80c7c6d5c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $cfc2e5a80c7c6d5c$var$Za(a, d);
                                e = $cfc2e5a80c7c6d5c$var$Ya(a, d);
                                $cfc2e5a80c7c6d5c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $cfc2e5a80c7c6d5c$var$A({}, d, {
                                    value: void 0
                                });
                                $cfc2e5a80c7c6d5c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $cfc2e5a80c7c6d5c$var$hb(a, d);
                                e = $cfc2e5a80c7c6d5c$var$gb(a, d);
                                $cfc2e5a80c7c6d5c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $cfc2e5a80c7c6d5c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $cfc2e5a80c7c6d5c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $cfc2e5a80c7c6d5c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $cfc2e5a80c7c6d5c$var$ob(a, k) : "number" === typeof k && $cfc2e5a80c7c6d5c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($cfc2e5a80c7c6d5c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $cfc2e5a80c7c6d5c$var$D("scroll", a) : null != k && $cfc2e5a80c7c6d5c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $cfc2e5a80c7c6d5c$var$Va(a);
                                $cfc2e5a80c7c6d5c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $cfc2e5a80c7c6d5c$var$Va(a);
                                $cfc2e5a80c7c6d5c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $cfc2e5a80c7c6d5c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $cfc2e5a80c7c6d5c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $cfc2e5a80c7c6d5c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $cfc2e5a80c7c6d5c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $cfc2e5a80c7c6d5c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $cfc2e5a80c7c6d5c$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($cfc2e5a80c7c6d5c$var$p(166));
                c = $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Gh.current);
                $cfc2e5a80c7c6d5c$var$Hh($cfc2e5a80c7c6d5c$var$Eh.current);
                if ($cfc2e5a80c7c6d5c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$cfc2e5a80c7c6d5c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $cfc2e5a80c7c6d5c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $cfc2e5a80c7c6d5c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $cfc2e5a80c7c6d5c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$cfc2e5a80c7c6d5c$var$Of] = b, b.stateNode = d;
            }
            $cfc2e5a80c7c6d5c$var$S(b);
            return null;
        case 13:
            $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($cfc2e5a80c7c6d5c$var$I && null !== $cfc2e5a80c7c6d5c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $cfc2e5a80c7c6d5c$var$Hg(), $cfc2e5a80c7c6d5c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $cfc2e5a80c7c6d5c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($cfc2e5a80c7c6d5c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($cfc2e5a80c7c6d5c$var$p(317));
                        f[$cfc2e5a80c7c6d5c$var$Of] = b;
                    } else $cfc2e5a80c7c6d5c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $cfc2e5a80c7c6d5c$var$S(b);
                    f = !1;
                } else null !== $cfc2e5a80c7c6d5c$var$zg && ($cfc2e5a80c7c6d5c$var$Gj($cfc2e5a80c7c6d5c$var$zg), $cfc2e5a80c7c6d5c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($cfc2e5a80c7c6d5c$var$M.current & 1) ? 0 === $cfc2e5a80c7c6d5c$var$T && ($cfc2e5a80c7c6d5c$var$T = 3) : $cfc2e5a80c7c6d5c$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $cfc2e5a80c7c6d5c$var$S(b);
            return null;
        case 4:
            return $cfc2e5a80c7c6d5c$var$Jh(), $cfc2e5a80c7c6d5c$var$Bj(a, b), null === a && $cfc2e5a80c7c6d5c$var$sf(b.stateNode.containerInfo), $cfc2e5a80c7c6d5c$var$S(b), null;
        case 10:
            return $cfc2e5a80c7c6d5c$var$Rg(b.type._context), $cfc2e5a80c7c6d5c$var$S(b), null;
        case 17:
            return $cfc2e5a80c7c6d5c$var$Zf(b.type) && $cfc2e5a80c7c6d5c$var$$f(), $cfc2e5a80c7c6d5c$var$S(b), null;
        case 19:
            $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$M);
            f = b.memoizedState;
            if (null === f) return $cfc2e5a80c7c6d5c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $cfc2e5a80c7c6d5c$var$Ej(f, !1);
                else {
                    if (0 !== $cfc2e5a80c7c6d5c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $cfc2e5a80c7c6d5c$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $cfc2e5a80c7c6d5c$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, $cfc2e5a80c7c6d5c$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $cfc2e5a80c7c6d5c$var$B() > $cfc2e5a80c7c6d5c$var$Hj && (b.flags |= 128, d = !0, $cfc2e5a80c7c6d5c$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $cfc2e5a80c7c6d5c$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $cfc2e5a80c7c6d5c$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$cfc2e5a80c7c6d5c$var$I) return $cfc2e5a80c7c6d5c$var$S(b), null;
                    } else 2 * $cfc2e5a80c7c6d5c$var$B() - f.renderingStartTime > $cfc2e5a80c7c6d5c$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $cfc2e5a80c7c6d5c$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $cfc2e5a80c7c6d5c$var$B(), b.sibling = null, c = $cfc2e5a80c7c6d5c$var$M.current, $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$M, d ? c & 1 | 2 : c & 1), b;
            $cfc2e5a80c7c6d5c$var$S(b);
            return null;
        case 22:
        case 23:
            return $cfc2e5a80c7c6d5c$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($cfc2e5a80c7c6d5c$var$gj & 1073741824) && ($cfc2e5a80c7c6d5c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $cfc2e5a80c7c6d5c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($cfc2e5a80c7c6d5c$var$p(156, b.tag));
}
function $cfc2e5a80c7c6d5c$var$Jj(a, b) {
    $cfc2e5a80c7c6d5c$var$wg(b);
    switch(b.tag){
        case 1:
            return $cfc2e5a80c7c6d5c$var$Zf(b.type) && $cfc2e5a80c7c6d5c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $cfc2e5a80c7c6d5c$var$Jh(), $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Wf), $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$H), $cfc2e5a80c7c6d5c$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $cfc2e5a80c7c6d5c$var$Lh(b), null;
        case 13:
            $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($cfc2e5a80c7c6d5c$var$p(340));
                $cfc2e5a80c7c6d5c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$M), null;
        case 4:
            return $cfc2e5a80c7c6d5c$var$Jh(), null;
        case 10:
            return $cfc2e5a80c7c6d5c$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $cfc2e5a80c7c6d5c$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $cfc2e5a80c7c6d5c$var$Kj = !1, $cfc2e5a80c7c6d5c$var$U = !1, $cfc2e5a80c7c6d5c$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $cfc2e5a80c7c6d5c$var$V = null;
function $cfc2e5a80c7c6d5c$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $cfc2e5a80c7c6d5c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $cfc2e5a80c7c6d5c$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $cfc2e5a80c7c6d5c$var$W(a, b, d);
    }
}
var $cfc2e5a80c7c6d5c$var$Oj = !1;
function $cfc2e5a80c7c6d5c$var$Pj(a, b) {
    $cfc2e5a80c7c6d5c$var$Cf = $cfc2e5a80c7c6d5c$var$dd;
    a = $cfc2e5a80c7c6d5c$var$Me();
    if ($cfc2e5a80c7c6d5c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $cfc2e5a80c7c6d5c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $cfc2e5a80c7c6d5c$var$dd = !1;
    for($cfc2e5a80c7c6d5c$var$V = b; null !== $cfc2e5a80c7c6d5c$var$V;)if (b = $cfc2e5a80c7c6d5c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, $cfc2e5a80c7c6d5c$var$V = a;
    else for(; null !== $cfc2e5a80c7c6d5c$var$V;){
        b = $cfc2e5a80c7c6d5c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $cfc2e5a80c7c6d5c$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($cfc2e5a80c7c6d5c$var$p(163));
            }
        } catch (F) {
            $cfc2e5a80c7c6d5c$var$W(b, b["return"], F);
        }
        a = b.sibling;
        if (null !== a) {
            a["return"] = b["return"];
            $cfc2e5a80c7c6d5c$var$V = a;
            break;
        }
        $cfc2e5a80c7c6d5c$var$V = b["return"];
    }
    n = $cfc2e5a80c7c6d5c$var$Oj;
    $cfc2e5a80c7c6d5c$var$Oj = !1;
    return n;
}
function $cfc2e5a80c7c6d5c$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $cfc2e5a80c7c6d5c$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $cfc2e5a80c7c6d5c$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $cfc2e5a80c7c6d5c$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $cfc2e5a80c7c6d5c$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $cfc2e5a80c7c6d5c$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$cfc2e5a80c7c6d5c$var$Of], delete b[$cfc2e5a80c7c6d5c$var$Pf], delete b[$cfc2e5a80c7c6d5c$var$of], delete b[$cfc2e5a80c7c6d5c$var$Qf], delete b[$cfc2e5a80c7c6d5c$var$Rf]));
    a.stateNode = null;
    a["return"] = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $cfc2e5a80c7c6d5c$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $cfc2e5a80c7c6d5c$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a["return"] || $cfc2e5a80c7c6d5c$var$Uj(a["return"])) return null;
            a = a["return"];
        }
        a.sibling["return"] = a["return"];
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child["return"] = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $cfc2e5a80c7c6d5c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $cfc2e5a80c7c6d5c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($cfc2e5a80c7c6d5c$var$Wj(a, b, c), a = a.sibling; null !== a;)$cfc2e5a80c7c6d5c$var$Wj(a, b, c), a = a.sibling;
}
function $cfc2e5a80c7c6d5c$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($cfc2e5a80c7c6d5c$var$Xj(a, b, c), a = a.sibling; null !== a;)$cfc2e5a80c7c6d5c$var$Xj(a, b, c), a = a.sibling;
}
var $cfc2e5a80c7c6d5c$var$X = null, $cfc2e5a80c7c6d5c$var$Yj = !1;
function $cfc2e5a80c7c6d5c$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$cfc2e5a80c7c6d5c$var$ak(a, b, c), c = c.sibling;
}
function $cfc2e5a80c7c6d5c$var$ak(a, b, c) {
    if ($cfc2e5a80c7c6d5c$var$lc && "function" === typeof $cfc2e5a80c7c6d5c$var$lc.onCommitFiberUnmount) try {
        $cfc2e5a80c7c6d5c$var$lc.onCommitFiberUnmount($cfc2e5a80c7c6d5c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $cfc2e5a80c7c6d5c$var$U || $cfc2e5a80c7c6d5c$var$Mj(c, b);
        case 6:
            var d = $cfc2e5a80c7c6d5c$var$X, e = $cfc2e5a80c7c6d5c$var$Yj;
            $cfc2e5a80c7c6d5c$var$X = null;
            $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
            $cfc2e5a80c7c6d5c$var$X = d;
            $cfc2e5a80c7c6d5c$var$Yj = e;
            null !== $cfc2e5a80c7c6d5c$var$X && ($cfc2e5a80c7c6d5c$var$Yj ? (a = $cfc2e5a80c7c6d5c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $cfc2e5a80c7c6d5c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $cfc2e5a80c7c6d5c$var$X && ($cfc2e5a80c7c6d5c$var$Yj ? (a = $cfc2e5a80c7c6d5c$var$X, c = c.stateNode, 8 === a.nodeType ? $cfc2e5a80c7c6d5c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $cfc2e5a80c7c6d5c$var$Kf(a, c), $cfc2e5a80c7c6d5c$var$bd(a)) : $cfc2e5a80c7c6d5c$var$Kf($cfc2e5a80c7c6d5c$var$X, c.stateNode));
            break;
        case 4:
            d = $cfc2e5a80c7c6d5c$var$X;
            e = $cfc2e5a80c7c6d5c$var$Yj;
            $cfc2e5a80c7c6d5c$var$X = c.stateNode.containerInfo;
            $cfc2e5a80c7c6d5c$var$Yj = !0;
            $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
            $cfc2e5a80c7c6d5c$var$X = d;
            $cfc2e5a80c7c6d5c$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$cfc2e5a80c7c6d5c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $cfc2e5a80c7c6d5c$var$Nj(c, b, g) : 0 !== (f & 4) && $cfc2e5a80c7c6d5c$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
            break;
        case 1:
            if (!$cfc2e5a80c7c6d5c$var$U && ($cfc2e5a80c7c6d5c$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $cfc2e5a80c7c6d5c$var$W(c, b, h);
            }
            $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
            break;
        case 21:
            $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($cfc2e5a80c7c6d5c$var$U = (d = $cfc2e5a80c7c6d5c$var$U) || null !== c.memoizedState, $cfc2e5a80c7c6d5c$var$Zj(a, b, c), $cfc2e5a80c7c6d5c$var$U = d) : $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
            break;
        default:
            $cfc2e5a80c7c6d5c$var$Zj(a, b, c);
    }
}
function $cfc2e5a80c7c6d5c$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $cfc2e5a80c7c6d5c$var$Lj);
        b.forEach(function(b) {
            var d = $cfc2e5a80c7c6d5c$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $cfc2e5a80c7c6d5c$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $cfc2e5a80c7c6d5c$var$X = h.stateNode;
                        $cfc2e5a80c7c6d5c$var$Yj = !1;
                        break a;
                    case 3:
                        $cfc2e5a80c7c6d5c$var$X = h.stateNode.containerInfo;
                        $cfc2e5a80c7c6d5c$var$Yj = !0;
                        break a;
                    case 4:
                        $cfc2e5a80c7c6d5c$var$X = h.stateNode.containerInfo;
                        $cfc2e5a80c7c6d5c$var$Yj = !0;
                        break a;
                }
                h = h["return"];
            }
            if (null === $cfc2e5a80c7c6d5c$var$X) throw Error($cfc2e5a80c7c6d5c$var$p(160));
            $cfc2e5a80c7c6d5c$var$ak(f, g, e);
            $cfc2e5a80c7c6d5c$var$X = null;
            $cfc2e5a80c7c6d5c$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k["return"] = null);
            e["return"] = null;
        } catch (l) {
            $cfc2e5a80c7c6d5c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$cfc2e5a80c7c6d5c$var$ek(b, a), b = b.sibling;
}
function $cfc2e5a80c7c6d5c$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            if (d & 4) {
                try {
                    $cfc2e5a80c7c6d5c$var$Qj(3, a, a["return"]), $cfc2e5a80c7c6d5c$var$Rj(3, a);
                } catch (t) {
                    $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                }
                try {
                    $cfc2e5a80c7c6d5c$var$Qj(5, a, a["return"]);
                } catch (t) {
                    $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                }
            }
            break;
        case 1:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            d & 512 && null !== c && $cfc2e5a80c7c6d5c$var$Mj(c, c["return"]);
            break;
        case 5:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            d & 512 && null !== c && $cfc2e5a80c7c6d5c$var$Mj(c, c["return"]);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $cfc2e5a80c7c6d5c$var$ob(e, "");
                } catch (t) {
                    $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $cfc2e5a80c7c6d5c$var$ab(e, f);
                    $cfc2e5a80c7c6d5c$var$vb(h, g);
                    var l = $cfc2e5a80c7c6d5c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $cfc2e5a80c7c6d5c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $cfc2e5a80c7c6d5c$var$nb(e, q) : "children" === m ? $cfc2e5a80c7c6d5c$var$ob(e, q) : $cfc2e5a80c7c6d5c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $cfc2e5a80c7c6d5c$var$bb(e, f);
                            break;
                        case "textarea":
                            $cfc2e5a80c7c6d5c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $cfc2e5a80c7c6d5c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $cfc2e5a80c7c6d5c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $cfc2e5a80c7c6d5c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$cfc2e5a80c7c6d5c$var$Pf] = f;
                } catch (t) {
                    $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                }
            }
            break;
        case 6:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($cfc2e5a80c7c6d5c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                }
            }
            break;
        case 3:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $cfc2e5a80c7c6d5c$var$bd(b.containerInfo);
            } catch (t) {
                $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
            }
            break;
        case 4:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            break;
        case 13:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($cfc2e5a80c7c6d5c$var$gk = $cfc2e5a80c7c6d5c$var$B()));
            d & 4 && $cfc2e5a80c7c6d5c$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($cfc2e5a80c7c6d5c$var$U = (l = $cfc2e5a80c7c6d5c$var$U) || m, $cfc2e5a80c7c6d5c$var$dk(b, a), $cfc2e5a80c7c6d5c$var$U = l) : $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($cfc2e5a80c7c6d5c$var$V = a, m = a.child; null !== m;){
                    for(q = $cfc2e5a80c7c6d5c$var$V = m; null !== $cfc2e5a80c7c6d5c$var$V;){
                        r = $cfc2e5a80c7c6d5c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $cfc2e5a80c7c6d5c$var$Qj(4, r, r["return"]);
                                break;
                            case 1:
                                $cfc2e5a80c7c6d5c$var$Mj(r, r["return"]);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r["return"];
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $cfc2e5a80c7c6d5c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $cfc2e5a80c7c6d5c$var$Mj(r, r["return"]);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $cfc2e5a80c7c6d5c$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y["return"] = r, $cfc2e5a80c7c6d5c$var$V = y) : $cfc2e5a80c7c6d5c$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $cfc2e5a80c7c6d5c$var$rb("display", g));
                            } catch (t) {
                                $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $cfc2e5a80c7c6d5c$var$W(a, a["return"], t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child["return"] = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q["return"] || q["return"] === a) break a;
                        m === q && (m = null);
                        q = q["return"];
                    }
                    m === q && (m = null);
                    q.sibling["return"] = q["return"];
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $cfc2e5a80c7c6d5c$var$dk(b, a);
            $cfc2e5a80c7c6d5c$var$fk(a);
            d & 4 && $cfc2e5a80c7c6d5c$var$bk(a);
            break;
        case 21:
            break;
        default:
            $cfc2e5a80c7c6d5c$var$dk(b, a), $cfc2e5a80c7c6d5c$var$fk(a);
    }
}
function $cfc2e5a80c7c6d5c$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a["return"]; null !== c;){
                    if ($cfc2e5a80c7c6d5c$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c["return"];
                }
                throw Error($cfc2e5a80c7c6d5c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($cfc2e5a80c7c6d5c$var$ob(e, ""), d.flags &= -33);
                    var f = $cfc2e5a80c7c6d5c$var$Vj(a);
                    $cfc2e5a80c7c6d5c$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $cfc2e5a80c7c6d5c$var$Vj(a);
                    $cfc2e5a80c7c6d5c$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($cfc2e5a80c7c6d5c$var$p(161));
            }
        } catch (k) {
            $cfc2e5a80c7c6d5c$var$W(a, a["return"], k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $cfc2e5a80c7c6d5c$var$ik(a, b, c) {
    $cfc2e5a80c7c6d5c$var$V = a;
    $cfc2e5a80c7c6d5c$var$jk(a, b, c);
}
function $cfc2e5a80c7c6d5c$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $cfc2e5a80c7c6d5c$var$V;){
        var e = $cfc2e5a80c7c6d5c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $cfc2e5a80c7c6d5c$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $cfc2e5a80c7c6d5c$var$U;
                h = $cfc2e5a80c7c6d5c$var$Kj;
                var l = $cfc2e5a80c7c6d5c$var$U;
                $cfc2e5a80c7c6d5c$var$Kj = g;
                if (($cfc2e5a80c7c6d5c$var$U = k) && !l) for($cfc2e5a80c7c6d5c$var$V = e; null !== $cfc2e5a80c7c6d5c$var$V;)g = $cfc2e5a80c7c6d5c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $cfc2e5a80c7c6d5c$var$kk(e) : null !== k ? (k["return"] = g, $cfc2e5a80c7c6d5c$var$V = k) : $cfc2e5a80c7c6d5c$var$kk(e);
                for(; null !== f;)$cfc2e5a80c7c6d5c$var$V = f, $cfc2e5a80c7c6d5c$var$jk(f, b, c), f = f.sibling;
                $cfc2e5a80c7c6d5c$var$V = e;
                $cfc2e5a80c7c6d5c$var$Kj = h;
                $cfc2e5a80c7c6d5c$var$U = l;
            }
            $cfc2e5a80c7c6d5c$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, $cfc2e5a80c7c6d5c$var$V = f) : $cfc2e5a80c7c6d5c$var$lk(a, b, c);
    }
}
function $cfc2e5a80c7c6d5c$var$lk(a) {
    for(; null !== $cfc2e5a80c7c6d5c$var$V;){
        var b = $cfc2e5a80c7c6d5c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $cfc2e5a80c7c6d5c$var$U || $cfc2e5a80c7c6d5c$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$cfc2e5a80c7c6d5c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $cfc2e5a80c7c6d5c$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $cfc2e5a80c7c6d5c$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $cfc2e5a80c7c6d5c$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $cfc2e5a80c7c6d5c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($cfc2e5a80c7c6d5c$var$p(163));
                }
                $cfc2e5a80c7c6d5c$var$U || b.flags & 512 && $cfc2e5a80c7c6d5c$var$Sj(b);
            } catch (r) {
                $cfc2e5a80c7c6d5c$var$W(b, b["return"], r);
            }
        }
        if (b === a) {
            $cfc2e5a80c7c6d5c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $cfc2e5a80c7c6d5c$var$V = c;
            break;
        }
        $cfc2e5a80c7c6d5c$var$V = b["return"];
    }
}
function $cfc2e5a80c7c6d5c$var$hk(a) {
    for(; null !== $cfc2e5a80c7c6d5c$var$V;){
        var b = $cfc2e5a80c7c6d5c$var$V;
        if (b === a) {
            $cfc2e5a80c7c6d5c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $cfc2e5a80c7c6d5c$var$V = c;
            break;
        }
        $cfc2e5a80c7c6d5c$var$V = b["return"];
    }
}
function $cfc2e5a80c7c6d5c$var$kk(a) {
    for(; null !== $cfc2e5a80c7c6d5c$var$V;){
        var b = $cfc2e5a80c7c6d5c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b["return"];
                    try {
                        $cfc2e5a80c7c6d5c$var$Rj(4, b);
                    } catch (k) {
                        $cfc2e5a80c7c6d5c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b["return"];
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $cfc2e5a80c7c6d5c$var$W(b, e, k);
                        }
                    }
                    var f = b["return"];
                    try {
                        $cfc2e5a80c7c6d5c$var$Sj(b);
                    } catch (k) {
                        $cfc2e5a80c7c6d5c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b["return"];
                    try {
                        $cfc2e5a80c7c6d5c$var$Sj(b);
                    } catch (k) {
                        $cfc2e5a80c7c6d5c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $cfc2e5a80c7c6d5c$var$W(b, b["return"], k);
        }
        if (b === a) {
            $cfc2e5a80c7c6d5c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h["return"] = b["return"];
            $cfc2e5a80c7c6d5c$var$V = h;
            break;
        }
        $cfc2e5a80c7c6d5c$var$V = b["return"];
    }
}
var $cfc2e5a80c7c6d5c$var$mk = Math.ceil, $cfc2e5a80c7c6d5c$var$nk = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentDispatcher, $cfc2e5a80c7c6d5c$var$ok = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentOwner, $cfc2e5a80c7c6d5c$var$pk = $cfc2e5a80c7c6d5c$var$ua.ReactCurrentBatchConfig, $cfc2e5a80c7c6d5c$var$K = 0, $cfc2e5a80c7c6d5c$var$R = null, $cfc2e5a80c7c6d5c$var$Y = null, $cfc2e5a80c7c6d5c$var$Z = 0, $cfc2e5a80c7c6d5c$var$gj = 0, $cfc2e5a80c7c6d5c$var$fj = $cfc2e5a80c7c6d5c$var$Uf(0), $cfc2e5a80c7c6d5c$var$T = 0, $cfc2e5a80c7c6d5c$var$qk = null, $cfc2e5a80c7c6d5c$var$hh = 0, $cfc2e5a80c7c6d5c$var$rk = 0, $cfc2e5a80c7c6d5c$var$sk = 0, $cfc2e5a80c7c6d5c$var$tk = null, $cfc2e5a80c7c6d5c$var$uk = null, $cfc2e5a80c7c6d5c$var$gk = 0, $cfc2e5a80c7c6d5c$var$Hj = Infinity, $cfc2e5a80c7c6d5c$var$vk = null, $cfc2e5a80c7c6d5c$var$Pi = !1, $cfc2e5a80c7c6d5c$var$Qi = null, $cfc2e5a80c7c6d5c$var$Si = null, $cfc2e5a80c7c6d5c$var$wk = !1, $cfc2e5a80c7c6d5c$var$xk = null, $cfc2e5a80c7c6d5c$var$yk = 0, $cfc2e5a80c7c6d5c$var$zk = 0, $cfc2e5a80c7c6d5c$var$Ak = null, $cfc2e5a80c7c6d5c$var$Bk = -1, $cfc2e5a80c7c6d5c$var$Ck = 0;
function $cfc2e5a80c7c6d5c$var$L() {
    return 0 !== ($cfc2e5a80c7c6d5c$var$K & 6) ? $cfc2e5a80c7c6d5c$var$B() : -1 !== $cfc2e5a80c7c6d5c$var$Bk ? $cfc2e5a80c7c6d5c$var$Bk : $cfc2e5a80c7c6d5c$var$Bk = $cfc2e5a80c7c6d5c$var$B();
}
function $cfc2e5a80c7c6d5c$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($cfc2e5a80c7c6d5c$var$K & 2) && 0 !== $cfc2e5a80c7c6d5c$var$Z) return $cfc2e5a80c7c6d5c$var$Z & -$cfc2e5a80c7c6d5c$var$Z;
    if (null !== $cfc2e5a80c7c6d5c$var$Kg.transition) return 0 === $cfc2e5a80c7c6d5c$var$Ck && ($cfc2e5a80c7c6d5c$var$Ck = $cfc2e5a80c7c6d5c$var$yc()), $cfc2e5a80c7c6d5c$var$Ck;
    a = $cfc2e5a80c7c6d5c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $cfc2e5a80c7c6d5c$var$jd(a.type);
    return a;
}
function $cfc2e5a80c7c6d5c$var$mh(a, b, c, d) {
    if (50 < $cfc2e5a80c7c6d5c$var$zk) throw $cfc2e5a80c7c6d5c$var$zk = 0, $cfc2e5a80c7c6d5c$var$Ak = null, Error($cfc2e5a80c7c6d5c$var$p(185));
    $cfc2e5a80c7c6d5c$var$Ac(a, c, d);
    if (0 === ($cfc2e5a80c7c6d5c$var$K & 2) || a !== $cfc2e5a80c7c6d5c$var$R) a === $cfc2e5a80c7c6d5c$var$R && (0 === ($cfc2e5a80c7c6d5c$var$K & 2) && ($cfc2e5a80c7c6d5c$var$rk |= c), 4 === $cfc2e5a80c7c6d5c$var$T && $cfc2e5a80c7c6d5c$var$Dk(a, $cfc2e5a80c7c6d5c$var$Z)), $cfc2e5a80c7c6d5c$var$Ek(a, d), 1 === c && 0 === $cfc2e5a80c7c6d5c$var$K && 0 === (b.mode & 1) && ($cfc2e5a80c7c6d5c$var$Hj = $cfc2e5a80c7c6d5c$var$B() + 500, $cfc2e5a80c7c6d5c$var$fg && $cfc2e5a80c7c6d5c$var$jg());
}
function $cfc2e5a80c7c6d5c$var$Ek(a, b) {
    var c = a.callbackNode;
    $cfc2e5a80c7c6d5c$var$wc(a, b);
    var d = $cfc2e5a80c7c6d5c$var$uc(a, a === $cfc2e5a80c7c6d5c$var$R ? $cfc2e5a80c7c6d5c$var$Z : 0);
    if (0 === d) null !== c && $cfc2e5a80c7c6d5c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $cfc2e5a80c7c6d5c$var$bc(c);
        if (1 === b) 0 === a.tag ? $cfc2e5a80c7c6d5c$var$ig($cfc2e5a80c7c6d5c$var$Fk.bind(null, a)) : $cfc2e5a80c7c6d5c$var$hg($cfc2e5a80c7c6d5c$var$Fk.bind(null, a)), $cfc2e5a80c7c6d5c$var$Jf(function() {
            0 === ($cfc2e5a80c7c6d5c$var$K & 6) && $cfc2e5a80c7c6d5c$var$jg();
        }), c = null;
        else {
            switch($cfc2e5a80c7c6d5c$var$Dc(d)){
                case 1:
                    c = $cfc2e5a80c7c6d5c$var$fc;
                    break;
                case 4:
                    c = $cfc2e5a80c7c6d5c$var$gc;
                    break;
                case 16:
                    c = $cfc2e5a80c7c6d5c$var$hc;
                    break;
                case 536870912:
                    c = $cfc2e5a80c7c6d5c$var$jc;
                    break;
                default:
                    c = $cfc2e5a80c7c6d5c$var$hc;
            }
            c = $cfc2e5a80c7c6d5c$var$Gk(c, $cfc2e5a80c7c6d5c$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $cfc2e5a80c7c6d5c$var$Hk(a, b) {
    $cfc2e5a80c7c6d5c$var$Bk = -1;
    $cfc2e5a80c7c6d5c$var$Ck = 0;
    if (0 !== ($cfc2e5a80c7c6d5c$var$K & 6)) throw Error($cfc2e5a80c7c6d5c$var$p(327));
    var c = a.callbackNode;
    if ($cfc2e5a80c7c6d5c$var$Ik() && a.callbackNode !== c) return null;
    var d = $cfc2e5a80c7c6d5c$var$uc(a, a === $cfc2e5a80c7c6d5c$var$R ? $cfc2e5a80c7c6d5c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $cfc2e5a80c7c6d5c$var$Jk(a, d);
    else {
        b = d;
        var e = $cfc2e5a80c7c6d5c$var$K;
        $cfc2e5a80c7c6d5c$var$K |= 2;
        var f = $cfc2e5a80c7c6d5c$var$Kk();
        if ($cfc2e5a80c7c6d5c$var$R !== a || $cfc2e5a80c7c6d5c$var$Z !== b) $cfc2e5a80c7c6d5c$var$vk = null, $cfc2e5a80c7c6d5c$var$Hj = $cfc2e5a80c7c6d5c$var$B() + 500, $cfc2e5a80c7c6d5c$var$Lk(a, b);
        for(;;)try {
            $cfc2e5a80c7c6d5c$var$Mk();
            break;
        } catch (h) {
            $cfc2e5a80c7c6d5c$var$Nk(a, h);
        }
        $cfc2e5a80c7c6d5c$var$Qg();
        $cfc2e5a80c7c6d5c$var$nk.current = f;
        $cfc2e5a80c7c6d5c$var$K = e;
        null !== $cfc2e5a80c7c6d5c$var$Y ? b = 0 : ($cfc2e5a80c7c6d5c$var$R = null, $cfc2e5a80c7c6d5c$var$Z = 0, b = $cfc2e5a80c7c6d5c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $cfc2e5a80c7c6d5c$var$xc(a), 0 !== e && (d = e, b = $cfc2e5a80c7c6d5c$var$Ok(a, e)));
        if (1 === b) throw c = $cfc2e5a80c7c6d5c$var$qk, $cfc2e5a80c7c6d5c$var$Lk(a, 0), $cfc2e5a80c7c6d5c$var$Dk(a, d), $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B()), c;
        if (6 === b) $cfc2e5a80c7c6d5c$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$cfc2e5a80c7c6d5c$var$Pk(e) && (b = $cfc2e5a80c7c6d5c$var$Jk(a, d), 2 === b && (f = $cfc2e5a80c7c6d5c$var$xc(a), 0 !== f && (d = f, b = $cfc2e5a80c7c6d5c$var$Ok(a, f))), 1 === b)) throw c = $cfc2e5a80c7c6d5c$var$qk, $cfc2e5a80c7c6d5c$var$Lk(a, 0), $cfc2e5a80c7c6d5c$var$Dk(a, d), $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($cfc2e5a80c7c6d5c$var$p(345));
                case 2:
                    $cfc2e5a80c7c6d5c$var$Qk(a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk);
                    break;
                case 3:
                    $cfc2e5a80c7c6d5c$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $cfc2e5a80c7c6d5c$var$gk + 500 - $cfc2e5a80c7c6d5c$var$B(), 10 < b)) {
                        if (0 !== $cfc2e5a80c7c6d5c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $cfc2e5a80c7c6d5c$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $cfc2e5a80c7c6d5c$var$Ff($cfc2e5a80c7c6d5c$var$Qk.bind(null, a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk), b);
                        break;
                    }
                    $cfc2e5a80c7c6d5c$var$Qk(a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk);
                    break;
                case 4:
                    $cfc2e5a80c7c6d5c$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $cfc2e5a80c7c6d5c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $cfc2e5a80c7c6d5c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $cfc2e5a80c7c6d5c$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $cfc2e5a80c7c6d5c$var$Ff($cfc2e5a80c7c6d5c$var$Qk.bind(null, a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk), d);
                        break;
                    }
                    $cfc2e5a80c7c6d5c$var$Qk(a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk);
                    break;
                case 5:
                    $cfc2e5a80c7c6d5c$var$Qk(a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk);
                    break;
                default:
                    throw Error($cfc2e5a80c7c6d5c$var$p(329));
            }
        }
    }
    $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B());
    return a.callbackNode === c ? $cfc2e5a80c7c6d5c$var$Hk.bind(null, a) : null;
}
function $cfc2e5a80c7c6d5c$var$Ok(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$tk;
    a.current.memoizedState.isDehydrated && ($cfc2e5a80c7c6d5c$var$Lk(a, b).flags |= 256);
    a = $cfc2e5a80c7c6d5c$var$Jk(a, b);
    2 !== a && (b = $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$uk = c, null !== b && $cfc2e5a80c7c6d5c$var$Gj(b));
    return a;
}
function $cfc2e5a80c7c6d5c$var$Gj(a) {
    null === $cfc2e5a80c7c6d5c$var$uk ? $cfc2e5a80c7c6d5c$var$uk = a : $cfc2e5a80c7c6d5c$var$uk.push.apply($cfc2e5a80c7c6d5c$var$uk, a);
}
function $cfc2e5a80c7c6d5c$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$cfc2e5a80c7c6d5c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b["return"] || b["return"] === a) return !0;
                b = b["return"];
            }
            b.sibling["return"] = b["return"];
            b = b.sibling;
        }
    }
    return !0;
}
function $cfc2e5a80c7c6d5c$var$Dk(a, b) {
    b &= ~$cfc2e5a80c7c6d5c$var$sk;
    b &= ~$cfc2e5a80c7c6d5c$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $cfc2e5a80c7c6d5c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $cfc2e5a80c7c6d5c$var$Fk(a) {
    if (0 !== ($cfc2e5a80c7c6d5c$var$K & 6)) throw Error($cfc2e5a80c7c6d5c$var$p(327));
    $cfc2e5a80c7c6d5c$var$Ik();
    var b = $cfc2e5a80c7c6d5c$var$uc(a, 0);
    if (0 === (b & 1)) return $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B()), null;
    var c = $cfc2e5a80c7c6d5c$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $cfc2e5a80c7c6d5c$var$xc(a);
        0 !== d && (b = d, c = $cfc2e5a80c7c6d5c$var$Ok(a, d));
    }
    if (1 === c) throw c = $cfc2e5a80c7c6d5c$var$qk, $cfc2e5a80c7c6d5c$var$Lk(a, 0), $cfc2e5a80c7c6d5c$var$Dk(a, b), $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B()), c;
    if (6 === c) throw Error($cfc2e5a80c7c6d5c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $cfc2e5a80c7c6d5c$var$Qk(a, $cfc2e5a80c7c6d5c$var$uk, $cfc2e5a80c7c6d5c$var$vk);
    $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B());
    return null;
}
function $cfc2e5a80c7c6d5c$var$Rk(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$K;
    $cfc2e5a80c7c6d5c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $cfc2e5a80c7c6d5c$var$K = c, 0 === $cfc2e5a80c7c6d5c$var$K && ($cfc2e5a80c7c6d5c$var$Hj = $cfc2e5a80c7c6d5c$var$B() + 500, $cfc2e5a80c7c6d5c$var$fg && $cfc2e5a80c7c6d5c$var$jg());
    }
}
function $cfc2e5a80c7c6d5c$var$Sk(a) {
    null !== $cfc2e5a80c7c6d5c$var$xk && 0 === $cfc2e5a80c7c6d5c$var$xk.tag && 0 === ($cfc2e5a80c7c6d5c$var$K & 6) && $cfc2e5a80c7c6d5c$var$Ik();
    var b = $cfc2e5a80c7c6d5c$var$K;
    $cfc2e5a80c7c6d5c$var$K |= 1;
    var c = $cfc2e5a80c7c6d5c$var$pk.transition, d = $cfc2e5a80c7c6d5c$var$C;
    try {
        if ($cfc2e5a80c7c6d5c$var$pk.transition = null, $cfc2e5a80c7c6d5c$var$C = 1, a) return a();
    } finally{
        $cfc2e5a80c7c6d5c$var$C = d, $cfc2e5a80c7c6d5c$var$pk.transition = c, $cfc2e5a80c7c6d5c$var$K = b, 0 === ($cfc2e5a80c7c6d5c$var$K & 6) && $cfc2e5a80c7c6d5c$var$jg();
    }
}
function $cfc2e5a80c7c6d5c$var$Ij() {
    $cfc2e5a80c7c6d5c$var$gj = $cfc2e5a80c7c6d5c$var$fj.current;
    $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$fj);
}
function $cfc2e5a80c7c6d5c$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $cfc2e5a80c7c6d5c$var$Gf(c));
    if (null !== $cfc2e5a80c7c6d5c$var$Y) for(c = $cfc2e5a80c7c6d5c$var$Y["return"]; null !== c;){
        var d = c;
        $cfc2e5a80c7c6d5c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $cfc2e5a80c7c6d5c$var$$f();
                break;
            case 3:
                $cfc2e5a80c7c6d5c$var$Jh();
                $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$Wf);
                $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$H);
                $cfc2e5a80c7c6d5c$var$Oh();
                break;
            case 5:
                $cfc2e5a80c7c6d5c$var$Lh(d);
                break;
            case 4:
                $cfc2e5a80c7c6d5c$var$Jh();
                break;
            case 13:
                $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$M);
                break;
            case 19:
                $cfc2e5a80c7c6d5c$var$E($cfc2e5a80c7c6d5c$var$M);
                break;
            case 10:
                $cfc2e5a80c7c6d5c$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $cfc2e5a80c7c6d5c$var$Ij();
        }
        c = c["return"];
    }
    $cfc2e5a80c7c6d5c$var$R = a;
    $cfc2e5a80c7c6d5c$var$Y = a = $cfc2e5a80c7c6d5c$var$wh(a.current, null);
    $cfc2e5a80c7c6d5c$var$Z = $cfc2e5a80c7c6d5c$var$gj = b;
    $cfc2e5a80c7c6d5c$var$T = 0;
    $cfc2e5a80c7c6d5c$var$qk = null;
    $cfc2e5a80c7c6d5c$var$sk = $cfc2e5a80c7c6d5c$var$rk = $cfc2e5a80c7c6d5c$var$hh = 0;
    $cfc2e5a80c7c6d5c$var$uk = $cfc2e5a80c7c6d5c$var$tk = null;
    if (null !== $cfc2e5a80c7c6d5c$var$Wg) {
        for(b = 0; b < $cfc2e5a80c7c6d5c$var$Wg.length; b++)if (c = $cfc2e5a80c7c6d5c$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $cfc2e5a80c7c6d5c$var$Wg = null;
    }
    return a;
}
function $cfc2e5a80c7c6d5c$var$Nk(a, b) {
    do {
        var c = $cfc2e5a80c7c6d5c$var$Y;
        try {
            $cfc2e5a80c7c6d5c$var$Qg();
            $cfc2e5a80c7c6d5c$var$Ph.current = $cfc2e5a80c7c6d5c$var$ai;
            if ($cfc2e5a80c7c6d5c$var$Sh) {
                for(var d = $cfc2e5a80c7c6d5c$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $cfc2e5a80c7c6d5c$var$Sh = !1;
            }
            $cfc2e5a80c7c6d5c$var$Rh = 0;
            $cfc2e5a80c7c6d5c$var$P = $cfc2e5a80c7c6d5c$var$O = $cfc2e5a80c7c6d5c$var$N = null;
            $cfc2e5a80c7c6d5c$var$Th = !1;
            $cfc2e5a80c7c6d5c$var$Uh = 0;
            $cfc2e5a80c7c6d5c$var$ok.current = null;
            if (null === c || null === c["return"]) {
                $cfc2e5a80c7c6d5c$var$T = 1;
                $cfc2e5a80c7c6d5c$var$qk = b;
                $cfc2e5a80c7c6d5c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c["return"], h = c, k = b;
                b = $cfc2e5a80c7c6d5c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $k4vcf._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $cfc2e5a80c7c6d5c$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $cfc2e5a80c7c6d5c$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $cfc2e5a80c7c6d5c$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $cfc2e5a80c7c6d5c$var$Ti(f, l, b);
                            $cfc2e5a80c7c6d5c$var$uj();
                            break a;
                        }
                        k = Error($cfc2e5a80c7c6d5c$var$p(426));
                    }
                } else if ($cfc2e5a80c7c6d5c$var$I && h.mode & 1) {
                    var J = $cfc2e5a80c7c6d5c$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $cfc2e5a80c7c6d5c$var$Wi(J, g, h, f, b);
                        $cfc2e5a80c7c6d5c$var$Jg($cfc2e5a80c7c6d5c$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $cfc2e5a80c7c6d5c$var$Ki(k, h);
                4 !== $cfc2e5a80c7c6d5c$var$T && ($cfc2e5a80c7c6d5c$var$T = 2);
                null === $cfc2e5a80c7c6d5c$var$tk ? $cfc2e5a80c7c6d5c$var$tk = [
                    f
                ] : $cfc2e5a80c7c6d5c$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $cfc2e5a80c7c6d5c$var$Oi(f, k, b);
                            $cfc2e5a80c7c6d5c$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $cfc2e5a80c7c6d5c$var$Si || !$cfc2e5a80c7c6d5c$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $cfc2e5a80c7c6d5c$var$Ri(f, h, b);
                                $cfc2e5a80c7c6d5c$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f["return"];
                }while (null !== f);
            }
            $cfc2e5a80c7c6d5c$var$Tk(c);
        } catch (na) {
            b = na;
            $cfc2e5a80c7c6d5c$var$Y === c && null !== c && ($cfc2e5a80c7c6d5c$var$Y = c = c["return"]);
            continue;
        }
        break;
    }while (1);
}
function $cfc2e5a80c7c6d5c$var$Kk() {
    var a = $cfc2e5a80c7c6d5c$var$nk.current;
    $cfc2e5a80c7c6d5c$var$nk.current = $cfc2e5a80c7c6d5c$var$ai;
    return null === a ? $cfc2e5a80c7c6d5c$var$ai : a;
}
function $cfc2e5a80c7c6d5c$var$uj() {
    if (0 === $cfc2e5a80c7c6d5c$var$T || 3 === $cfc2e5a80c7c6d5c$var$T || 2 === $cfc2e5a80c7c6d5c$var$T) $cfc2e5a80c7c6d5c$var$T = 4;
    null === $cfc2e5a80c7c6d5c$var$R || 0 === ($cfc2e5a80c7c6d5c$var$hh & 268435455) && 0 === ($cfc2e5a80c7c6d5c$var$rk & 268435455) || $cfc2e5a80c7c6d5c$var$Dk($cfc2e5a80c7c6d5c$var$R, $cfc2e5a80c7c6d5c$var$Z);
}
function $cfc2e5a80c7c6d5c$var$Jk(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$K;
    $cfc2e5a80c7c6d5c$var$K |= 2;
    var d = $cfc2e5a80c7c6d5c$var$Kk();
    if ($cfc2e5a80c7c6d5c$var$R !== a || $cfc2e5a80c7c6d5c$var$Z !== b) $cfc2e5a80c7c6d5c$var$vk = null, $cfc2e5a80c7c6d5c$var$Lk(a, b);
    for(;;)try {
        $cfc2e5a80c7c6d5c$var$Uk();
        break;
    } catch (e) {
        $cfc2e5a80c7c6d5c$var$Nk(a, e);
    }
    $cfc2e5a80c7c6d5c$var$Qg();
    $cfc2e5a80c7c6d5c$var$K = c;
    $cfc2e5a80c7c6d5c$var$nk.current = d;
    if (null !== $cfc2e5a80c7c6d5c$var$Y) throw Error($cfc2e5a80c7c6d5c$var$p(261));
    $cfc2e5a80c7c6d5c$var$R = null;
    $cfc2e5a80c7c6d5c$var$Z = 0;
    return $cfc2e5a80c7c6d5c$var$T;
}
function $cfc2e5a80c7c6d5c$var$Uk() {
    for(; null !== $cfc2e5a80c7c6d5c$var$Y;)$cfc2e5a80c7c6d5c$var$Vk($cfc2e5a80c7c6d5c$var$Y);
}
function $cfc2e5a80c7c6d5c$var$Mk() {
    for(; null !== $cfc2e5a80c7c6d5c$var$Y && !$cfc2e5a80c7c6d5c$var$cc();)$cfc2e5a80c7c6d5c$var$Vk($cfc2e5a80c7c6d5c$var$Y);
}
function $cfc2e5a80c7c6d5c$var$Vk(a) {
    var b = $cfc2e5a80c7c6d5c$var$Wk(a.alternate, a, $cfc2e5a80c7c6d5c$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $cfc2e5a80c7c6d5c$var$Tk(a) : $cfc2e5a80c7c6d5c$var$Y = b;
    $cfc2e5a80c7c6d5c$var$ok.current = null;
}
function $cfc2e5a80c7c6d5c$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b["return"];
        if (0 === (b.flags & 32768)) {
            if (c = $cfc2e5a80c7c6d5c$var$Fj(c, b, $cfc2e5a80c7c6d5c$var$gj), null !== c) {
                $cfc2e5a80c7c6d5c$var$Y = c;
                return;
            }
        } else {
            c = $cfc2e5a80c7c6d5c$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $cfc2e5a80c7c6d5c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $cfc2e5a80c7c6d5c$var$T = 6;
                $cfc2e5a80c7c6d5c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $cfc2e5a80c7c6d5c$var$Y = b;
            return;
        }
        $cfc2e5a80c7c6d5c$var$Y = b = a;
    }while (null !== b);
    0 === $cfc2e5a80c7c6d5c$var$T && ($cfc2e5a80c7c6d5c$var$T = 5);
}
function $cfc2e5a80c7c6d5c$var$Qk(a, b, c) {
    var d = $cfc2e5a80c7c6d5c$var$C, e = $cfc2e5a80c7c6d5c$var$pk.transition;
    try {
        $cfc2e5a80c7c6d5c$var$pk.transition = null, $cfc2e5a80c7c6d5c$var$C = 1, $cfc2e5a80c7c6d5c$var$Xk(a, b, c, d);
    } finally{
        $cfc2e5a80c7c6d5c$var$pk.transition = e, $cfc2e5a80c7c6d5c$var$C = d;
    }
    return null;
}
function $cfc2e5a80c7c6d5c$var$Xk(a, b, c, d) {
    do $cfc2e5a80c7c6d5c$var$Ik();
    while (null !== $cfc2e5a80c7c6d5c$var$xk);
    if (0 !== ($cfc2e5a80c7c6d5c$var$K & 6)) throw Error($cfc2e5a80c7c6d5c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($cfc2e5a80c7c6d5c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $cfc2e5a80c7c6d5c$var$Bc(a, f);
    a === $cfc2e5a80c7c6d5c$var$R && ($cfc2e5a80c7c6d5c$var$Y = $cfc2e5a80c7c6d5c$var$R = null, $cfc2e5a80c7c6d5c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $cfc2e5a80c7c6d5c$var$wk || ($cfc2e5a80c7c6d5c$var$wk = !0, $cfc2e5a80c7c6d5c$var$Gk($cfc2e5a80c7c6d5c$var$hc, function() {
        $cfc2e5a80c7c6d5c$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $cfc2e5a80c7c6d5c$var$pk.transition;
        $cfc2e5a80c7c6d5c$var$pk.transition = null;
        var g = $cfc2e5a80c7c6d5c$var$C;
        $cfc2e5a80c7c6d5c$var$C = 1;
        var h = $cfc2e5a80c7c6d5c$var$K;
        $cfc2e5a80c7c6d5c$var$K |= 4;
        $cfc2e5a80c7c6d5c$var$ok.current = null;
        $cfc2e5a80c7c6d5c$var$Pj(a, c);
        $cfc2e5a80c7c6d5c$var$ek(c, a);
        $cfc2e5a80c7c6d5c$var$Oe($cfc2e5a80c7c6d5c$var$Df);
        $cfc2e5a80c7c6d5c$var$dd = !!$cfc2e5a80c7c6d5c$var$Cf;
        $cfc2e5a80c7c6d5c$var$Df = $cfc2e5a80c7c6d5c$var$Cf = null;
        a.current = c;
        $cfc2e5a80c7c6d5c$var$ik(c, a, e);
        $cfc2e5a80c7c6d5c$var$dc();
        $cfc2e5a80c7c6d5c$var$K = h;
        $cfc2e5a80c7c6d5c$var$C = g;
        $cfc2e5a80c7c6d5c$var$pk.transition = f;
    } else a.current = c;
    $cfc2e5a80c7c6d5c$var$wk && ($cfc2e5a80c7c6d5c$var$wk = !1, $cfc2e5a80c7c6d5c$var$xk = a, $cfc2e5a80c7c6d5c$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($cfc2e5a80c7c6d5c$var$Si = null);
    $cfc2e5a80c7c6d5c$var$mc(c.stateNode, d);
    $cfc2e5a80c7c6d5c$var$Ek(a, $cfc2e5a80c7c6d5c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($cfc2e5a80c7c6d5c$var$Pi) throw $cfc2e5a80c7c6d5c$var$Pi = !1, a = $cfc2e5a80c7c6d5c$var$Qi, $cfc2e5a80c7c6d5c$var$Qi = null, a;
    0 !== ($cfc2e5a80c7c6d5c$var$yk & 1) && 0 !== a.tag && $cfc2e5a80c7c6d5c$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $cfc2e5a80c7c6d5c$var$Ak ? $cfc2e5a80c7c6d5c$var$zk++ : ($cfc2e5a80c7c6d5c$var$zk = 0, $cfc2e5a80c7c6d5c$var$Ak = a) : $cfc2e5a80c7c6d5c$var$zk = 0;
    $cfc2e5a80c7c6d5c$var$jg();
    return null;
}
function $cfc2e5a80c7c6d5c$var$Ik() {
    if (null !== $cfc2e5a80c7c6d5c$var$xk) {
        var a = $cfc2e5a80c7c6d5c$var$Dc($cfc2e5a80c7c6d5c$var$yk), b = $cfc2e5a80c7c6d5c$var$pk.transition, c = $cfc2e5a80c7c6d5c$var$C;
        try {
            $cfc2e5a80c7c6d5c$var$pk.transition = null;
            $cfc2e5a80c7c6d5c$var$C = 16 > a ? 16 : a;
            if (null === $cfc2e5a80c7c6d5c$var$xk) var d = !1;
            else {
                a = $cfc2e5a80c7c6d5c$var$xk;
                $cfc2e5a80c7c6d5c$var$xk = null;
                $cfc2e5a80c7c6d5c$var$yk = 0;
                if (0 !== ($cfc2e5a80c7c6d5c$var$K & 6)) throw Error($cfc2e5a80c7c6d5c$var$p(331));
                var e = $cfc2e5a80c7c6d5c$var$K;
                $cfc2e5a80c7c6d5c$var$K |= 4;
                for($cfc2e5a80c7c6d5c$var$V = a.current; null !== $cfc2e5a80c7c6d5c$var$V;){
                    var f = $cfc2e5a80c7c6d5c$var$V, g = f.child;
                    if (0 !== ($cfc2e5a80c7c6d5c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($cfc2e5a80c7c6d5c$var$V = l; null !== $cfc2e5a80c7c6d5c$var$V;){
                                    var m = $cfc2e5a80c7c6d5c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $cfc2e5a80c7c6d5c$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q["return"] = m, $cfc2e5a80c7c6d5c$var$V = q;
                                    else for(; null !== $cfc2e5a80c7c6d5c$var$V;){
                                        m = $cfc2e5a80c7c6d5c$var$V;
                                        var r = m.sibling, y = m["return"];
                                        $cfc2e5a80c7c6d5c$var$Tj(m);
                                        if (m === l) {
                                            $cfc2e5a80c7c6d5c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r["return"] = y;
                                            $cfc2e5a80c7c6d5c$var$V = r;
                                            break;
                                        }
                                        $cfc2e5a80c7c6d5c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $cfc2e5a80c7c6d5c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, $cfc2e5a80c7c6d5c$var$V = g;
                    else b: for(; null !== $cfc2e5a80c7c6d5c$var$V;){
                        f = $cfc2e5a80c7c6d5c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $cfc2e5a80c7c6d5c$var$Qj(9, f, f["return"]);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x["return"] = f["return"];
                            $cfc2e5a80c7c6d5c$var$V = x;
                            break b;
                        }
                        $cfc2e5a80c7c6d5c$var$V = f["return"];
                    }
                }
                var w = a.current;
                for($cfc2e5a80c7c6d5c$var$V = w; null !== $cfc2e5a80c7c6d5c$var$V;){
                    g = $cfc2e5a80c7c6d5c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u["return"] = g, $cfc2e5a80c7c6d5c$var$V = u;
                    else b: for(g = w; null !== $cfc2e5a80c7c6d5c$var$V;){
                        h = $cfc2e5a80c7c6d5c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $cfc2e5a80c7c6d5c$var$Rj(9, h);
                            }
                        } catch (na) {
                            $cfc2e5a80c7c6d5c$var$W(h, h["return"], na);
                        }
                        if (h === g) {
                            $cfc2e5a80c7c6d5c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F["return"] = h["return"];
                            $cfc2e5a80c7c6d5c$var$V = F;
                            break b;
                        }
                        $cfc2e5a80c7c6d5c$var$V = h["return"];
                    }
                }
                $cfc2e5a80c7c6d5c$var$K = e;
                $cfc2e5a80c7c6d5c$var$jg();
                if ($cfc2e5a80c7c6d5c$var$lc && "function" === typeof $cfc2e5a80c7c6d5c$var$lc.onPostCommitFiberRoot) try {
                    $cfc2e5a80c7c6d5c$var$lc.onPostCommitFiberRoot($cfc2e5a80c7c6d5c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $cfc2e5a80c7c6d5c$var$C = c, $cfc2e5a80c7c6d5c$var$pk.transition = b;
        }
    }
    return !1;
}
function $cfc2e5a80c7c6d5c$var$Yk(a, b, c) {
    b = $cfc2e5a80c7c6d5c$var$Ki(c, b);
    b = $cfc2e5a80c7c6d5c$var$Oi(a, b, 1);
    a = $cfc2e5a80c7c6d5c$var$dh(a, b, 1);
    b = $cfc2e5a80c7c6d5c$var$L();
    null !== a && ($cfc2e5a80c7c6d5c$var$Ac(a, 1, b), $cfc2e5a80c7c6d5c$var$Ek(a, b));
}
function $cfc2e5a80c7c6d5c$var$W(a, b, c) {
    if (3 === a.tag) $cfc2e5a80c7c6d5c$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $cfc2e5a80c7c6d5c$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $cfc2e5a80c7c6d5c$var$Si || !$cfc2e5a80c7c6d5c$var$Si.has(d))) {
                a = $cfc2e5a80c7c6d5c$var$Ki(c, a);
                a = $cfc2e5a80c7c6d5c$var$Ri(b, a, 1);
                b = $cfc2e5a80c7c6d5c$var$dh(b, a, 1);
                a = $cfc2e5a80c7c6d5c$var$L();
                null !== b && ($cfc2e5a80c7c6d5c$var$Ac(b, 1, a), $cfc2e5a80c7c6d5c$var$Ek(b, a));
                break;
            }
        }
        b = b["return"];
    }
}
function $cfc2e5a80c7c6d5c$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    b = $cfc2e5a80c7c6d5c$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $cfc2e5a80c7c6d5c$var$R === a && ($cfc2e5a80c7c6d5c$var$Z & c) === c && (4 === $cfc2e5a80c7c6d5c$var$T || 3 === $cfc2e5a80c7c6d5c$var$T && ($cfc2e5a80c7c6d5c$var$Z & 130023424) === $cfc2e5a80c7c6d5c$var$Z && 500 > $cfc2e5a80c7c6d5c$var$B() - $cfc2e5a80c7c6d5c$var$gk ? $cfc2e5a80c7c6d5c$var$Lk(a, 0) : $cfc2e5a80c7c6d5c$var$sk |= c);
    $cfc2e5a80c7c6d5c$var$Ek(a, b);
}
function $cfc2e5a80c7c6d5c$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $cfc2e5a80c7c6d5c$var$sc, $cfc2e5a80c7c6d5c$var$sc <<= 1, 0 === ($cfc2e5a80c7c6d5c$var$sc & 130023424) && ($cfc2e5a80c7c6d5c$var$sc = 4194304)));
    var c = $cfc2e5a80c7c6d5c$var$L();
    a = $cfc2e5a80c7c6d5c$var$Zg(a, b);
    null !== a && ($cfc2e5a80c7c6d5c$var$Ac(a, b, c), $cfc2e5a80c7c6d5c$var$Ek(a, c));
}
function $cfc2e5a80c7c6d5c$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $cfc2e5a80c7c6d5c$var$Zk(a, c);
}
function $cfc2e5a80c7c6d5c$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($cfc2e5a80c7c6d5c$var$p(314));
    }
    null !== d && d["delete"](b);
    $cfc2e5a80c7c6d5c$var$Zk(a, c);
}
var $cfc2e5a80c7c6d5c$var$Wk;
$cfc2e5a80c7c6d5c$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $cfc2e5a80c7c6d5c$var$Wf.current) $cfc2e5a80c7c6d5c$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $cfc2e5a80c7c6d5c$var$Ug = !1, $cfc2e5a80c7c6d5c$var$zj(a, b, c);
            $cfc2e5a80c7c6d5c$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $cfc2e5a80c7c6d5c$var$Ug = !1, $cfc2e5a80c7c6d5c$var$I && 0 !== (b.flags & 1048576) && $cfc2e5a80c7c6d5c$var$ug(b, $cfc2e5a80c7c6d5c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $cfc2e5a80c7c6d5c$var$jj(a, b);
            a = b.pendingProps;
            var e = $cfc2e5a80c7c6d5c$var$Yf(b, $cfc2e5a80c7c6d5c$var$H.current);
            $cfc2e5a80c7c6d5c$var$Tg(b, c);
            e = $cfc2e5a80c7c6d5c$var$Xh(null, b, d, a, e, c);
            var f = $cfc2e5a80c7c6d5c$var$bi();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $k4vcf._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $cfc2e5a80c7c6d5c$var$Zf(d) ? (f = !0, $cfc2e5a80c7c6d5c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $cfc2e5a80c7c6d5c$var$ah(b), e.updater = $cfc2e5a80c7c6d5c$var$nh, b.stateNode = e, e._reactInternals = b, $cfc2e5a80c7c6d5c$var$rh(b, d, a, c), b = $cfc2e5a80c7c6d5c$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $cfc2e5a80c7c6d5c$var$I && f && $cfc2e5a80c7c6d5c$var$vg(b), $cfc2e5a80c7c6d5c$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $cfc2e5a80c7c6d5c$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $cfc2e5a80c7c6d5c$var$$k(d);
                a = $cfc2e5a80c7c6d5c$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $cfc2e5a80c7c6d5c$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $cfc2e5a80c7c6d5c$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $cfc2e5a80c7c6d5c$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $cfc2e5a80c7c6d5c$var$aj(null, b, d, $cfc2e5a80c7c6d5c$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($cfc2e5a80c7c6d5c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cfc2e5a80c7c6d5c$var$Lg(d, e), $cfc2e5a80c7c6d5c$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cfc2e5a80c7c6d5c$var$Lg(d, e), $cfc2e5a80c7c6d5c$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $cfc2e5a80c7c6d5c$var$lj(b);
                if (null === a) throw Error($cfc2e5a80c7c6d5c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $cfc2e5a80c7c6d5c$var$bh(a, b);
                $cfc2e5a80c7c6d5c$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $cfc2e5a80c7c6d5c$var$Ki(Error($cfc2e5a80c7c6d5c$var$p(423)), b);
                        b = $cfc2e5a80c7c6d5c$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $cfc2e5a80c7c6d5c$var$Ki(Error($cfc2e5a80c7c6d5c$var$p(424)), b);
                        b = $cfc2e5a80c7c6d5c$var$mj(a, b, d, c, e);
                        break a;
                    } else for($cfc2e5a80c7c6d5c$var$yg = $cfc2e5a80c7c6d5c$var$Lf(b.stateNode.containerInfo.firstChild), $cfc2e5a80c7c6d5c$var$xg = b, $cfc2e5a80c7c6d5c$var$I = !0, $cfc2e5a80c7c6d5c$var$zg = null, c = $cfc2e5a80c7c6d5c$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $cfc2e5a80c7c6d5c$var$Ig();
                    if (d === e) {
                        b = $cfc2e5a80c7c6d5c$var$$i(a, b, c);
                        break a;
                    }
                    $cfc2e5a80c7c6d5c$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $cfc2e5a80c7c6d5c$var$Kh(b), null === a && $cfc2e5a80c7c6d5c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $cfc2e5a80c7c6d5c$var$Ef(d, e) ? g = null : null !== f && $cfc2e5a80c7c6d5c$var$Ef(d, f) && (b.flags |= 32), $cfc2e5a80c7c6d5c$var$hj(a, b), $cfc2e5a80c7c6d5c$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $cfc2e5a80c7c6d5c$var$Eg(b), null;
        case 13:
            return $cfc2e5a80c7c6d5c$var$pj(a, b, c);
        case 4:
            return $cfc2e5a80c7c6d5c$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $cfc2e5a80c7c6d5c$var$Bh(b, null, d, c) : $cfc2e5a80c7c6d5c$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cfc2e5a80c7c6d5c$var$Lg(d, e), $cfc2e5a80c7c6d5c$var$Zi(a, b, d, e, c);
        case 7:
            return $cfc2e5a80c7c6d5c$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $cfc2e5a80c7c6d5c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $cfc2e5a80c7c6d5c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $cfc2e5a80c7c6d5c$var$G($cfc2e5a80c7c6d5c$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($cfc2e5a80c7c6d5c$var$He(f.value, g)) {
                        if (f.children === e.children && !$cfc2e5a80c7c6d5c$var$Wf.current) {
                            b = $cfc2e5a80c7c6d5c$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f["return"] = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $cfc2e5a80c7c6d5c$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $cfc2e5a80c7c6d5c$var$Sg(f["return"], c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f["return"];
                            if (null === g) throw Error($cfc2e5a80c7c6d5c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $cfc2e5a80c7c6d5c$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g["return"] = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f["return"] = g["return"];
                                g = f;
                                break;
                            }
                            g = g["return"];
                        }
                        f = g;
                    }
                }
                $cfc2e5a80c7c6d5c$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $cfc2e5a80c7c6d5c$var$Tg(b, c), e = $cfc2e5a80c7c6d5c$var$Vg(e), d = d(e), b.flags |= 1, $cfc2e5a80c7c6d5c$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $cfc2e5a80c7c6d5c$var$Lg(d, b.pendingProps), e = $cfc2e5a80c7c6d5c$var$Lg(d.type, e), $cfc2e5a80c7c6d5c$var$aj(a, b, d, e, c);
        case 15:
            return $cfc2e5a80c7c6d5c$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cfc2e5a80c7c6d5c$var$Lg(d, e), $cfc2e5a80c7c6d5c$var$jj(a, b), b.tag = 1, $cfc2e5a80c7c6d5c$var$Zf(d) ? (a = !0, $cfc2e5a80c7c6d5c$var$cg(b)) : a = !1, $cfc2e5a80c7c6d5c$var$Tg(b, c), $cfc2e5a80c7c6d5c$var$ph(b, d, e), $cfc2e5a80c7c6d5c$var$rh(b, d, e, c), $cfc2e5a80c7c6d5c$var$kj(null, b, d, !0, a, c);
        case 19:
            return $cfc2e5a80c7c6d5c$var$yj(a, b, c);
        case 22:
            return $cfc2e5a80c7c6d5c$var$ej(a, b, c);
    }
    throw Error($cfc2e5a80c7c6d5c$var$p(156, b.tag));
};
function $cfc2e5a80c7c6d5c$var$Gk(a, b) {
    return $cfc2e5a80c7c6d5c$var$ac(a, b);
}
function $cfc2e5a80c7c6d5c$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $cfc2e5a80c7c6d5c$var$Bg(a, b, c, d) {
    return new $cfc2e5a80c7c6d5c$var$al(a, b, c, d);
}
function $cfc2e5a80c7c6d5c$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $cfc2e5a80c7c6d5c$var$$k(a) {
    if ("function" === typeof a) return $cfc2e5a80c7c6d5c$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $cfc2e5a80c7c6d5c$var$Da) return 11;
        if (a === $cfc2e5a80c7c6d5c$var$Ga) return 14;
    }
    return 2;
}
function $cfc2e5a80c7c6d5c$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $cfc2e5a80c7c6d5c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $cfc2e5a80c7c6d5c$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $cfc2e5a80c7c6d5c$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $cfc2e5a80c7c6d5c$var$ya:
            return $cfc2e5a80c7c6d5c$var$Ah(c.children, e, f, b);
        case $cfc2e5a80c7c6d5c$var$za:
            g = 8;
            e |= 8;
            break;
        case $cfc2e5a80c7c6d5c$var$Aa:
            return a = $cfc2e5a80c7c6d5c$var$Bg(12, c, b, e | 2), a.elementType = $cfc2e5a80c7c6d5c$var$Aa, a.lanes = f, a;
        case $cfc2e5a80c7c6d5c$var$Ea:
            return a = $cfc2e5a80c7c6d5c$var$Bg(13, c, b, e), a.elementType = $cfc2e5a80c7c6d5c$var$Ea, a.lanes = f, a;
        case $cfc2e5a80c7c6d5c$var$Fa:
            return a = $cfc2e5a80c7c6d5c$var$Bg(19, c, b, e), a.elementType = $cfc2e5a80c7c6d5c$var$Fa, a.lanes = f, a;
        case $cfc2e5a80c7c6d5c$var$Ia:
            return $cfc2e5a80c7c6d5c$var$qj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a)) && null !== a) switch(a.$$typeof){
                case $cfc2e5a80c7c6d5c$var$Ba:
                    g = 10;
                    break a;
                case $cfc2e5a80c7c6d5c$var$Ca:
                    g = 9;
                    break a;
                case $cfc2e5a80c7c6d5c$var$Da:
                    g = 11;
                    break a;
                case $cfc2e5a80c7c6d5c$var$Ga:
                    g = 14;
                    break a;
                case $cfc2e5a80c7c6d5c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($cfc2e5a80c7c6d5c$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $k4vcf._)(a), ""));
    }
    b = $cfc2e5a80c7c6d5c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $cfc2e5a80c7c6d5c$var$Ah(a, b, c, d) {
    a = $cfc2e5a80c7c6d5c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $cfc2e5a80c7c6d5c$var$qj(a, b, c, d) {
    a = $cfc2e5a80c7c6d5c$var$Bg(22, a, d, b);
    a.elementType = $cfc2e5a80c7c6d5c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $cfc2e5a80c7c6d5c$var$xh(a, b, c) {
    a = $cfc2e5a80c7c6d5c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $cfc2e5a80c7c6d5c$var$zh(a, b, c) {
    b = $cfc2e5a80c7c6d5c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $cfc2e5a80c7c6d5c$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $cfc2e5a80c7c6d5c$var$zc(0);
    this.expirationTimes = $cfc2e5a80c7c6d5c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $cfc2e5a80c7c6d5c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $cfc2e5a80c7c6d5c$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $cfc2e5a80c7c6d5c$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $cfc2e5a80c7c6d5c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $cfc2e5a80c7c6d5c$var$ah(f);
    return a;
}
function $cfc2e5a80c7c6d5c$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $cfc2e5a80c7c6d5c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $cfc2e5a80c7c6d5c$var$el(a) {
    if (!a) return $cfc2e5a80c7c6d5c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($cfc2e5a80c7c6d5c$var$Vb(a) !== a || 1 !== a.tag) throw Error($cfc2e5a80c7c6d5c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($cfc2e5a80c7c6d5c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b["return"];
        }while (null !== b);
        throw Error($cfc2e5a80c7c6d5c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($cfc2e5a80c7c6d5c$var$Zf(c)) return $cfc2e5a80c7c6d5c$var$bg(a, c, b);
    }
    return b;
}
function $cfc2e5a80c7c6d5c$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $cfc2e5a80c7c6d5c$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $cfc2e5a80c7c6d5c$var$el(null);
    c = a.current;
    d = $cfc2e5a80c7c6d5c$var$L();
    e = $cfc2e5a80c7c6d5c$var$lh(c);
    f = $cfc2e5a80c7c6d5c$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $cfc2e5a80c7c6d5c$var$dh(c, f, e);
    a.current.lanes = e;
    $cfc2e5a80c7c6d5c$var$Ac(a, e, d);
    $cfc2e5a80c7c6d5c$var$Ek(a, d);
    return a;
}
function $cfc2e5a80c7c6d5c$var$gl(a, b, c, d) {
    var e = b.current, f = $cfc2e5a80c7c6d5c$var$L(), g = $cfc2e5a80c7c6d5c$var$lh(e);
    c = $cfc2e5a80c7c6d5c$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $cfc2e5a80c7c6d5c$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $cfc2e5a80c7c6d5c$var$dh(e, b, g);
    null !== a && ($cfc2e5a80c7c6d5c$var$mh(a, e, g, f), $cfc2e5a80c7c6d5c$var$eh(a, e, g));
    return g;
}
function $cfc2e5a80c7c6d5c$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $cfc2e5a80c7c6d5c$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $cfc2e5a80c7c6d5c$var$jl(a, b) {
    $cfc2e5a80c7c6d5c$var$il(a, b);
    (a = a.alternate) && $cfc2e5a80c7c6d5c$var$il(a, b);
}
function $cfc2e5a80c7c6d5c$var$kl() {
    return null;
}
var $cfc2e5a80c7c6d5c$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $cfc2e5a80c7c6d5c$var$ml(a) {
    this._internalRoot = a;
}
$cfc2e5a80c7c6d5c$var$nl.prototype.render = $cfc2e5a80c7c6d5c$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($cfc2e5a80c7c6d5c$var$p(409));
    $cfc2e5a80c7c6d5c$var$gl(a, b, null, null);
};
$cfc2e5a80c7c6d5c$var$nl.prototype.unmount = $cfc2e5a80c7c6d5c$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $cfc2e5a80c7c6d5c$var$Sk(function() {
            $cfc2e5a80c7c6d5c$var$gl(null, a, null, null);
        });
        b[$cfc2e5a80c7c6d5c$var$uf] = null;
    }
};
function $cfc2e5a80c7c6d5c$var$nl(a) {
    this._internalRoot = a;
}
$cfc2e5a80c7c6d5c$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $cfc2e5a80c7c6d5c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $cfc2e5a80c7c6d5c$var$Qc.length && 0 !== b && b < $cfc2e5a80c7c6d5c$var$Qc[c].priority; c++);
        $cfc2e5a80c7c6d5c$var$Qc.splice(c, 0, a);
        0 === c && $cfc2e5a80c7c6d5c$var$Vc(a);
    }
};
function $cfc2e5a80c7c6d5c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $cfc2e5a80c7c6d5c$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $cfc2e5a80c7c6d5c$var$ql() {}
function $cfc2e5a80c7c6d5c$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $cfc2e5a80c7c6d5c$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $cfc2e5a80c7c6d5c$var$fl(b, d, a, 0, null, !1, !1, "", $cfc2e5a80c7c6d5c$var$ql);
        a._reactRootContainer = g;
        a[$cfc2e5a80c7c6d5c$var$uf] = g.current;
        $cfc2e5a80c7c6d5c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $cfc2e5a80c7c6d5c$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $cfc2e5a80c7c6d5c$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $cfc2e5a80c7c6d5c$var$cl(a, 0, !1, null, null, !1, !1, "", $cfc2e5a80c7c6d5c$var$ql);
    a._reactRootContainer = k;
    a[$cfc2e5a80c7c6d5c$var$uf] = k.current;
    $cfc2e5a80c7c6d5c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $cfc2e5a80c7c6d5c$var$Sk(function() {
        $cfc2e5a80c7c6d5c$var$gl(b, k, c, d);
    });
    return k;
}
function $cfc2e5a80c7c6d5c$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $cfc2e5a80c7c6d5c$var$hl(g);
                h.call(_$a);
            };
        }
        $cfc2e5a80c7c6d5c$var$gl(b, g, a, e);
    } else g = $cfc2e5a80c7c6d5c$var$rl(c, b, a, e, d);
    return $cfc2e5a80c7c6d5c$var$hl(g);
}
$cfc2e5a80c7c6d5c$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $cfc2e5a80c7c6d5c$var$tc(b.pendingLanes);
                0 !== c && ($cfc2e5a80c7c6d5c$var$Cc(b, c | 1), $cfc2e5a80c7c6d5c$var$Ek(b, $cfc2e5a80c7c6d5c$var$B()), 0 === ($cfc2e5a80c7c6d5c$var$K & 6) && ($cfc2e5a80c7c6d5c$var$Hj = $cfc2e5a80c7c6d5c$var$B() + 500, $cfc2e5a80c7c6d5c$var$jg()));
            }
            break;
        case 13:
            $cfc2e5a80c7c6d5c$var$Sk(function() {
                var b = $cfc2e5a80c7c6d5c$var$Zg(a, 1);
                if (null !== b) {
                    var c = $cfc2e5a80c7c6d5c$var$L();
                    $cfc2e5a80c7c6d5c$var$mh(b, a, 1, c);
                }
            }), $cfc2e5a80c7c6d5c$var$jl(a, 1);
    }
};
$cfc2e5a80c7c6d5c$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $cfc2e5a80c7c6d5c$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $cfc2e5a80c7c6d5c$var$L();
            $cfc2e5a80c7c6d5c$var$mh(b, a, 134217728, c);
        }
        $cfc2e5a80c7c6d5c$var$jl(a, 134217728);
    }
};
$cfc2e5a80c7c6d5c$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $cfc2e5a80c7c6d5c$var$lh(a), c = $cfc2e5a80c7c6d5c$var$Zg(a, b);
        if (null !== c) {
            var d = $cfc2e5a80c7c6d5c$var$L();
            $cfc2e5a80c7c6d5c$var$mh(c, a, b, d);
        }
        $cfc2e5a80c7c6d5c$var$jl(a, b);
    }
};
$cfc2e5a80c7c6d5c$var$Hc = function Hc() {
    return $cfc2e5a80c7c6d5c$var$C;
};
$cfc2e5a80c7c6d5c$var$Ic = function Ic(a, b) {
    var c = $cfc2e5a80c7c6d5c$var$C;
    try {
        return $cfc2e5a80c7c6d5c$var$C = a, b();
    } finally{
        $cfc2e5a80c7c6d5c$var$C = c;
    }
};
$cfc2e5a80c7c6d5c$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $cfc2e5a80c7c6d5c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $cfc2e5a80c7c6d5c$var$Db(d);
                        if (!e) throw Error($cfc2e5a80c7c6d5c$var$p(90));
                        $cfc2e5a80c7c6d5c$var$Wa(d);
                        $cfc2e5a80c7c6d5c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $cfc2e5a80c7c6d5c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $cfc2e5a80c7c6d5c$var$fb(a, !!c.multiple, b, !1);
    }
};
$cfc2e5a80c7c6d5c$var$Gb = $cfc2e5a80c7c6d5c$var$Rk;
$cfc2e5a80c7c6d5c$var$Hb = $cfc2e5a80c7c6d5c$var$Sk;
var $cfc2e5a80c7c6d5c$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $cfc2e5a80c7c6d5c$var$Cb,
        $cfc2e5a80c7c6d5c$var$ue,
        $cfc2e5a80c7c6d5c$var$Db,
        $cfc2e5a80c7c6d5c$var$Eb,
        $cfc2e5a80c7c6d5c$var$Fb,
        $cfc2e5a80c7c6d5c$var$Rk
    ]
}, $cfc2e5a80c7c6d5c$var$ul = {
    findFiberByHostInstance: $cfc2e5a80c7c6d5c$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $cfc2e5a80c7c6d5c$var$vl = {
    bundleType: $cfc2e5a80c7c6d5c$var$ul.bundleType,
    version: $cfc2e5a80c7c6d5c$var$ul.version,
    rendererPackageName: $cfc2e5a80c7c6d5c$var$ul.rendererPackageName,
    rendererConfig: $cfc2e5a80c7c6d5c$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $cfc2e5a80c7c6d5c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $cfc2e5a80c7c6d5c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $cfc2e5a80c7c6d5c$var$ul.findFiberByHostInstance || $cfc2e5a80c7c6d5c$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $cfc2e5a80c7c6d5c$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$cfc2e5a80c7c6d5c$var$wl.isDisabled && $cfc2e5a80c7c6d5c$var$wl.supportsFiber) try {
        $cfc2e5a80c7c6d5c$var$kc = $cfc2e5a80c7c6d5c$var$wl.inject($cfc2e5a80c7c6d5c$var$vl), $cfc2e5a80c7c6d5c$var$lc = $cfc2e5a80c7c6d5c$var$wl;
    } catch (a) {}
}
$cfc2e5a80c7c6d5c$export$ae55be85d98224ed = $cfc2e5a80c7c6d5c$var$tl;
$cfc2e5a80c7c6d5c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$cfc2e5a80c7c6d5c$var$ol(b)) throw Error($cfc2e5a80c7c6d5c$var$p(200));
    return $cfc2e5a80c7c6d5c$var$dl(a, b, null, c);
};
$cfc2e5a80c7c6d5c$export$882461b6382ed46c = function(a, b) {
    if (!$cfc2e5a80c7c6d5c$var$ol(a)) throw Error($cfc2e5a80c7c6d5c$var$p(299));
    var c = !1, d = "", e = $cfc2e5a80c7c6d5c$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $cfc2e5a80c7c6d5c$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$cfc2e5a80c7c6d5c$var$uf] = b.current;
    $cfc2e5a80c7c6d5c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $cfc2e5a80c7c6d5c$var$ml(b);
};
$cfc2e5a80c7c6d5c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($cfc2e5a80c7c6d5c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($cfc2e5a80c7c6d5c$var$p(268, a));
    }
    a = $cfc2e5a80c7c6d5c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$cfc2e5a80c7c6d5c$export$cd75ccfd720a3cd4 = function(a) {
    return $cfc2e5a80c7c6d5c$var$Sk(a);
};
$cfc2e5a80c7c6d5c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$cfc2e5a80c7c6d5c$var$pl(b)) throw Error($cfc2e5a80c7c6d5c$var$p(200));
    return $cfc2e5a80c7c6d5c$var$sl(null, a, b, !0, c);
};
$cfc2e5a80c7c6d5c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$cfc2e5a80c7c6d5c$var$ol(a)) throw Error($cfc2e5a80c7c6d5c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $cfc2e5a80c7c6d5c$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $cfc2e5a80c7c6d5c$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$cfc2e5a80c7c6d5c$var$uf] = b.current;
    $cfc2e5a80c7c6d5c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $cfc2e5a80c7c6d5c$var$nl(b);
};
$cfc2e5a80c7c6d5c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$cfc2e5a80c7c6d5c$var$pl(b)) throw Error($cfc2e5a80c7c6d5c$var$p(200));
    return $cfc2e5a80c7c6d5c$var$sl(null, a, b, !1, c);
};
$cfc2e5a80c7c6d5c$export$502457920280e6be = function(a) {
    if (!$cfc2e5a80c7c6d5c$var$pl(a)) throw Error($cfc2e5a80c7c6d5c$var$p(40));
    return a._reactRootContainer ? ($cfc2e5a80c7c6d5c$var$Sk(function() {
        $cfc2e5a80c7c6d5c$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$cfc2e5a80c7c6d5c$var$uf] = null;
        });
    }), !0) : !1;
};
$cfc2e5a80c7c6d5c$export$c78a37762a8d58e1 = $cfc2e5a80c7c6d5c$var$Rk;
$cfc2e5a80c7c6d5c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$cfc2e5a80c7c6d5c$var$pl(c)) throw Error($cfc2e5a80c7c6d5c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($cfc2e5a80c7c6d5c$var$p(38));
    return $cfc2e5a80c7c6d5c$var$sl(a, b, c, !1, d);
};
$cfc2e5a80c7c6d5c$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("hIoV8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("37q2b"));

});
parcelRegister("37q2b", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2456385f9e2f9528$export$c4744153514ff05d; }, function (v) { return $2456385f9e2f9528$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2456385f9e2f9528$export$3e506c1ccc9cc1a7; }, function (v) { return $2456385f9e2f9528$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2456385f9e2f9528$export$e26fe2ed2fa76875; }, function (v) { return $2456385f9e2f9528$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2456385f9e2f9528$export$502329bbf4b505b1; }, function (v) { return $2456385f9e2f9528$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2456385f9e2f9528$export$6e3807111c4874c4; }, function (v) { return $2456385f9e2f9528$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2456385f9e2f9528$export$c27134553091fb3a; }, function (v) { return $2456385f9e2f9528$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2456385f9e2f9528$export$33ee1acdc04fd2a2; }, function (v) { return $2456385f9e2f9528$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2456385f9e2f9528$export$b00a404bbd5edef2; }, function (v) { return $2456385f9e2f9528$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $2456385f9e2f9528$export$8352ce38b91d0c62; }, function (v) { return $2456385f9e2f9528$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2456385f9e2f9528$export$d66a1c1c77bd778b; }, function (v) { return $2456385f9e2f9528$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2456385f9e2f9528$export$d3dfb8e4810cb555; }, function (v) { return $2456385f9e2f9528$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $2456385f9e2f9528$export$839f9183b0465a69; }, function (v) { return $2456385f9e2f9528$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2456385f9e2f9528$export$72fdf0e06517287b; }, function (v) { return $2456385f9e2f9528$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $2456385f9e2f9528$export$4b844e58a3e414b4; }, function (v) { return $2456385f9e2f9528$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2456385f9e2f9528$export$816d2913ae6b83b1; }, function (v) { return $2456385f9e2f9528$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2456385f9e2f9528$export$61bcfe829111a1d0; }, function (v) { return $2456385f9e2f9528$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2456385f9e2f9528$export$7ee8c9beb337bc3f; }, function (v) { return $2456385f9e2f9528$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2456385f9e2f9528$export$b5836b71941fa3ed; }, function (v) { return $2456385f9e2f9528$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2456385f9e2f9528$export$cf845f2c119da08a; }, function (v) { return $2456385f9e2f9528$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $k4vcf = parcelRequire("k4vcf");
var $2456385f9e2f9528$export$c4744153514ff05d;
var $2456385f9e2f9528$export$3e506c1ccc9cc1a7;
var $2456385f9e2f9528$export$e26fe2ed2fa76875;
var $2456385f9e2f9528$export$502329bbf4b505b1;
var $2456385f9e2f9528$export$6e3807111c4874c4;
var $2456385f9e2f9528$export$c27134553091fb3a;
var $2456385f9e2f9528$export$33ee1acdc04fd2a2;
var $2456385f9e2f9528$export$b00a404bbd5edef2;
var $2456385f9e2f9528$export$8352ce38b91d0c62;
var $2456385f9e2f9528$export$d66a1c1c77bd778b;
var $2456385f9e2f9528$export$d3dfb8e4810cb555;
var $2456385f9e2f9528$export$839f9183b0465a69;
var $2456385f9e2f9528$export$72fdf0e06517287b;
var $2456385f9e2f9528$export$4b844e58a3e414b4;
var $2456385f9e2f9528$export$816d2913ae6b83b1;
var $2456385f9e2f9528$export$61bcfe829111a1d0;
var $2456385f9e2f9528$export$7ee8c9beb337bc3f;
var $2456385f9e2f9528$export$b5836b71941fa3ed;
var $2456385f9e2f9528$export$cf845f2c119da08a;
'use strict';
function $2456385f9e2f9528$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $2456385f9e2f9528$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $2456385f9e2f9528$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $2456385f9e2f9528$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $2456385f9e2f9528$var$g(C, c)) n < e && 0 > $2456385f9e2f9528$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $2456385f9e2f9528$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $2456385f9e2f9528$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $k4vcf._)(performance)) && "function" === typeof performance.now) {
    var $2456385f9e2f9528$var$l = performance;
    $2456385f9e2f9528$export$c4744153514ff05d = function() {
        return $2456385f9e2f9528$var$l.now();
    };
} else {
    var $2456385f9e2f9528$var$p = Date, $2456385f9e2f9528$var$q = $2456385f9e2f9528$var$p.now();
    $2456385f9e2f9528$export$c4744153514ff05d = function() {
        return $2456385f9e2f9528$var$p.now() - $2456385f9e2f9528$var$q;
    };
}
var $2456385f9e2f9528$var$r = [], $2456385f9e2f9528$var$t = [], $2456385f9e2f9528$var$u = 1, $2456385f9e2f9528$var$v = null, $2456385f9e2f9528$var$y = 3, $2456385f9e2f9528$var$z = !1, $2456385f9e2f9528$var$A = !1, $2456385f9e2f9528$var$B = !1, $2456385f9e2f9528$var$D = "function" === typeof setTimeout ? setTimeout : null, $2456385f9e2f9528$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $2456385f9e2f9528$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $2456385f9e2f9528$var$G(a) {
    for(var b = $2456385f9e2f9528$var$h($2456385f9e2f9528$var$t); null !== b;){
        if (null === b.callback) $2456385f9e2f9528$var$k($2456385f9e2f9528$var$t);
        else if (b.startTime <= a) $2456385f9e2f9528$var$k($2456385f9e2f9528$var$t), b.sortIndex = b.expirationTime, $2456385f9e2f9528$var$f($2456385f9e2f9528$var$r, b);
        else break;
        b = $2456385f9e2f9528$var$h($2456385f9e2f9528$var$t);
    }
}
function $2456385f9e2f9528$var$H(a) {
    $2456385f9e2f9528$var$B = !1;
    $2456385f9e2f9528$var$G(a);
    if (!$2456385f9e2f9528$var$A) {
        if (null !== $2456385f9e2f9528$var$h($2456385f9e2f9528$var$r)) $2456385f9e2f9528$var$A = !0, $2456385f9e2f9528$var$I($2456385f9e2f9528$var$J);
        else {
            var b = $2456385f9e2f9528$var$h($2456385f9e2f9528$var$t);
            null !== b && $2456385f9e2f9528$var$K($2456385f9e2f9528$var$H, b.startTime - a);
        }
    }
}
function $2456385f9e2f9528$var$J(a, b) {
    $2456385f9e2f9528$var$A = !1;
    $2456385f9e2f9528$var$B && ($2456385f9e2f9528$var$B = !1, $2456385f9e2f9528$var$E($2456385f9e2f9528$var$L), $2456385f9e2f9528$var$L = -1);
    $2456385f9e2f9528$var$z = !0;
    var c = $2456385f9e2f9528$var$y;
    try {
        $2456385f9e2f9528$var$G(b);
        for($2456385f9e2f9528$var$v = $2456385f9e2f9528$var$h($2456385f9e2f9528$var$r); null !== $2456385f9e2f9528$var$v && (!($2456385f9e2f9528$var$v.expirationTime > b) || a && !$2456385f9e2f9528$var$M());){
            var d = $2456385f9e2f9528$var$v.callback;
            if ("function" === typeof d) {
                $2456385f9e2f9528$var$v.callback = null;
                $2456385f9e2f9528$var$y = $2456385f9e2f9528$var$v.priorityLevel;
                var e = d($2456385f9e2f9528$var$v.expirationTime <= b);
                b = $2456385f9e2f9528$export$c4744153514ff05d();
                "function" === typeof e ? $2456385f9e2f9528$var$v.callback = e : $2456385f9e2f9528$var$v === $2456385f9e2f9528$var$h($2456385f9e2f9528$var$r) && $2456385f9e2f9528$var$k($2456385f9e2f9528$var$r);
                $2456385f9e2f9528$var$G(b);
            } else $2456385f9e2f9528$var$k($2456385f9e2f9528$var$r);
            $2456385f9e2f9528$var$v = $2456385f9e2f9528$var$h($2456385f9e2f9528$var$r);
        }
        if (null !== $2456385f9e2f9528$var$v) var w = !0;
        else {
            var m = $2456385f9e2f9528$var$h($2456385f9e2f9528$var$t);
            null !== m && $2456385f9e2f9528$var$K($2456385f9e2f9528$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $2456385f9e2f9528$var$v = null, $2456385f9e2f9528$var$y = c, $2456385f9e2f9528$var$z = !1;
    }
}
var $2456385f9e2f9528$var$N = !1, $2456385f9e2f9528$var$O = null, $2456385f9e2f9528$var$L = -1, $2456385f9e2f9528$var$P = 5, $2456385f9e2f9528$var$Q = -1;
function $2456385f9e2f9528$var$M() {
    return $2456385f9e2f9528$export$c4744153514ff05d() - $2456385f9e2f9528$var$Q < $2456385f9e2f9528$var$P ? !1 : !0;
}
function $2456385f9e2f9528$var$R() {
    if (null !== $2456385f9e2f9528$var$O) {
        var a = $2456385f9e2f9528$export$c4744153514ff05d();
        $2456385f9e2f9528$var$Q = a;
        var b = !0;
        try {
            b = $2456385f9e2f9528$var$O(!0, a);
        } finally{
            b ? $2456385f9e2f9528$var$S() : ($2456385f9e2f9528$var$N = !1, $2456385f9e2f9528$var$O = null);
        }
    } else $2456385f9e2f9528$var$N = !1;
}
var $2456385f9e2f9528$var$S;
if ("function" === typeof $2456385f9e2f9528$var$F) $2456385f9e2f9528$var$S = function S() {
    $2456385f9e2f9528$var$F($2456385f9e2f9528$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2456385f9e2f9528$var$T = new MessageChannel, $2456385f9e2f9528$var$U = $2456385f9e2f9528$var$T.port2;
    $2456385f9e2f9528$var$T.port1.onmessage = $2456385f9e2f9528$var$R;
    $2456385f9e2f9528$var$S = function S() {
        $2456385f9e2f9528$var$U.postMessage(null);
    };
} else $2456385f9e2f9528$var$S = function S() {
    $2456385f9e2f9528$var$D($2456385f9e2f9528$var$R, 0);
};
function $2456385f9e2f9528$var$I(a) {
    $2456385f9e2f9528$var$O = a;
    $2456385f9e2f9528$var$N || ($2456385f9e2f9528$var$N = !0, $2456385f9e2f9528$var$S());
}
function $2456385f9e2f9528$var$K(a, b) {
    $2456385f9e2f9528$var$L = $2456385f9e2f9528$var$D(function() {
        a($2456385f9e2f9528$export$c4744153514ff05d());
    }, b);
}
$2456385f9e2f9528$export$3e506c1ccc9cc1a7 = 5;
$2456385f9e2f9528$export$e26fe2ed2fa76875 = 1;
$2456385f9e2f9528$export$502329bbf4b505b1 = 4;
$2456385f9e2f9528$export$6e3807111c4874c4 = 3;
$2456385f9e2f9528$export$c27134553091fb3a = null;
$2456385f9e2f9528$export$33ee1acdc04fd2a2 = 2;
$2456385f9e2f9528$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$2456385f9e2f9528$export$8352ce38b91d0c62 = function() {
    $2456385f9e2f9528$var$A || $2456385f9e2f9528$var$z || ($2456385f9e2f9528$var$A = !0, $2456385f9e2f9528$var$I($2456385f9e2f9528$var$J));
};
$2456385f9e2f9528$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2456385f9e2f9528$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$2456385f9e2f9528$export$d3dfb8e4810cb555 = function() {
    return $2456385f9e2f9528$var$y;
};
$2456385f9e2f9528$export$839f9183b0465a69 = function() {
    return $2456385f9e2f9528$var$h($2456385f9e2f9528$var$r);
};
$2456385f9e2f9528$export$72fdf0e06517287b = function(a) {
    switch($2456385f9e2f9528$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $2456385f9e2f9528$var$y;
    }
    var c = $2456385f9e2f9528$var$y;
    $2456385f9e2f9528$var$y = b;
    try {
        return a();
    } finally{
        $2456385f9e2f9528$var$y = c;
    }
};
$2456385f9e2f9528$export$4b844e58a3e414b4 = function() {};
$2456385f9e2f9528$export$816d2913ae6b83b1 = function() {};
$2456385f9e2f9528$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $2456385f9e2f9528$var$y;
    $2456385f9e2f9528$var$y = a;
    try {
        return b();
    } finally{
        $2456385f9e2f9528$var$y = c;
    }
};
$2456385f9e2f9528$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $2456385f9e2f9528$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $k4vcf._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $2456385f9e2f9528$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $2456385f9e2f9528$var$f($2456385f9e2f9528$var$t, a), null === $2456385f9e2f9528$var$h($2456385f9e2f9528$var$r) && a === $2456385f9e2f9528$var$h($2456385f9e2f9528$var$t) && ($2456385f9e2f9528$var$B ? ($2456385f9e2f9528$var$E($2456385f9e2f9528$var$L), $2456385f9e2f9528$var$L = -1) : $2456385f9e2f9528$var$B = !0, $2456385f9e2f9528$var$K($2456385f9e2f9528$var$H, c - d))) : (a.sortIndex = e, $2456385f9e2f9528$var$f($2456385f9e2f9528$var$r, a), $2456385f9e2f9528$var$A || $2456385f9e2f9528$var$z || ($2456385f9e2f9528$var$A = !0, $2456385f9e2f9528$var$I($2456385f9e2f9528$var$J)));
    return a;
};
$2456385f9e2f9528$export$b5836b71941fa3ed = $2456385f9e2f9528$var$M;
$2456385f9e2f9528$export$cf845f2c119da08a = function(a) {
    var b = $2456385f9e2f9528$var$y;
    return function() {
        var c = $2456385f9e2f9528$var$y;
        $2456385f9e2f9528$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $2456385f9e2f9528$var$y = c;
        }
    };
};

});



parcelRegister("hI7DA", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return Action; });
$parcel$export(module.exports, "createMemoryHistory", function () { return createMemoryHistory; });
$parcel$export(module.exports, "createPath", function () { return createPath; });
$parcel$export(module.exports, "parsePath", function () { return parsePath; });
$parcel$export(module.exports, "createBrowserHistory", function () { return createBrowserHistory; });
$parcel$export(module.exports, "createHashHistory", function () { return createHashHistory; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return invariant; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return decodePath; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return AbortedDeferredError; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return IDLE_FETCHER; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return IDLE_BLOCKER; });
$parcel$export(module.exports, "createRouter", function () { return createRouter; });
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bq3K4 = parcelRequire("bq3K4");

var $dOTqn = parcelRequire("dOTqn");

var $gNNCA = parcelRequire("gNNCA");

var $9fiLN = parcelRequire("9fiLN");

var $eYH8F = parcelRequire("eYH8F");

var $1594H = parcelRequire("1594H");

var $axlKX = parcelRequire("axlKX");

var $4YG5F = parcelRequire("4YG5F");

var $lJaNg = parcelRequire("lJaNg");

var $k4vcf = parcelRequire("k4vcf");

var $29eLC = parcelRequire("29eLC");

var $m9tdn = parcelRequire("m9tdn");

var $m9tdn = parcelRequire("m9tdn");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $lJaNg._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $4YG5F._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $lJaNg._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $lJaNg._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $axlKX._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $axlKX._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(_char, field, dest, path) {
    return "Cannot include a '" + _char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $gNNCA._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1594H._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $gNNCA._)(this, AbortedDeferredError);
        return (0, $dOTqn._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $29eLC._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $gNNCA._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && (typeof data === "undefined" ? "undefined" : (0, $k4vcf._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $axlKX._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $eYH8F._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $9fiLN._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise["catch"](function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet["delete"](key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers["delete"](fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet["delete"](k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $bq3K4._)(function() {
                    var aborted, onAbort;
                    return (0, $m9tdn.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $axlKX._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $eYH8F._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $gNNCA._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, $lJaNg._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $eYH8F._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) initialMatches = fogOfWar1.matches;
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers["delete"](fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $lJaNg._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers["delete"](key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $bq3K4._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $bq3K4._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $eYH8F._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $axlKX._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $eYH8F._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $bq3K4._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $bq3K4._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $eYH8F._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $eYH8F._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $axlKX._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $eYH8F._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers["delete"](rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds["delete"](routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $eYH8F._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $bq3K4._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches["delete"](key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers["delete"](key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $axlKX._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds["delete"](key);
                        fetchControllers["delete"](key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers["delete"](r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $bq3K4._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $bq3K4._)(function(request, redirect, isNavigation, _temp2) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $bq3K4._)(function(type, state, request, matchesToLoad, matches, fetcherKey) {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $axlKX._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $bq3K4._)(function(state, matches, matchesToLoad, fetchersToLoad, request) {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(/*#__PURE__*/ function() {
                            var _ref = (0, $bq3K4._)(function(f) {
                                var results, result;
                                return (0, $m9tdn.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, $eYH8F._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $eYH8F._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(f) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $lJaNg._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $eYH8F._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers["delete"](key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches["delete"](key);
        fetchReloadIds["delete"](key);
        fetchRedirectIds["delete"](key);
        deletedFetchers["delete"](key);
        cancelledFetcherLoads["delete"](key);
        state.fetchers["delete"](key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers["delete"](key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers["delete"](key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds["delete"](key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $axlKX._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds["delete"](key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers["delete"](key);
        blockerFunctions["delete"](key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $axlKX._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds["delete"](routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $bq3K4._)(function(matches, pathname, signal) {
            var _loop, partialMatches, _ret;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $m9tdn.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                path: pathname,
                                                matches: partialMatches,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $lJaNg._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $m9tdn.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $k4vcf._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $lJaNg._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $bq3K4._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $eYH8F._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $eYH8F._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $bq3K4._)(function(request, _temp4) {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $bq3K4._)(function(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $bq3K4._)(function(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $eYH8F._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, $eYH8F._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, $eYH8F._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $eYH8F._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $bq3K4._)(function(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $eYH8F._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $eYH8F._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $bq3K4._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
            var results, dataResults;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(/*#__PURE__*/ function() {
                                var _ref = (0, $bq3K4._)(function(match) {
                                    var result, response, _;
                                    return (0, $m9tdn.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(match) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $eYH8F._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params["delete"]("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $axlKX._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads["delete"](key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $lJaNg._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $bq3K4._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_ref4) {
    return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
    _defaultDataStrategy = // Default implementation of `dataStrategy` which fetches all loaders in parallel
    (0, $bq3K4._)(function(_ref4) {
        var matches, matchesToLoad, results;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $eYH8F._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    });
    return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, $bq3K4._)(function(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = /*#__PURE__*/ function() {
                            var _ref = (0, $bq3K4._)(function(handlerOverride) {
                                return (0, $m9tdn.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            });
                            return function resolve(handlerOverride) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $bq3K4._)(function(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $lJaNg._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = (0, $bq3K4._)(function() {
                            var val, e;
                            return (0, $m9tdn.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            handlerOverride ? handlerOverride(function(ctx) {
                                                return actualHandler(ctx);
                                            }) : actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler)["catch"](function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $axlKX._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function _convertDataStrategyResultToDataResult() {
    _convertDataStrategyResultToDataResult = (0, $bq3K4._)(function(dataStrategyResult) {
        var result, type, data, contentType, e, _result$init2, _result$init, _result$init3, _result$init4, _result$init5, _result$init6;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
                                headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $axlKX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $axlKX._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $eYH8F._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, $eYH8F._)({}, boundaryMatch.route.id, result.error));
            state.fetchers["delete"](key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $eYH8F._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $lJaNg._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $axlKX._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $k4vcf._)(result)) === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $k4vcf._)(deferred)) === "object" && (0, $k4vcf._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $k4vcf._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function _resolveNavigationDeferredResults() {
    _resolveNavigationDeferredResults = (0, $bq3K4._)(function(matches, results, signal, currentMatches, currentLoaderData) {
        var _loop, entries, index;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, $m9tdn.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, $axlKX._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $m9tdn.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function _resolveFetcherDeferredResults() {
    _resolveFetcherDeferredResults = (0, $bq3K4._)(function(matches, results, revalidatingFetchers) {
        var _loop, index;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, $m9tdn.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $m9tdn.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, $bq3K4._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $axlKX._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $axlKX._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $lJaNg._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("bq3K4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $850506896abefdfb$export$71511d61b312f219; });
function $850506896abefdfb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $850506896abefdfb$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $850506896abefdfb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $850506896abefdfb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("dOTqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0faefffcaf3587d$export$71511d61b312f219; });

var $hK71c = parcelRequire("hK71c");

var $b3EB6 = parcelRequire("b3EB6");

var $ivic3 = parcelRequire("ivic3");
function $a0faefffcaf3587d$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $hK71c._)(derived);
    return (0, $ivic3._)(_this, (0, $b3EB6._)() ? Reflect.construct(derived, args || [], (0, $hK71c._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("hK71c", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ceac2d419866b475$export$71511d61b312f219; });
function $ceac2d419866b475$export$71511d61b312f219(o) {
    $ceac2d419866b475$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ceac2d419866b475$export$71511d61b312f219(o);
}

});

parcelRegister("b3EB6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $80cf775653d774c9$export$71511d61b312f219; });
function $80cf775653d774c9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($80cf775653d774c9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("ivic3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d7893c103c585e35$export$71511d61b312f219; });

var $dXT6K = parcelRequire("dXT6K");

var $k4vcf = parcelRequire("k4vcf");
function $d7893c103c585e35$export$71511d61b312f219(self, call) {
    if (call && ((0, $k4vcf._)(call) === "object" || typeof call === "function")) return call;
    return (0, $dXT6K._)(self);
}

});
parcelRegister("dXT6K", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a2ab885717640ac8$export$71511d61b312f219; });
function $a2ab885717640ac8$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("gNNCA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b7b6bb02623acc$export$71511d61b312f219; });
function $c3b7b6bb02623acc$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9fiLN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6bb4130efa46408f$export$71511d61b312f219; });
function $6bb4130efa46408f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6bb4130efa46408f$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $6bb4130efa46408f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6bb4130efa46408f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("eYH8F", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae7821bf40ba4f13$export$71511d61b312f219; });
function $ae7821bf40ba4f13$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("1594H", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0c9d4c21d7e5fe5e$export$71511d61b312f219; });

var $7CSaq = parcelRequire("7CSaq");
function $0c9d4c21d7e5fe5e$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $7CSaq._)(subClass, superClass);
}

});
parcelRegister("7CSaq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $58d6197556fb783b$export$71511d61b312f219; });
function $58d6197556fb783b$export$71511d61b312f219(o, p) {
    $58d6197556fb783b$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $58d6197556fb783b$export$71511d61b312f219(o, p);
}

});


parcelRegister("axlKX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7abddccda67ebc53$export$71511d61b312f219; });

var $5UIcZ = parcelRequire("5UIcZ");

var $i7snR = parcelRequire("i7snR");

var $hdaXc = parcelRequire("hdaXc");

var $a9wwd = parcelRequire("a9wwd");
function $7abddccda67ebc53$export$71511d61b312f219(arr, i) {
    return (0, $5UIcZ._)(arr) || (0, $i7snR._)(arr, i) || (0, $a9wwd._)(arr, i) || (0, $hdaXc._)();
}

});
parcelRegister("5UIcZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $44e47994969cfad0$export$71511d61b312f219; });
function $44e47994969cfad0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("i7snR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d30ee5e13f781d35$export$71511d61b312f219; });
function $d30ee5e13f781d35$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("hdaXc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c87c25c180235356$export$71511d61b312f219; });
function $c87c25c180235356$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("a9wwd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7643f830ab2eadbf$export$71511d61b312f219; });

var $8dhiW = parcelRequire("8dhiW");
function $7643f830ab2eadbf$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $8dhiW._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $8dhiW._)(o, minLen);
}

});
parcelRegister("8dhiW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5facf5f22dc516fe$export$71511d61b312f219; });
function $5facf5f22dc516fe$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("4YG5F", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $39fd6a505025c7e0$export$71511d61b312f219; });

var $5UIcZ = parcelRequire("5UIcZ");

var $8oTsp = parcelRequire("8oTsp");

var $hdaXc = parcelRequire("hdaXc");

var $a9wwd = parcelRequire("a9wwd");
function $39fd6a505025c7e0$export$71511d61b312f219(arr) {
    return (0, $5UIcZ._)(arr) || (0, $8oTsp._)(arr) || (0, $a9wwd._)(arr) || (0, $hdaXc._)();
}

});
parcelRegister("8oTsp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $61db9548ab35982a$export$71511d61b312f219; });
function $61db9548ab35982a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("lJaNg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fd162c596548c216$export$71511d61b312f219; });

var $d0vPF = parcelRequire("d0vPF");

var $8oTsp = parcelRequire("8oTsp");

var $4cM5F = parcelRequire("4cM5F");

var $a9wwd = parcelRequire("a9wwd");
function $fd162c596548c216$export$71511d61b312f219(arr) {
    return (0, $d0vPF._)(arr) || (0, $8oTsp._)(arr) || (0, $a9wwd._)(arr) || (0, $4cM5F._)();
}

});
parcelRegister("d0vPF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9783f7af7e09e918$export$71511d61b312f219; });

var $8dhiW = parcelRequire("8dhiW");
function $9783f7af7e09e918$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $8dhiW._)(arr);
}

});

parcelRegister("4cM5F", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $30fd962b69cc1328$export$71511d61b312f219; });
function $30fd962b69cc1328$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("29eLC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1907e078d39e42ba$export$71511d61b312f219; });

var $hw4ub = parcelRequire("hw4ub");

var $hK71c = parcelRequire("hK71c");

var $lmd85 = parcelRequire("lmd85");

var $7CSaq = parcelRequire("7CSaq");
function $1907e078d39e42ba$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $1907e078d39e42ba$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $lmd85._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $hw4ub._)(Class, arguments, (0, $hK71c._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $7CSaq._)(Wrapper, Class);
    };
    return $1907e078d39e42ba$export$71511d61b312f219(Class);
}

});
parcelRegister("hw4ub", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc08e7a3474f975a$export$71511d61b312f219; });

var $b3EB6 = parcelRequire("b3EB6");

var $7CSaq = parcelRequire("7CSaq");
function $cc08e7a3474f975a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $b3EB6._)()) $cc08e7a3474f975a$export$71511d61b312f219 = Reflect.construct;
    else $cc08e7a3474f975a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $7CSaq._)(instance, Class.prototype);
        return instance;
    };
    return $cc08e7a3474f975a$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("lmd85", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f8c5d645df254407$export$71511d61b312f219; });
function $f8c5d645df254407$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("m9tdn", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $042966c634dbba79$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $042966c634dbba79$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $k4vcf = parcelRequire("k4vcf");
var $042966c634dbba79$var$extendStatics = function extendStatics1(d, b) {
    $042966c634dbba79$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $042966c634dbba79$var$extendStatics(d, b);
};
function $042966c634dbba79$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $042966c634dbba79$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $042966c634dbba79$export$18ce0697a983be9b = function __assign1() {
    $042966c634dbba79$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $042966c634dbba79$export$18ce0697a983be9b.apply(this, arguments);
};
function $042966c634dbba79$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $042966c634dbba79$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $k4vcf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $042966c634dbba79$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $042966c634dbba79$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $k4vcf._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $042966c634dbba79$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $042966c634dbba79$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $k4vcf._)(x)) === "symbol" ? x : "".concat(x);
}
function $042966c634dbba79$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $k4vcf._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $042966c634dbba79$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $k4vcf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $042966c634dbba79$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $042966c634dbba79$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $042966c634dbba79$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $042966c634dbba79$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $042966c634dbba79$export$45d3717a4c69092e(o, m, p);
}
function $042966c634dbba79$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $042966c634dbba79$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $042966c634dbba79$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($042966c634dbba79$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $042966c634dbba79$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $042966c634dbba79$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $042966c634dbba79$export$10c90e4f7922046c(v) {
    return this instanceof $042966c634dbba79$export$10c90e4f7922046c ? (this.v = v, this) : new $042966c634dbba79$export$10c90e4f7922046c(v);
}
function $042966c634dbba79$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $042966c634dbba79$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $042966c634dbba79$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $042966c634dbba79$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $042966c634dbba79$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $042966c634dbba79$export$19a8beecd37a4c45 === "function" ? $042966c634dbba79$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $042966c634dbba79$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $042966c634dbba79$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $042966c634dbba79$var$ownKeys = function ownKeys1(o) {
    $042966c634dbba79$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $042966c634dbba79$var$ownKeys(o);
};
function $042966c634dbba79$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $042966c634dbba79$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $042966c634dbba79$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $042966c634dbba79$var$__setModuleDefault(result, mod);
    return result;
}
function $042966c634dbba79$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $042966c634dbba79$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $042966c634dbba79$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $042966c634dbba79$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $k4vcf._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $042966c634dbba79$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $042966c634dbba79$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $042966c634dbba79$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $042966c634dbba79$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $042966c634dbba79$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $042966c634dbba79$export$2e2bcd8739ae039 = {
    __extends: $042966c634dbba79$export$a8ba968b8961cb8a,
    __assign: $042966c634dbba79$export$18ce0697a983be9b,
    __rest: $042966c634dbba79$export$3c9a16f847548506,
    __decorate: $042966c634dbba79$export$29e00dfd3077644b,
    __param: $042966c634dbba79$export$d5ad3fd78186038f,
    __esDecorate: $042966c634dbba79$export$3a84e1ae4e97e9b0,
    __runInitializers: $042966c634dbba79$export$d831c04e792af3d,
    __propKey: $042966c634dbba79$export$6a2a36740a146cb8,
    __setFunctionName: $042966c634dbba79$export$d1a06452d3489bc7,
    __metadata: $042966c634dbba79$export$f1db080c865becb9,
    __awaiter: $042966c634dbba79$export$1050f835b63b671e,
    __generator: $042966c634dbba79$export$67ebef60e6f28a6,
    __createBinding: $042966c634dbba79$export$45d3717a4c69092e,
    __exportStar: $042966c634dbba79$export$f33643c0debef087,
    __values: $042966c634dbba79$export$19a8beecd37a4c45,
    __read: $042966c634dbba79$export$8d051b38c9118094,
    __spread: $042966c634dbba79$export$afc72e2116322959,
    __spreadArrays: $042966c634dbba79$export$6388937ca91ccae8,
    __spreadArray: $042966c634dbba79$export$1216008129fb82ed,
    __await: $042966c634dbba79$export$10c90e4f7922046c,
    __asyncGenerator: $042966c634dbba79$export$e427f37a30a4de9b,
    __asyncDelegator: $042966c634dbba79$export$bbd80228419bb833,
    __asyncValues: $042966c634dbba79$export$e3b29a3d6162315f,
    __makeTemplateObject: $042966c634dbba79$export$4fb47efe1390b86f,
    __importStar: $042966c634dbba79$export$c21735bcef00d192,
    __importDefault: $042966c634dbba79$export$da59b14a69baef04,
    __classPrivateFieldGet: $042966c634dbba79$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $042966c634dbba79$export$d40a35129aaff81f,
    __classPrivateFieldIn: $042966c634dbba79$export$81fdc39f203e4e04,
    __addDisposableResource: $042966c634dbba79$export$88ac25d8e944e405,
    __disposeResources: $042966c634dbba79$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $042966c634dbba79$export$889dfb5d17574b0b
};

});


parcelRegister("yVSFb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $069012fc3f1fbb5b$export$bf730a2d8bf68b42; }, function (v) { return $069012fc3f1fbb5b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $069012fc3f1fbb5b$export$bf730a2d8bf68b42;
'use strict';

var $eN0cn = parcelRequire("eN0cn");
function $069012fc3f1fbb5b$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $069012fc3f1fbb5b$var$p = "function" === typeof Object.is ? Object.is : $069012fc3f1fbb5b$var$n, $069012fc3f1fbb5b$var$q = $eN0cn.useSyncExternalStore, $069012fc3f1fbb5b$var$r = $eN0cn.useRef, $069012fc3f1fbb5b$var$t = $eN0cn.useEffect, $069012fc3f1fbb5b$var$u = $eN0cn.useMemo, $069012fc3f1fbb5b$var$v = $eN0cn.useDebugValue;
$069012fc3f1fbb5b$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $069012fc3f1fbb5b$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $069012fc3f1fbb5b$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($069012fc3f1fbb5b$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $069012fc3f1fbb5b$var$q(a, c[0], c[1]);
    $069012fc3f1fbb5b$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $069012fc3f1fbb5b$var$v(d);
    return d;
};

});

parcelRegister("iLa78", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $dOTqn = parcelRequire("dOTqn");

var $gNNCA = parcelRequire("gNNCA");

var $9fiLN = parcelRequire("9fiLN");

var $eYH8F = parcelRequire("eYH8F");

var $1594H = parcelRequire("1594H");

var $axlKX = parcelRequire("axlKX");

var $lJaNg = parcelRequire("lJaNg");

var $k4vcf = parcelRequire("k4vcf");

var $29eLC = parcelRequire("29eLC");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol["for"]("immer-nothing");
var DRAFTABLE = Symbol["for"]("immer-draftable");
var DRAFT_STATE = Symbol["for"]("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj["delete"] = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $axlKX._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $k4vcf._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $gNNCA._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $lJaNg._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || (typeof base === "undefined" ? "undefined" : (0, $k4vcf._)(base)) !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $lJaNg._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $9fiLN._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if ((typeof base === "undefined" ? "undefined" : (0, $k4vcf._)(base)) !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base["delete"](key);
                        case 3 /* Set */ :
                            return base["delete"](patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $axlKX._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $1594H._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $gNNCA._)(this, DraftMap);
            var _this;
            _this = (0, $dOTqn._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $9fiLN._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_["delete"](key);
                    state.copy_["delete"](key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $eYH8F._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $eYH8F._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $eYH8F._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $eYH8F._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $29eLC._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $1594H._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $gNNCA._)(this, DraftSet);
            var _this;
            _this = (0, $dOTqn._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $9fiLN._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_["delete"](value) || (state.drafts_.has(value) ? state.copy_["delete"](state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $29eLC._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});

parcelRegister("8d5DK", function(module, exports) {


module.exports = (parcelRequire("cRZqc"))((parcelRequire("6IT3i")).resolve("XyC1X")).then(function() {
    return parcelRequire('2BO66');
});

});
parcelRegister("cRZqc", function(module, exports) {
"use strict";

var $cISvJ = parcelRequire("cISvJ");
module.exports = $cISvJ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("cISvJ", function(module, exports) {
"use strict";
var $9433e0d168033f6c$var$cachedBundles = {};
var $9433e0d168033f6c$var$cachedPreloads = {};
var $9433e0d168033f6c$var$cachedPrefetches = {};
function $9433e0d168033f6c$var$getCache(type) {
    switch(type){
        case 'preload':
            return $9433e0d168033f6c$var$cachedPreloads;
        case 'prefetch':
            return $9433e0d168033f6c$var$cachedPrefetches;
        default:
            return $9433e0d168033f6c$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9433e0d168033f6c$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $102ce40121bc485d$exports = {};


(parcelRequire("6IT3i")).register((parcelRequire("4vTas")).getBundleURL('hpNCx'), JSON.parse("[\"hpNCx\",\"index.19057117.js\",\"3awau\",\"pngaaa.82eca32a.png\",\"XyC1X\",\"Grocery.0e24ae61.js\"]"));


var $axlKX = parcelRequire("axlKX");

var $22qX1 = parcelRequire("22qX1");

var $eN0cn = parcelRequire("eN0cn");
var $446c27911db40913$exports = {};

$parcel$export($446c27911db40913$exports, "createRoot", function () { return $446c27911db40913$export$882461b6382ed46c; }, function (v) { return $446c27911db40913$export$882461b6382ed46c = v; });
$parcel$export($446c27911db40913$exports, "hydrateRoot", function () { return $446c27911db40913$export$757ceba2d55c277e; }, function (v) { return $446c27911db40913$export$757ceba2d55c277e = v; });
var $446c27911db40913$export$882461b6382ed46c;
var $446c27911db40913$export$757ceba2d55c277e;
'use strict';
var $9ac32e98257d5b48$exports = {};
'use strict';
function $9ac32e98257d5b48$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9ac32e98257d5b48$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9ac32e98257d5b48$var$checkDCE();

$9ac32e98257d5b48$exports = (parcelRequire("hPUkI"));


var $446c27911db40913$var$i;
$446c27911db40913$export$882461b6382ed46c = $9ac32e98257d5b48$exports.createRoot;
$446c27911db40913$export$757ceba2d55c277e = $9ac32e98257d5b48$exports.hydrateRoot;



var $axlKX = parcelRequire("axlKX");

var $22qX1 = parcelRequire("22qX1");
// constants.js
var $7fb67fe6c69adf0e$export$7478f66cc99621d3 = 'https://swiggy-proxy.gagansalian04102005.workers.dev';
var $7fb67fe6c69adf0e$export$5294eb8a5c857846 = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.3730376&lng=74.7071271&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
var $7fb67fe6c69adf0e$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $7fb67fe6c69adf0e$export$85dc8a20c452aa8a = "".concat($7fb67fe6c69adf0e$export$7478f66cc99621d3, "/?url=").concat(encodeURIComponent($7fb67fe6c69adf0e$export$5294eb8a5c857846));
var $7fb67fe6c69adf0e$export$b77c1aa4fb57bd1c = function(restaurantId) {
    return "".concat($7fb67fe6c69adf0e$export$7478f66cc99621d3, "/?url=").concat(encodeURIComponent("https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.3730376&lng=74.7071271&restaurantId=".concat(restaurantId)));
};



var $eN0cn = parcelRequire("eN0cn");
/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bq3K4 = parcelRequire("bq3K4");

var $gNNCA = parcelRequire("gNNCA");

var $axlKX = parcelRequire("axlKX");

var $m9tdn = parcelRequire("m9tdn");

var $eN0cn = parcelRequire("eN0cn");


var $hI7DA = parcelRequire("hI7DA");/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dOTqn = parcelRequire("dOTqn");

var $gNNCA = parcelRequire("gNNCA");

var $9fiLN = parcelRequire("9fiLN");

var $1594H = parcelRequire("1594H");

var $axlKX = parcelRequire("axlKX");

var $lJaNg = parcelRequire("lJaNg");

var $eN0cn = parcelRequire("eN0cn");

var $hI7DA = parcelRequire("hI7DA");
function $f0e056f577c778ce$var$_extends() {
    $f0e056f577c778ce$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0e056f577c778ce$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $f0e056f577c778ce$export$3add0d5dce533e2e = /*#__PURE__*/ $eN0cn.createContext(null);
var $f0e056f577c778ce$export$145dfa71566a64dc = /*#__PURE__*/ $eN0cn.createContext(null);
var $f0e056f577c778ce$var$AwaitContext = /*#__PURE__*/ $eN0cn.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $f0e056f577c778ce$export$26749e8557646306 = /*#__PURE__*/ $eN0cn.createContext(null);
var $f0e056f577c778ce$export$c7914228fb69b0f5 = /*#__PURE__*/ $eN0cn.createContext(null);
var $f0e056f577c778ce$export$9072aa6dd1f93057 = /*#__PURE__*/ $eN0cn.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $f0e056f577c778ce$var$RouteErrorContext = /*#__PURE__*/ $eN0cn.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $f0e056f577c778ce$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    var _React_useContext = $eN0cn.useContext($f0e056f577c778ce$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $f0e056f577c778ce$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $hI7DA.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $f0e056f577c778ce$export$9c954a9d03d32f4a() {
    return $eN0cn.useContext($f0e056f577c778ce$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $f0e056f577c778ce$export$45d76561a5302f2b() {
    !$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    return $eN0cn.useContext($f0e056f577c778ce$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $f0e056f577c778ce$export$1b3f31771c5d07c() {
    return $eN0cn.useContext($f0e056f577c778ce$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $f0e056f577c778ce$export$6c330e8992e8a295(pattern) {
    !$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    var pathname = $f0e056f577c778ce$export$45d76561a5302f2b().pathname;
    return $eN0cn.useMemo(function() {
        return (0, $hI7DA.matchPath)(pattern, (0, $hI7DA.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $f0e056f577c778ce$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f0e056f577c778ce$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $eN0cn.useContext($f0e056f577c778ce$export$26749e8557646306)["static"];
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eN0cn.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $f0e056f577c778ce$export$9770f232ac06a008() {
    var isDataRoute = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f0e056f577c778ce$var$useNavigateStable() : $f0e056f577c778ce$var$useNavigateUnstable();
}
function $f0e056f577c778ce$var$useNavigateUnstable() {
    !$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    var dataRouterContext = $eN0cn.useContext($f0e056f577c778ce$export$3add0d5dce533e2e);
    var _React_useContext = $eN0cn.useContext($f0e056f577c778ce$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0e056f577c778ce$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $hI7DA.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = $eN0cn.useRef(false);
    $f0e056f577c778ce$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $eN0cn.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $hI7DA.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $hI7DA.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $f0e056f577c778ce$var$OutletContext = /*#__PURE__*/ $eN0cn.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $f0e056f577c778ce$export$4138103a3ae699cc() {
    return $eN0cn.useContext($f0e056f577c778ce$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $f0e056f577c778ce$export$a3be3530d8e40d0b(context) {
    var outlet = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $f0e056f577c778ce$export$99eaa27ddbbb95ef() {
    var matches = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $f0e056f577c778ce$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $eN0cn.useContext($f0e056f577c778ce$export$26749e8557646306).future;
    var matches = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0e056f577c778ce$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $hI7DA.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eN0cn.useMemo(function() {
        return (0, $hI7DA.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $f0e056f577c778ce$export$5d3fca4a98652595(routes, locationArg) {
    return $f0e056f577c778ce$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f0e056f577c778ce$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    var navigator = $eN0cn.useContext($f0e056f577c778ce$export$26749e8557646306).navigator;
    var _React_useContext = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $f0e056f577c778ce$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $hI7DA.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $hI7DA.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $hI7DA.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $f0e056f577c778ce$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $hI7DA.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $hI7DA.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f0e056f577c778ce$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $hI7DA.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f0e056f577c778ce$var$DefaultErrorComponent() {
    var error = $f0e056f577c778ce$export$ed527bf60f6e05f2();
    var message = (0, $hI7DA.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $eN0cn.createElement($eN0cn.Fragment, null, /*#__PURE__*/ $eN0cn.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eN0cn.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eN0cn.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $f0e056f577c778ce$var$defaultErrorElement = /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$DefaultErrorComponent, null);
var $f0e056f577c778ce$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $1594H._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $gNNCA._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $dOTqn._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $9fiLN._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($eN0cn.Component);
function $f0e056f577c778ce$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $eN0cn.useContext($f0e056f577c778ce$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext["static"] && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f0e056f577c778ce$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $hI7DA.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $f0e056f577c778ce$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f0e056f577c778ce$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eN0cn.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f0e056f577c778ce$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($f0e056f577c778ce$var$DataRouterHook || {});
var $f0e056f577c778ce$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($f0e056f577c778ce$var$DataRouterStateHook || {});
function $f0e056f577c778ce$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $f0e056f577c778ce$var$useDataRouterContext(hookName) {
    var ctx = $eN0cn.useContext($f0e056f577c778ce$export$3add0d5dce533e2e);
    !ctx && (0, $hI7DA.UNSAFE_invariant)(false);
    return ctx;
}
function $f0e056f577c778ce$var$useDataRouterState(hookName) {
    var state = $eN0cn.useContext($f0e056f577c778ce$export$145dfa71566a64dc);
    !state && (0, $hI7DA.UNSAFE_invariant)(false);
    return state;
}
function $f0e056f577c778ce$var$useRouteContext(hookName) {
    var route = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057);
    !route && (0, $hI7DA.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f0e056f577c778ce$var$useCurrentRouteId(hookName) {
    var route = $f0e056f577c778ce$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $hI7DA.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f0e056f577c778ce$export$5fc8298006ad9e58() {
    return $f0e056f577c778ce$var$useCurrentRouteId($f0e056f577c778ce$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f0e056f577c778ce$export$d0fd4b7106de2769() {
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f0e056f577c778ce$export$600dc272ed516c15() {
    var dataRouterContext = $f0e056f577c778ce$var$useDataRouterContext($f0e056f577c778ce$var$DataRouterHook.UseRevalidator);
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseRevalidator);
    return $eN0cn.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f0e056f577c778ce$export$2378eb7f5ff86053() {
    var _useDataRouterState = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $eN0cn.useMemo(function() {
        return matches.map(function(m) {
            return (0, $hI7DA.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f0e056f577c778ce$export$1448a5050d252c4d() {
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseLoaderData);
    var routeId = $f0e056f577c778ce$var$useCurrentRouteId($f0e056f577c778ce$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f0e056f577c778ce$export$fd5d37484eab868d(routeId) {
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f0e056f577c778ce$export$fdc00f3f26066d5e() {
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseActionData);
    var routeId = $f0e056f577c778ce$var$useCurrentRouteId($f0e056f577c778ce$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f0e056f577c778ce$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $eN0cn.useContext($f0e056f577c778ce$var$RouteErrorContext);
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseRouteError);
    var routeId = $f0e056f577c778ce$var$useCurrentRouteId($f0e056f577c778ce$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $f0e056f577c778ce$export$78a72ddb39bdd145() {
    var value = $eN0cn.useContext($f0e056f577c778ce$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $f0e056f577c778ce$export$17f53340677d5831() {
    var value = $eN0cn.useContext($f0e056f577c778ce$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $f0e056f577c778ce$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f0e056f577c778ce$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $f0e056f577c778ce$var$useDataRouterContext($f0e056f577c778ce$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $f0e056f577c778ce$var$useDataRouterState($f0e056f577c778ce$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $axlKX._)($eN0cn.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $eN0cn.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $f0e056f577c778ce$var$_extends({}, currentLocation, {
                pathname: (0, $hI7DA.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f0e056f577c778ce$var$_extends({}, nextLocation, {
                pathname: (0, $hI7DA.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eN0cn.useEffect(function() {
        var key = String(++$f0e056f577c778ce$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eN0cn.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $hI7DA.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f0e056f577c778ce$var$useNavigateStable() {
    var router = $f0e056f577c778ce$var$useDataRouterContext($f0e056f577c778ce$var$DataRouterHook.UseNavigateStable).router;
    var id = $f0e056f577c778ce$var$useCurrentRouteId($f0e056f577c778ce$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $eN0cn.useRef(false);
    $f0e056f577c778ce$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $eN0cn.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f0e056f577c778ce$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $f0e056f577c778ce$var$alreadyWarned$1 = {};
function $f0e056f577c778ce$var$warningOnce(key, cond, message) {
    if (!cond && !$f0e056f577c778ce$var$alreadyWarned$1[key]) $f0e056f577c778ce$var$alreadyWarned$1[key] = true;
}
var $f0e056f577c778ce$var$alreadyWarned = {};
function $f0e056f577c778ce$var$warnOnce(key, message) {
    if (!$f0e056f577c778ce$var$alreadyWarned[message]) {
        $f0e056f577c778ce$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
var $f0e056f577c778ce$var$logDeprecation = function(flag, msg, link) {
    return $f0e056f577c778ce$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
};
function $f0e056f577c778ce$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $f0e056f577c778ce$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $f0e056f577c778ce$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $f0e056f577c778ce$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $f0e056f577c778ce$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $f0e056f577c778ce$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $f0e056f577c778ce$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $f0e056f577c778ce$var$START_TRANSITION = "startTransition";
var $f0e056f577c778ce$var$startTransitionImpl = $eN0cn[$f0e056f577c778ce$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f0e056f577c778ce$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $axlKX._)($eN0cn.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $eN0cn.useCallback(function(newState) {
        if (v7_startTransition && $f0e056f577c778ce$var$startTransitionImpl) $f0e056f577c778ce$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eN0cn.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $eN0cn.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $eN0cn.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $eN0cn.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    $eN0cn.useEffect(function() {
        return $f0e056f577c778ce$export$db5148ec97d6af7a(future, router.future);
    }, [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eN0cn.createElement($eN0cn.Fragment, null, /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $f0e056f577c778ce$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $f0e056f577c778ce$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $f0e056f577c778ce$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $eN0cn.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hI7DA.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $axlKX._)($eN0cn.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $eN0cn.useCallback(function(newState) {
        v7_startTransition && $f0e056f577c778ce$var$startTransitionImpl ? $f0e056f577c778ce$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eN0cn.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $eN0cn.useEffect(function() {
        return $f0e056f577c778ce$export$db5148ec97d6af7a(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $f0e056f577c778ce$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    var _React_useContext = $eN0cn.useContext($f0e056f577c778ce$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext["static"];
    var matches = $eN0cn.useContext($f0e056f577c778ce$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0e056f577c778ce$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $f0e056f577c778ce$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $hI7DA.resolveTo)(to, (0, $hI7DA.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $eN0cn.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $f0e056f577c778ce$export$910ae8079b2c2852(props) {
    return $f0e056f577c778ce$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $f0e056f577c778ce$export$e7b0ac011bb776c6(_props) {
    (0, $hI7DA.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $f0e056f577c778ce$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $hI7DA.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5["static"], staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$f0e056f577c778ce$export$9c954a9d03d32f4a() && (0, $hI7DA.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $eN0cn.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $f0e056f577c778ce$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $hI7DA.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $eN0cn.useMemo(function() {
        var trailingPathname = (0, $hI7DA.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $f0e056f577c778ce$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $f0e056f577c778ce$export$5d3fca4a98652595($f0e056f577c778ce$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f0e056f577c778ce$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$ResolveAwait, null, children));
}
var $f0e056f577c778ce$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($f0e056f577c778ce$var$AwaitRenderStatus || {});
var $f0e056f577c778ce$var$neverSettledPromise = new Promise(function() {});
var $f0e056f577c778ce$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $1594H._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $gNNCA._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $dOTqn._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $9fiLN._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $f0e056f577c778ce$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $f0e056f577c778ce$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $f0e056f577c778ce$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject()["catch"](function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $f0e056f577c778ce$var$AwaitRenderStatus.error : "_data" in promise ? $f0e056f577c778ce$var$AwaitRenderStatus.success : $f0e056f577c778ce$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $f0e056f577c778ce$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $f0e056f577c778ce$var$AwaitRenderStatus.error && promise._error instanceof (0, $hI7DA.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $f0e056f577c778ce$var$neverSettledPromise;
                if (status === $f0e056f577c778ce$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $f0e056f577c778ce$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $f0e056f577c778ce$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $eN0cn.createElement($f0e056f577c778ce$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($eN0cn.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $f0e056f577c778ce$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $f0e056f577c778ce$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eN0cn.createElement($eN0cn.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $f0e056f577c778ce$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $eN0cn.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $eN0cn.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $lJaNg._)(parentPath).concat([
            index
        ]);
        if (element.type === $eN0cn.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f0e056f577c778ce$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f0e056f577c778ce$export$e7b0ac011bb776c6) && (0, $hI7DA.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $hI7DA.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f0e056f577c778ce$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f0e056f577c778ce$export$daf73786167a7f72(matches) {
    return $f0e056f577c778ce$var$_renderMatches(matches);
}
function $f0e056f577c778ce$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eN0cn.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eN0cn.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eN0cn.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f0e056f577c778ce$export$f30f7e456d254e83(routes, opts) {
    return (0, $hI7DA.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f0e056f577c778ce$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hI7DA.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f0e056f577c778ce$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $hI7DA = parcelRequire("hI7DA");
function $df9553b03ed5684d$var$_extends() {
    $df9553b03ed5684d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $df9553b03ed5684d$var$_extends.apply(this, arguments);
}
function $df9553b03ed5684d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $df9553b03ed5684d$var$defaultMethod = "get";
var $df9553b03ed5684d$var$defaultEncType = "application/x-www-form-urlencoded";
function $df9553b03ed5684d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $df9553b03ed5684d$var$isButtonElement(object) {
    return $df9553b03ed5684d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $df9553b03ed5684d$var$isFormElement(object) {
    return $df9553b03ed5684d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $df9553b03ed5684d$var$isInputElement(object) {
    return $df9553b03ed5684d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $df9553b03ed5684d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $df9553b03ed5684d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$df9553b03ed5684d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $df9553b03ed5684d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $df9553b03ed5684d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $df9553b03ed5684d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $df9553b03ed5684d$var$_formDataSupportsSubmitter = null;
function $df9553b03ed5684d$var$isFormDataSubmitterSupported() {
    if ($df9553b03ed5684d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $df9553b03ed5684d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $df9553b03ed5684d$var$_formDataSupportsSubmitter = true;
    }
    return $df9553b03ed5684d$var$_formDataSupportsSubmitter;
}
var $df9553b03ed5684d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $df9553b03ed5684d$var$getFormEncType(encType) {
    if (encType != null && !$df9553b03ed5684d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $df9553b03ed5684d$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($df9553b03ed5684d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $hI7DA.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $df9553b03ed5684d$var$defaultMethod;
        encType = $df9553b03ed5684d$var$getFormEncType(target.getAttribute("enctype")) || $df9553b03ed5684d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($df9553b03ed5684d$var$isButtonElement(target) || $df9553b03ed5684d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $hI7DA.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $df9553b03ed5684d$var$defaultMethod;
        encType = $df9553b03ed5684d$var$getFormEncType(target.getAttribute("formenctype")) || $df9553b03ed5684d$var$getFormEncType(form.getAttribute("enctype")) || $df9553b03ed5684d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$df9553b03ed5684d$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($df9553b03ed5684d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $df9553b03ed5684d$var$defaultMethod;
        action = null;
        encType = $df9553b03ed5684d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $df9553b03ed5684d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $df9553b03ed5684d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $df9553b03ed5684d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $df9553b03ed5684d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $df9553b03ed5684d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $df9553b03ed5684d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $hI7DA.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $df9553b03ed5684d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hI7DA.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $df9553b03ed5684d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f0e056f577c778ce$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $df9553b03ed5684d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $hI7DA.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $df9553b03ed5684d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hI7DA.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $df9553b03ed5684d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f0e056f577c778ce$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $df9553b03ed5684d$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $df9553b03ed5684d$var$_extends({}, state, {
        errors: $df9553b03ed5684d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $df9553b03ed5684d$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $axlKX._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $hI7DA.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $df9553b03ed5684d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eN0cn.createContext({
    isTransitioning: false
});
var $df9553b03ed5684d$export$148fd98d095596d4 = /*#__PURE__*/ $eN0cn.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $df9553b03ed5684d$var$START_TRANSITION = "startTransition";
var $df9553b03ed5684d$var$startTransitionImpl = $eN0cn[$df9553b03ed5684d$var$START_TRANSITION];
var $df9553b03ed5684d$var$FLUSH_SYNC = "flushSync";
var $df9553b03ed5684d$var$flushSyncImpl = $9ac32e98257d5b48$exports[$df9553b03ed5684d$var$FLUSH_SYNC];
var $df9553b03ed5684d$var$USE_ID = "useId";
var $df9553b03ed5684d$var$useIdImpl = $eN0cn[$df9553b03ed5684d$var$USE_ID];
function $df9553b03ed5684d$var$startTransitionSafe(cb) {
    if ($df9553b03ed5684d$var$startTransitionImpl) $df9553b03ed5684d$var$startTransitionImpl(cb);
    else cb();
}
function $df9553b03ed5684d$var$flushSyncSafe(cb) {
    if ($df9553b03ed5684d$var$flushSyncImpl) $df9553b03ed5684d$var$flushSyncImpl(cb);
    else cb();
}
var $df9553b03ed5684d$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $gNNCA._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $df9553b03ed5684d$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $axlKX._)($eN0cn.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $axlKX._)($eN0cn.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $axlKX._)($eN0cn.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $axlKX._)($eN0cn.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $axlKX._)($eN0cn.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $axlKX._)($eN0cn.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $eN0cn.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $eN0cn.useCallback(function(cb) {
        if (v7_startTransition) $df9553b03ed5684d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $eN0cn.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current["delete"](key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $df9553b03ed5684d$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $df9553b03ed5684d$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $df9553b03ed5684d$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished["finally"](function() {
                $df9553b03ed5684d$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $df9553b03ed5684d$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eN0cn.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eN0cn.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $df9553b03ed5684d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eN0cn.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $bq3K4._)(function() {
                return (0, $m9tdn.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished["finally"](function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eN0cn.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eN0cn.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eN0cn.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $eN0cn.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $eN0cn.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $eN0cn.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    $eN0cn.useEffect(function() {
        return (0, $f0e056f577c778ce$export$db5148ec97d6af7a)(future, router.future);
    }, [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eN0cn.createElement($eN0cn.Fragment, null, /*#__PURE__*/ $eN0cn.createElement((0, $f0e056f577c778ce$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eN0cn.createElement((0, $f0e056f577c778ce$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $eN0cn.createElement($df9553b03ed5684d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eN0cn.createElement($df9553b03ed5684d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eN0cn.createElement((0, $f0e056f577c778ce$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eN0cn.createElement($df9553b03ed5684d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $df9553b03ed5684d$var$MemoizedDataRoutes = /*#__PURE__*/ $eN0cn.memo($df9553b03ed5684d$var$DataRoutes);
function $df9553b03ed5684d$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $f0e056f577c778ce$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $df9553b03ed5684d$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $eN0cn.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hI7DA.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $axlKX._)($eN0cn.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $eN0cn.useCallback(function(newState) {
        v7_startTransition && $df9553b03ed5684d$var$startTransitionImpl ? $df9553b03ed5684d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eN0cn.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $eN0cn.useEffect(function() {
        return (0, $f0e056f577c778ce$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $eN0cn.createElement((0, $f0e056f577c778ce$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $df9553b03ed5684d$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $eN0cn.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hI7DA.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $axlKX._)($eN0cn.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $eN0cn.useCallback(function(newState) {
        v7_startTransition && $df9553b03ed5684d$var$startTransitionImpl ? $df9553b03ed5684d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eN0cn.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $eN0cn.useEffect(function() {
        return (0, $f0e056f577c778ce$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $eN0cn.createElement((0, $f0e056f577c778ce$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $df9553b03ed5684d$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $axlKX._)($eN0cn.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $eN0cn.useCallback(function(newState) {
        v7_startTransition && $df9553b03ed5684d$var$startTransitionImpl ? $df9553b03ed5684d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eN0cn.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $eN0cn.useEffect(function() {
        return (0, $f0e056f577c778ce$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $eN0cn.createElement((0, $f0e056f577c778ce$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $df9553b03ed5684d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $df9553b03ed5684d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $df9553b03ed5684d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eN0cn.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = $df9553b03ed5684d$var$_objectWithoutPropertiesLoose(_ref7, $df9553b03ed5684d$var$_excluded);
    var basename = $eN0cn.useContext((0, $f0e056f577c778ce$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $df9553b03ed5684d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($df9553b03ed5684d$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $hI7DA.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $f0e056f577c778ce$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $df9553b03ed5684d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eN0cn.createElement("a", $df9553b03ed5684d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $df9553b03ed5684d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eN0cn.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = $df9553b03ed5684d$var$_objectWithoutPropertiesLoose(_ref8, $df9553b03ed5684d$var$_excluded2);
    var path = (0, $f0e056f577c778ce$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $f0e056f577c778ce$export$45d76561a5302f2b)();
    var routerState = $eN0cn.useContext((0, $f0e056f577c778ce$export$145dfa71566a64dc));
    var _React_useContext = $eN0cn.useContext((0, $f0e056f577c778ce$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $df9553b03ed5684d$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $hI7DA.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eN0cn.createElement($df9553b03ed5684d$export$a6c7ac8248d6e38a, $df9553b03ed5684d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $df9553b03ed5684d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eN0cn.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $df9553b03ed5684d$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = $df9553b03ed5684d$var$_objectWithoutPropertiesLoose(_ref9, $df9553b03ed5684d$var$_excluded3);
    var submit = $df9553b03ed5684d$export$47c85c6e3a081d3();
    var formAction = $df9553b03ed5684d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $eN0cn.createElement("form", $df9553b03ed5684d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $df9553b03ed5684d$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $df9553b03ed5684d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $df9553b03ed5684d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($df9553b03ed5684d$var$DataRouterHook || ($df9553b03ed5684d$var$DataRouterHook = {}));
var $df9553b03ed5684d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($df9553b03ed5684d$var$DataRouterStateHook || ($df9553b03ed5684d$var$DataRouterStateHook = {}));
// Internal hooks
function $df9553b03ed5684d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $df9553b03ed5684d$var$useDataRouterContext(hookName) {
    var ctx = $eN0cn.useContext((0, $f0e056f577c778ce$export$3add0d5dce533e2e));
    !ctx && (0, $hI7DA.UNSAFE_invariant)(false);
    return ctx;
}
function $df9553b03ed5684d$var$useDataRouterState(hookName) {
    var state = $eN0cn.useContext((0, $f0e056f577c778ce$export$145dfa71566a64dc));
    !state && (0, $hI7DA.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $df9553b03ed5684d$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, $f0e056f577c778ce$export$9770f232ac06a008)();
    var location = (0, $f0e056f577c778ce$export$45d76561a5302f2b)();
    var path = (0, $f0e056f577c778ce$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $eN0cn.useCallback(function(event) {
        if ($df9553b03ed5684d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $hI7DA.createPath)(location) === (0, $hI7DA.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $df9553b03ed5684d$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $eN0cn.useRef($df9553b03ed5684d$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $eN0cn.useRef(false);
    var location = (0, $f0e056f577c778ce$export$45d76561a5302f2b)();
    var searchParams = $eN0cn.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $df9553b03ed5684d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $f0e056f577c778ce$export$9770f232ac06a008)();
    var setSearchParams = $eN0cn.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $df9553b03ed5684d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $df9553b03ed5684d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $df9553b03ed5684d$var$fetcherId = 0;
var $df9553b03ed5684d$var$getUniqueFetcherId = function() {
    return "__" + String(++$df9553b03ed5684d$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $df9553b03ed5684d$export$47c85c6e3a081d3() {
    var router = $df9553b03ed5684d$var$useDataRouterContext($df9553b03ed5684d$var$DataRouterHook.UseSubmit).router;
    var basename = $eN0cn.useContext((0, $f0e056f577c778ce$export$26749e8557646306)).basename;
    var currentRouteId = (0, $f0e056f577c778ce$export$5fc8298006ad9e58)();
    return $eN0cn.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $df9553b03ed5684d$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $df9553b03ed5684d$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $df9553b03ed5684d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $df9553b03ed5684d$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $eN0cn.useContext((0, $f0e056f577c778ce$export$26749e8557646306)).basename;
    var routeContext = $eN0cn.useContext((0, $f0e056f577c778ce$export$9072aa6dd1f93057));
    !routeContext && (0, $hI7DA.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $axlKX._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $df9553b03ed5684d$var$_extends({}, (0, $f0e056f577c778ce$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $f0e056f577c778ce$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params["delete"]("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $hI7DA.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $hI7DA.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $df9553b03ed5684d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $df9553b03ed5684d$var$useDataRouterContext($df9553b03ed5684d$var$DataRouterHook.UseFetcher).router;
    var state = $df9553b03ed5684d$var$useDataRouterState($df9553b03ed5684d$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $eN0cn.useContext($df9553b03ed5684d$export$148fd98d095596d4);
    var route = $eN0cn.useContext((0, $f0e056f577c778ce$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $hI7DA.UNSAFE_invariant)(false);
    !route && (0, $hI7DA.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $hI7DA.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $df9553b03ed5684d$var$useIdImpl ? $df9553b03ed5684d$var$useIdImpl() : "";
    var _React_useState = (0, $axlKX._)($eN0cn.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($df9553b03ed5684d$var$getUniqueFetcherId());
    // Registration/cleanup
    $eN0cn.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $eN0cn.useCallback(function(href, opts) {
        !routeId && (0, $hI7DA.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $df9553b03ed5684d$export$47c85c6e3a081d3();
    var submit = $eN0cn.useCallback(function(target, opts) {
        submitImpl(target, $df9553b03ed5684d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $eN0cn.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $eN0cn.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $eN0cn.createElement($df9553b03ed5684d$export$a7fed597f4b8afd8, $df9553b03ed5684d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $hI7DA.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $eN0cn.useMemo(function() {
        return $df9553b03ed5684d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $df9553b03ed5684d$export$fa996778a3a31087() {
    var state = $df9553b03ed5684d$var$useDataRouterState($df9553b03ed5684d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $axlKX._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $df9553b03ed5684d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $df9553b03ed5684d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $df9553b03ed5684d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $df9553b03ed5684d$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $df9553b03ed5684d$var$useDataRouterContext($df9553b03ed5684d$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $df9553b03ed5684d$var$useDataRouterState($df9553b03ed5684d$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $eN0cn.useContext((0, $f0e056f577c778ce$export$26749e8557646306)).basename;
    var location = (0, $f0e056f577c778ce$export$45d76561a5302f2b)();
    var matches = (0, $f0e056f577c778ce$export$2378eb7f5ff86053)();
    var navigation = (0, $f0e056f577c778ce$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $eN0cn.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $df9553b03ed5684d$var$usePageHide($eN0cn.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $df9553b03ed5684d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $df9553b03ed5684d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($df9553b03ed5684d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eN0cn.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $df9553b03ed5684d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $df9553b03ed5684d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eN0cn.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($df9553b03ed5684d$var$_extends({}, location, {
                    pathname: (0, $hI7DA.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($df9553b03ed5684d$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eN0cn.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $df9553b03ed5684d$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $eN0cn.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $df9553b03ed5684d$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $eN0cn.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $df9553b03ed5684d$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $f0e056f577c778ce$export$b273b3273281a049)(when);
    $eN0cn.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eN0cn.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $df9553b03ed5684d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $eN0cn.useContext($df9553b03ed5684d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $hI7DA.UNSAFE_invariant)(false);
    var basename = $df9553b03ed5684d$var$useDataRouterContext($df9553b03ed5684d$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $f0e056f577c778ce$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $hI7DA.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $hI7DA.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $hI7DA.matchPath)(path.pathname, nextPath) != null || (0, $hI7DA.matchPath)(path.pathname, currentPath) != null;
}



var $axlKX = parcelRequire("axlKX");

var $eN0cn = parcelRequire("eN0cn");
var $407b08b21203010a$var$useOnlineStatus = function() {
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(true), 2), onlineStatus = _useState[0], setonlineStatus = _useState[1];
    (0, $eN0cn.useEffect)(function() {
        window.addEventListener("offline", function() {
            setonlineStatus(false);
        });
        window.addEventListener("online", function() {
            setonlineStatus(true);
        });
    }, []);
    return onlineStatus;
};
var $407b08b21203010a$export$2e2bcd8739ae039 = $407b08b21203010a$var$useOnlineStatus;



var $eN0cn = parcelRequire("eN0cn");
var $ce4e95b53dbe8cd7$var$UserContext = /*#__PURE__*/ (0, $eN0cn.createContext)({
    loggedInUser: "Salian"
});
var $ce4e95b53dbe8cd7$export$2e2bcd8739ae039 = $ce4e95b53dbe8cd7$var$UserContext;



var $eYH8F = parcelRequire("eYH8F");

var $axlKX = parcelRequire("axlKX");

var $lJaNg = parcelRequire("lJaNg");

var $k4vcf = parcelRequire("k4vcf");

var $eN0cn = parcelRequire("eN0cn");
var $44d8fffa6ef7bf88$exports = {};
'use strict';

$44d8fffa6ef7bf88$exports = (parcelRequire("yVSFb"));


var $130b58dab455a653$var$__defProp = Object.defineProperty;
var $130b58dab455a653$var$__defProps = Object.defineProperties;
var $130b58dab455a653$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $130b58dab455a653$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $130b58dab455a653$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $130b58dab455a653$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $130b58dab455a653$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $130b58dab455a653$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $130b58dab455a653$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($130b58dab455a653$var$__hasOwnProp.call(b, prop)) $130b58dab455a653$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($130b58dab455a653$var$__getOwnPropSymbols) try {
        for(var _iterator = $130b58dab455a653$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($130b58dab455a653$var$__propIsEnum.call(b, prop)) $130b58dab455a653$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $130b58dab455a653$var$__spreadProps = function(a, b) {
    return $130b58dab455a653$var$__defProps(a, $130b58dab455a653$var$__getOwnPropDescs(b));
};
var $130b58dab455a653$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($130b58dab455a653$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $130b58dab455a653$var$__getOwnPropSymbols) try {
        for(var _iterator = $130b58dab455a653$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $130b58dab455a653$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $130b58dab455a653$var$React = // prettier-ignore
// @ts-ignore
"default" in $eN0cn ? $eN0cn["default"] : $eN0cn;
// src/components/Context.ts
var $130b58dab455a653$var$ContextKey = Symbol["for"]("react-redux-context");
var $130b58dab455a653$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $130b58dab455a653$var$getContext() {
    var _a;
    if (!$130b58dab455a653$var$React.createContext) return {};
    var contextMap = (_a = $130b58dab455a653$var$gT[$130b58dab455a653$var$ContextKey]) != null ? _a : $130b58dab455a653$var$gT[$130b58dab455a653$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($130b58dab455a653$var$React.createContext);
    if (!realContext) {
        realContext = $130b58dab455a653$var$React.createContext(null);
        contextMap.set($130b58dab455a653$var$React.createContext, realContext);
    }
    return realContext;
}
var $130b58dab455a653$export$cc80c08dc91f1c00 = /* @__PURE__ */ $130b58dab455a653$var$getContext();
// src/utils/useSyncExternalStore.ts
var $130b58dab455a653$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $130b58dab455a653$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $130b58dab455a653$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $130b58dab455a653$var$React.useContext(context);
        return contextValue;
    };
}
var $130b58dab455a653$var$useReduxContext = /* @__PURE__ */ $130b58dab455a653$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $130b58dab455a653$var$useSyncExternalStoreWithSelector = $130b58dab455a653$var$notInitialized;
var $130b58dab455a653$var$initializeUseSelector = function(fn) {
    $130b58dab455a653$var$useSyncExternalStoreWithSelector = fn;
};
var $130b58dab455a653$var$refEquality = function(a, b) {
    return a === b;
};
function $130b58dab455a653$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $130b58dab455a653$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $130b58dab455a653$export$cc80c08dc91f1c00 ? $130b58dab455a653$var$useReduxContext : $130b58dab455a653$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $130b58dab455a653$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $130b58dab455a653$var$React.useRef(true);
        var wrappedSelector = $130b58dab455a653$var$React.useCallback((0, $eYH8F._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $130b58dab455a653$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $130b58dab455a653$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $130b58dab455a653$export$2105062e25df4afe = /* @__PURE__ */ $130b58dab455a653$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $130b58dab455a653$var$REACT_ELEMENT_TYPE = Symbol["for"]("react.element");
var $130b58dab455a653$var$REACT_PORTAL_TYPE = Symbol["for"]("react.portal");
var $130b58dab455a653$var$REACT_FRAGMENT_TYPE = Symbol["for"]("react.fragment");
var $130b58dab455a653$var$REACT_STRICT_MODE_TYPE = Symbol["for"]("react.strict_mode");
var $130b58dab455a653$var$REACT_PROFILER_TYPE = Symbol["for"]("react.profiler");
var $130b58dab455a653$var$REACT_PROVIDER_TYPE = Symbol["for"]("react.provider");
var $130b58dab455a653$var$REACT_CONTEXT_TYPE = Symbol["for"]("react.context");
var $130b58dab455a653$var$REACT_SERVER_CONTEXT_TYPE = Symbol["for"]("react.server_context");
var $130b58dab455a653$var$REACT_FORWARD_REF_TYPE = Symbol["for"]("react.forward_ref");
var $130b58dab455a653$var$REACT_SUSPENSE_TYPE = Symbol["for"]("react.suspense");
var $130b58dab455a653$var$REACT_SUSPENSE_LIST_TYPE = Symbol["for"]("react.suspense_list");
var $130b58dab455a653$var$REACT_MEMO_TYPE = Symbol["for"]("react.memo");
var $130b58dab455a653$var$REACT_LAZY_TYPE = Symbol["for"]("react.lazy");
var $130b58dab455a653$var$REACT_OFFSCREEN_TYPE = Symbol["for"]("react.offscreen");
var $130b58dab455a653$var$REACT_CLIENT_REFERENCE = Symbol["for"]("react.client.reference");
var $130b58dab455a653$var$ForwardRef = $130b58dab455a653$var$REACT_FORWARD_REF_TYPE;
var $130b58dab455a653$var$Memo = $130b58dab455a653$var$REACT_MEMO_TYPE;
function $130b58dab455a653$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $130b58dab455a653$var$REACT_FRAGMENT_TYPE || type === $130b58dab455a653$var$REACT_PROFILER_TYPE || type === $130b58dab455a653$var$REACT_STRICT_MODE_TYPE || type === $130b58dab455a653$var$REACT_SUSPENSE_TYPE || type === $130b58dab455a653$var$REACT_SUSPENSE_LIST_TYPE || type === $130b58dab455a653$var$REACT_OFFSCREEN_TYPE) return true;
    if ((typeof type === "undefined" ? "undefined" : (0, $k4vcf._)(type)) === "object" && type !== null) {
        if (type.$$typeof === $130b58dab455a653$var$REACT_LAZY_TYPE || type.$$typeof === $130b58dab455a653$var$REACT_MEMO_TYPE || type.$$typeof === $130b58dab455a653$var$REACT_PROVIDER_TYPE || type.$$typeof === $130b58dab455a653$var$REACT_CONTEXT_TYPE || type.$$typeof === $130b58dab455a653$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $130b58dab455a653$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $130b58dab455a653$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $k4vcf._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $130b58dab455a653$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $130b58dab455a653$var$REACT_FRAGMENT_TYPE:
                        case $130b58dab455a653$var$REACT_PROFILER_TYPE:
                        case $130b58dab455a653$var$REACT_STRICT_MODE_TYPE:
                        case $130b58dab455a653$var$REACT_SUSPENSE_TYPE:
                        case $130b58dab455a653$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $130b58dab455a653$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $130b58dab455a653$var$REACT_CONTEXT_TYPE:
                                    case $130b58dab455a653$var$REACT_FORWARD_REF_TYPE:
                                    case $130b58dab455a653$var$REACT_LAZY_TYPE:
                                    case $130b58dab455a653$var$REACT_MEMO_TYPE:
                                    case $130b58dab455a653$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $130b58dab455a653$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $130b58dab455a653$var$isContextConsumer(object) {
    return $130b58dab455a653$var$typeOf(object) === $130b58dab455a653$var$REACT_CONTEXT_TYPE;
}
function $130b58dab455a653$var$isMemo(object) {
    return $130b58dab455a653$var$typeOf(object) === $130b58dab455a653$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $130b58dab455a653$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $130b58dab455a653$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $130b58dab455a653$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $130b58dab455a653$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $130b58dab455a653$var$verify(mapStateToProps, "mapStateToProps");
    $130b58dab455a653$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $130b58dab455a653$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $130b58dab455a653$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $130b58dab455a653$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $130b58dab455a653$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $130b58dab455a653$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $130b58dab455a653$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $lJaNg._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $130b58dab455a653$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $k4vcf._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $130b58dab455a653$var$verifyPlainObject(value, displayName, methodName) {
    if (!$130b58dab455a653$var$isPlainObject(value)) $130b58dab455a653$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $130b58dab455a653$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $130b58dab455a653$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $130b58dab455a653$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $130b58dab455a653$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $130b58dab455a653$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $130b58dab455a653$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $k4vcf._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $130b58dab455a653$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $k4vcf._)(mapDispatchToProps)) === "object" ? $130b58dab455a653$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $130b58dab455a653$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $130b58dab455a653$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $130b58dab455a653$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $130b58dab455a653$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $130b58dab455a653$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $130b58dab455a653$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $130b58dab455a653$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $130b58dab455a653$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $130b58dab455a653$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $130b58dab455a653$var$__spreadValues($130b58dab455a653$var$__spreadValues($130b58dab455a653$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $130b58dab455a653$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $130b58dab455a653$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $130b58dab455a653$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $130b58dab455a653$var$wrapMergePropsFunc(mergeProps) : $130b58dab455a653$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $130b58dab455a653$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $130b58dab455a653$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $130b58dab455a653$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $130b58dab455a653$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $130b58dab455a653$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $130b58dab455a653$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $130b58dab455a653$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $130b58dab455a653$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $130b58dab455a653$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $130b58dab455a653$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $130b58dab455a653$var$useIsomorphicLayoutEffect = $130b58dab455a653$var$canUseDOM || $130b58dab455a653$var$isReactNative ? $130b58dab455a653$var$React.useLayoutEffect : $130b58dab455a653$var$React.useEffect;
// src/utils/shallowEqual.ts
function $130b58dab455a653$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $130b58dab455a653$export$d36bdfa510afb180(objA, objB) {
    if ($130b58dab455a653$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $k4vcf._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $k4vcf._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$130b58dab455a653$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $130b58dab455a653$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $130b58dab455a653$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $130b58dab455a653$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $130b58dab455a653$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $130b58dab455a653$var$_obj;
var $130b58dab455a653$var$TYPE_STATICS = ($130b58dab455a653$var$_obj = {}, (0, $eYH8F._)($130b58dab455a653$var$_obj, $130b58dab455a653$var$ForwardRef, $130b58dab455a653$var$FORWARD_REF_STATICS), (0, $eYH8F._)($130b58dab455a653$var$_obj, $130b58dab455a653$var$Memo, $130b58dab455a653$var$MEMO_STATICS), $130b58dab455a653$var$_obj);
function $130b58dab455a653$var$getStatics(component) {
    if ($130b58dab455a653$var$isMemo(component)) return $130b58dab455a653$var$MEMO_STATICS;
    return $130b58dab455a653$var$TYPE_STATICS[component["$$typeof"]] || $130b58dab455a653$var$REACT_STATICS;
}
var $130b58dab455a653$var$defineProperty = Object.defineProperty;
var $130b58dab455a653$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $130b58dab455a653$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $130b58dab455a653$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $130b58dab455a653$var$getPrototypeOf = Object.getPrototypeOf;
var $130b58dab455a653$var$objectPrototype = Object.prototype;
function $130b58dab455a653$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($130b58dab455a653$var$objectPrototype) {
            var inheritedComponent = $130b58dab455a653$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $130b58dab455a653$var$objectPrototype) $130b58dab455a653$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $130b58dab455a653$var$getOwnPropertyNames(sourceComponent);
        if ($130b58dab455a653$var$getOwnPropertySymbols) keys = keys.concat($130b58dab455a653$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $130b58dab455a653$var$getStatics(targetComponent);
        var sourceStatics = $130b58dab455a653$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$130b58dab455a653$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $130b58dab455a653$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $130b58dab455a653$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $130b58dab455a653$var$useSyncExternalStore = $130b58dab455a653$var$notInitialized;
var $130b58dab455a653$var$initializeConnect = function(fn) {
    $130b58dab455a653$var$useSyncExternalStore = fn;
};
var $130b58dab455a653$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $130b58dab455a653$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $130b58dab455a653$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $130b58dab455a653$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $lJaNg._)(effectArgs));
    }, dependencies);
}
function $130b58dab455a653$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $130b58dab455a653$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $130b58dab455a653$var$strictEqual(a, b) {
    return a === b;
}
var $130b58dab455a653$var$hasWarnedAboutDeprecatedPureOption = false;
function $130b58dab455a653$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $130b58dab455a653$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $130b58dab455a653$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $130b58dab455a653$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $130b58dab455a653$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $130b58dab455a653$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $130b58dab455a653$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $130b58dab455a653$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $130b58dab455a653$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $axlKX._)($130b58dab455a653$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $130b58dab455a653$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $130b58dab455a653$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $130b58dab455a653$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $130b58dab455a653$var$React.useMemo(function() {
                return $130b58dab455a653$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $axlKX._)($130b58dab455a653$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $130b58dab455a653$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $130b58dab455a653$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $130b58dab455a653$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $130b58dab455a653$var$__spreadProps($130b58dab455a653$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $130b58dab455a653$var$React.useRef(void 0);
            var lastWrapperProps = $130b58dab455a653$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $130b58dab455a653$var$React.useRef(void 0);
            var renderIsScheduled = $130b58dab455a653$var$React.useRef(false);
            var isMounted = $130b58dab455a653$var$React.useRef(false);
            var latestSubscriptionCallbackError = $130b58dab455a653$var$React.useRef(void 0);
            $130b58dab455a653$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $130b58dab455a653$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $130b58dab455a653$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $130b58dab455a653$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $130b58dab455a653$var$useIsomorphicLayoutEffectWithArgs($130b58dab455a653$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $130b58dab455a653$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $130b58dab455a653$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $130b58dab455a653$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $130b58dab455a653$var$React.createElement(WrappedComponent, $130b58dab455a653$var$__spreadProps($130b58dab455a653$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $130b58dab455a653$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $130b58dab455a653$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $130b58dab455a653$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $130b58dab455a653$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $130b58dab455a653$var$React.createElement(Connect, $130b58dab455a653$var$__spreadProps($130b58dab455a653$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $130b58dab455a653$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $130b58dab455a653$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $130b58dab455a653$export$64605811ab45167f = $130b58dab455a653$var$connect;
// src/components/Provider.tsx
function $130b58dab455a653$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $130b58dab455a653$var$React.useMemo(function() {
        var subscription = $130b58dab455a653$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $130b58dab455a653$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $130b58dab455a653$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $130b58dab455a653$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $130b58dab455a653$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $130b58dab455a653$export$2881499e37b75b9a = $130b58dab455a653$var$Provider;
// src/hooks/useStore.ts
function $130b58dab455a653$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $130b58dab455a653$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $130b58dab455a653$export$cc80c08dc91f1c00 ? $130b58dab455a653$var$useReduxContext : // @ts-ignore
    $130b58dab455a653$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $130b58dab455a653$export$6ccbb43953eebf8 = /* @__PURE__ */ $130b58dab455a653$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $130b58dab455a653$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $130b58dab455a653$export$cc80c08dc91f1c00;
    var useStore2 = context === $130b58dab455a653$export$cc80c08dc91f1c00 ? $130b58dab455a653$export$6ccbb43953eebf8 : $130b58dab455a653$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $130b58dab455a653$export$8ad76b76a4c905f8 = /* @__PURE__ */ $130b58dab455a653$export$bc9b55530897c558();
// src/exports.ts
var $130b58dab455a653$export$712ea50be43a7858 = $130b58dab455a653$var$defaultNoopBatch;
// src/index.ts
$130b58dab455a653$var$initializeUseSelector((0, $44d8fffa6ef7bf88$exports.useSyncExternalStoreWithSelector));
$130b58dab455a653$var$initializeConnect($eN0cn.useSyncExternalStore);



var $eN0cn = parcelRequire("eN0cn");
function $6d60e4a1572189b0$var$MoonIcon(props, svgRef) {
    return /*#__PURE__*/ $eN0cn.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $eN0cn.createElement("path", {
        d: "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
    }));
}
var $6d60e4a1572189b0$var$ForwardRef = $eN0cn.forwardRef($6d60e4a1572189b0$var$MoonIcon);
var $6d60e4a1572189b0$export$2e2bcd8739ae039 = $6d60e4a1572189b0$var$ForwardRef;


var $eN0cn = parcelRequire("eN0cn");
function $ea0e3a1dbdb213fc$var$SunIcon(props, svgRef) {
    return /*#__PURE__*/ $eN0cn.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $eN0cn.createElement("path", {
        fillRule: "evenodd",
        d: "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
        clipRule: "evenodd"
    }));
}
var $ea0e3a1dbdb213fc$var$ForwardRef = $eN0cn.forwardRef($ea0e3a1dbdb213fc$var$SunIcon);
var $ea0e3a1dbdb213fc$export$2e2bcd8739ae039 = $ea0e3a1dbdb213fc$var$ForwardRef;


var $b1fe9ed88c0c1ba9$exports = {};

$b1fe9ed88c0c1ba9$exports = (parcelRequire("4vTas")).getBundleURL('hpNCx') + "pngaaa.82eca32a.png";


var $37b06739dce8f517$var$Header = function() {
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)("login"), 2), btnName = _useState[0], setBtnName = _useState[1];
    var _useState1 = (0, $axlKX._)((0, $eN0cn.useState)(false), 2), isDarkMode = _useState1[0], setIsDarkMode = _useState1[1];
    var onlineStatus = (0, $407b08b21203010a$export$2e2bcd8739ae039)();
    var loggedInUser = (0, $eN0cn.useContext)((0, $ce4e95b53dbe8cd7$export$2e2bcd8739ae039)).loggedInUser;
    var cartItems = (0, $130b58dab455a653$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var toggleDarkMode = function() {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle("dark");
    };
    return /*#__PURE__*/ (0, $22qX1.jsxs)("header", {
        className: "flex flex-wrap justify-between  mx-10 items-center px-8 py-3 border border-gray-200 rounded-b-xl shadow-md bg-orange-300 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsxs)((0, $df9553b03ed5684d$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b1fe9ed88c0c1ba9$exports))),
                        alt: "Swiggy Logo",
                        className: "w-20 hover:scale-105 transition-transform duration-300"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("span", {
                        className: "text-lg font-bold tracking-wide hidden sm:block",
                        children: "Good FOOD"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("nav", {
                className: "flex items-center gap-6",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsxs)("span", {
                        className: "text-sm font-semibold",
                        children: [
                            "Online: ",
                            onlineStatus ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                        ]
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)($37b06739dce8f517$var$NavLink, {
                        to: "/",
                        label: "Home"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)($37b06739dce8f517$var$NavLink, {
                        to: "/about",
                        label: "About"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)($37b06739dce8f517$var$NavLink, {
                        to: "/contact",
                        label: "Contact"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)($37b06739dce8f517$var$NavLink, {
                        to: "/grocery",
                        label: "Grocery"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)($37b06739dce8f517$var$NavLink, {
                        to: "/cart",
                        label: "Cart (".concat(cartItems.length, ")")
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("span", {
                        className: "hidden md:inline text-lg italic font-medium text-gray-700 dark:text-gray-300",
                        children: loggedInUser ? "\uD83D\uDC64 ".concat(loggedInUser) : "Guest"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                        onClick: function() {
                            return setBtnName(btnName === "login" ? "logout" : "login");
                        },
                        className: "px-4 py-1.5 rounded-lg text-white font-semibold shadow-sm transition-all duration-300 ".concat(btnName === "login" ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"),
                        children: btnName
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                        onClick: toggleDarkMode,
                        className: "ml-3 w-9 h-9 flex items-center justify-center rounded-full bg-gray-700 hover:bg-gray-600 dark:bg-gray-500 dark:hover:bg-gray-400 transition-colors duration-200",
                        children: isDarkMode ? /*#__PURE__*/ (0, $22qX1.jsx)((0, $ea0e3a1dbdb213fc$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 text-yellow-300"
                        }) : /*#__PURE__*/ (0, $22qX1.jsx)((0, $6d60e4a1572189b0$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 text-white"
                        })
                    })
                ]
            })
        ]
    });
};
var $37b06739dce8f517$var$NavLink = function(param) {
    var to = param.to, label = param.label;
    return /*#__PURE__*/ (0, $22qX1.jsx)((0, $df9553b03ed5684d$export$a6c7ac8248d6e38a), {
        to: to,
        className: "text-base font-medium hover:text-orange-600 dark:hover:text-orange-300 transition-colors duration-150",
        children: label
    });
};
var $37b06739dce8f517$export$2e2bcd8739ae039 = $37b06739dce8f517$var$Header;



var $bq3K4 = parcelRequire("bq3K4");

var $axlKX = parcelRequire("axlKX");

var $m9tdn = parcelRequire("m9tdn");

var $22qX1 = parcelRequire("22qX1");

var $22qX1 = parcelRequire("22qX1");

var $208cf2ce65103845$var$RestaurantCard = function(props) {
    var resData = props.resData;
    var _ref = resData === null || resData === void 0 ? void 0 : resData.info, cloudinaryImageId = _ref.cloudinaryImageId, name = _ref.name, avgRating = _ref.avgRating, cuisines = _ref.cuisines;
    return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
        className: "res-card m-4  w-[234px] h-[320px]   rounded-lg  object-cover transform hover:scale-95 hover:z-10 transition-all",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsx)("img", {
                className: "res-logo   rounded-xl w-full h-[181.99px] object-cover ",
                alt: "food-img",
                src: (0, $7fb67fe6c69adf0e$export$31adfacaf07ffe63) + cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $22qX1.jsx)("h3", {
                className: "res-detail pt-4   font-bold cursor-pointer  font-basis-grotesque  text-[rgb(40, 44, 63)] text-md",
                children: name
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("h4", {
                className: "res-details text-[rgb(40, 44, 63)] font-basis-grotesque  text-md",
                children: [
                    "\u2B50 ",
                    avgRating,
                    " ",
                    /*#__PURE__*/ (0, $22qX1.jsx)("span", {
                        className: "ml-2",
                        children: "\u2022  25:30 mins"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $22qX1.jsx)("h4", {
                className: "res-details   font-lato  pt-0 text-md",
                children: cuisines.join(", ")
            })
        ]
    });
};
var $208cf2ce65103845$export$2e2bcd8739ae039 = $208cf2ce65103845$var$RestaurantCard;



var $eN0cn = parcelRequire("eN0cn");

var $lJaNg = parcelRequire("lJaNg");

var $22qX1 = parcelRequire("22qX1");
parcelRequire("eN0cn");
var $4199897659dc45e5$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $22qX1.jsx)("div", {
        className: "flex flex-wrap gap-6 justify-center",
        children: (0, $lJaNg._)(Array(10)).map(function(_, index) {
            return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "w-[200px] h-[250px] bg-gray-200 rounded-lg p-4 shadow-md animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsx)("div", {
                        className: "w-full h-3/5 bg-gray-300 rounded-lg mb-4"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("div", {
                        className: "w-4/5 h-4 bg-gray-300 rounded-lg mb-2"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("div", {
                        className: "w-3/5 h-4 bg-gray-300 rounded-lg"
                    })
                ]
            }, index);
        })
    });
};
var $4199897659dc45e5$export$2e2bcd8739ae039 = $4199897659dc45e5$var$Shimmer;






var $718b5b3989e34d90$var$Body = function() {
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)([]), 2), restaurants = _useState[0], setRestaurants = _useState[1];
    var _useState1 = (0, $axlKX._)((0, $eN0cn.useState)([]), 2), filteredRestaurants = _useState1[0], setFilteredRestaurants = _useState1[1];
    var _useState2 = (0, $axlKX._)((0, $eN0cn.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var onlineStatus = (0, $407b08b21203010a$export$2e2bcd8739ae039)();
    var loggedInUser = (0, $eN0cn.useContext)((0, $ce4e95b53dbe8cd7$export$2e2bcd8739ae039)).loggedInUser;
    (0, $eN0cn.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $bq3K4._)(function() {
            var _json_data, response, json, cards, restaurantsList, i, _cards_i_card_card_gridElements_infoWithStyle, _cards_i_card_card_gridElements, _cards_i_card_card, _cards_i_card, _cards_i, maybeRestaurants, error;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch((0, $7fb67fe6c69adf0e$export$85dc8a20c452aa8a))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        json = _state.sent();
                        // Extract cards array
                        cards = (json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.cards) || [];
                        // Try to find the first card that contains restaurants
                        restaurantsList = [];
                        for(i = 0; i < cards.length; i++){
                            ;
                            maybeRestaurants = (_cards_i = cards[i]) === null || _cards_i === void 0 ? void 0 : (_cards_i_card = _cards_i.card) === null || _cards_i_card === void 0 ? void 0 : (_cards_i_card_card = _cards_i_card.card) === null || _cards_i_card_card === void 0 ? void 0 : (_cards_i_card_card_gridElements = _cards_i_card_card.gridElements) === null || _cards_i_card_card_gridElements === void 0 ? void 0 : (_cards_i_card_card_gridElements_infoWithStyle = _cards_i_card_card_gridElements.infoWithStyle) === null || _cards_i_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _cards_i_card_card_gridElements_infoWithStyle.restaurants;
                            if (maybeRestaurants && maybeRestaurants.length > 0) {
                                restaurantsList = maybeRestaurants;
                                break;
                            }
                        }
                        setRestaurants(restaurantsList);
                        setFilteredRestaurants(restaurantsList);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching data:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearch = function() {
        var filteredList = restaurants.filter(function(res) {
            var _res_info_name, _res_info;
            return (_res_info = res.info) === null || _res_info === void 0 ? void 0 : (_res_info_name = _res_info.name) === null || _res_info_name === void 0 ? void 0 : _res_info_name.toLowerCase().includes(searchText.toLowerCase());
        });
        setFilteredRestaurants(filteredList);
    };
    var handleTopRatedFilter = function() {
        var filteredList = restaurants.filter(function(res) {
            var _res_info;
            return ((_res_info = res.info) === null || _res_info === void 0 ? void 0 : _res_info.avgRating) > 4.5;
        });
        setFilteredRestaurants(filteredList);
    };
    if (onlineStatus === false) return /*#__PURE__*/ (0, $22qX1.jsx)("div", {
        className: "text-center mt-20 text-2xl font-bold dark:text-white",
        children: "Looks like you're offline! \uD83D\uDED1"
    });
    if (restaurants.length === 0) return /*#__PURE__*/ (0, $22qX1.jsx)("div", {
        className: "body dark:bg-gray-800 dark:text-white",
        children: /*#__PURE__*/ (0, $22qX1.jsx)((0, $4199897659dc45e5$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $22qX1.jsxs)("main", {
        className: "body dark:bg-gray-800 dark:text-white min-h-screen",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsx)("h2", {
                className: "text-center text-3xl font-extrabold mb-8 mt-4",
                children: "Restaurants in Manipal \uD83C\uDFD9\uFE0F"
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "flex flex-col md:flex-row justify-between items-center px-8 mb-10",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $22qX1.jsx)("label", {
                                htmlFor: "search",
                                className: "sr-only",
                                children: "Search Restaurants"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("input", {
                                id: "search",
                                type: "text",
                                placeholder: "Search by name...",
                                value: searchText,
                                onChange: function(e) {
                                    return setSearchText(e.target.value);
                                },
                                className: "border border-gray-400 rounded px-3 py-2 dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                                onClick: handleSearch,
                                className: "bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-all",
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                        onClick: handleTopRatedFilter,
                        className: "mt-4 md:mt-0 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-all",
                        children: "Top Rated Restaurants"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $22qX1.jsx)("section", {
                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 px-8",
                children: filteredRestaurants.map(function(restaurant) {
                    return /*#__PURE__*/ (0, $22qX1.jsx)((0, $df9553b03ed5684d$export$a6c7ac8248d6e38a), {
                        to: "/restaurants/".concat(restaurant.info.id),
                        children: /*#__PURE__*/ (0, $22qX1.jsx)((0, $208cf2ce65103845$export$2e2bcd8739ae039), {
                            resData: restaurant
                        })
                    }, restaurant.info.id);
                })
            })
        ]
    });
};
var $718b5b3989e34d90$export$2e2bcd8739ae039 = $718b5b3989e34d90$var$Body;



var $22qX1 = parcelRequire("22qX1");

var $eN0cn = parcelRequire("eN0cn");

var $b38f5e7923f6bc90$var$About = function() {
    var loggedInUser = (0, $eN0cn.useContext)((0, $ce4e95b53dbe8cd7$export$2e2bcd8739ae039)).loggedInUser;
    return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
        className: "max-w-4xl mx-auto mt-10 p-8 bg-orange-50 bg-[url('https://www.toptal.com/designers/subtlepatterns/uploads/symphony.png')] bg-repeat dark:bg-gray-800 dark:text-white rounded-lg shadow-lg",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsx)("h1", {
                className: "text-3xl font-extrabold mb-6 text-center text-orange-600 dark:text-orange-400",
                children: "About Swiggy Fire \uD83D\uDE80"
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("p", {
                className: "text-center text-gray-700 dark:text-gray-300 mb-10 text-lg",
                children: [
                    "Welcome to ",
                    /*#__PURE__*/ (0, $22qX1.jsx)("span", {
                        className: "font-bold text-orange-500",
                        children: "Swiggy Fire"
                    }),
                    " \u2014 a demo food-ordering platform built to learn modern web development using React, Redux, Tailwind CSS, and Cloudflare Workers."
                ]
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "bg-white dark:bg-gray-700 rounded-lg p-6 shadow-inner",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsx)("h2", {
                        className: "text-xl font-semibold mb-4 text-gray-800 dark:text-gray-100",
                        children: "About This Project"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("p", {
                        className: "text-gray-700 dark:text-gray-300 text-base leading-relaxed mb-4",
                        children: "This application is crafted for educational purposes. It simulates a food delivery platform similar to Swiggy, featuring:"
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsxs)("ul", {
                        className: "list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $22qX1.jsx)("li", {
                                children: "Dynamic restaurant listings fetched via Cloudflare Worker proxy"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("li", {
                                children: "Detailed restaurant menus"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("li", {
                                children: "Shopping cart functionality with Redux"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("li", {
                                children: "Responsive design with Tailwind CSS"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("li", {
                                children: "Dark mode support"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsxs)("p", {
                        className: "text-gray-700 dark:text-gray-300",
                        children: [
                            "Logged in as: ",
                            /*#__PURE__*/ (0, $22qX1.jsx)("span", {
                                className: "font-bold text-orange-600 dark:text-orange-400",
                                children: loggedInUser
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b38f5e7923f6bc90$export$2e2bcd8739ae039 = $b38f5e7923f6bc90$var$About;



var $axlKX = parcelRequire("axlKX");

var $22qX1 = parcelRequire("22qX1");

var $eN0cn = parcelRequire("eN0cn");
var $59390c90ae638e0b$var$Contact = function() {
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(''), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = (0, $axlKX._)((0, $eN0cn.useState)(''), 2), email = _useState1[0], setEmail = _useState1[1];
    var _useState2 = (0, $axlKX._)((0, $eN0cn.useState)(''), 2), message = _useState2[0], setMessage = _useState2[1];
    var handleSubmit = function(e) {
        e.preventDefault();
        console.log('Form submitted:', {
            name: name,
            email: email,
            message: message
        });
    };
    return /*#__PURE__*/ (0, $22qX1.jsx)("div", {
        className: "py-16 px-8 md:px-16 dark:bg-gray-800",
        children: /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
            className: "max-w-4xl mx-auto text-center",
            children: [
                /*#__PURE__*/ (0, $22qX1.jsx)("h1", {
                    className: "text-4xl font-extrabold text-indigo-600 mb-4 dark:text-indigo-400",
                    children: "We're Here to Help You 24/7"
                }),
                /*#__PURE__*/ (0, $22qX1.jsx)("p", {
                    className: "text-xl text-gray-700 mb-8 dark:text-gray-300",
                    children: "Whether you have questions, need support, or just want to say hello, we're available anytime!"
                }),
                /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                    className: "bg-white p-8 rounded-lg shadow-xl border border-gray-200 dark:bg-gray-900 dark:border-gray-700",
                    children: [
                        /*#__PURE__*/ (0, $22qX1.jsx)("h2", {
                            className: "text-2xl font-semibold text-gray-800 mb-4 dark:text-gray-100",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $22qX1.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $22qX1.jsx)("label", {
                                            className: "block text-lg text-gray-800 mb-2 dark:text-gray-200",
                                            htmlFor: "name",
                                            children: "Your Name"
                                        }),
                                        /*#__PURE__*/ (0, $22qX1.jsx)("input", {
                                            type: "text",
                                            id: "name",
                                            className: "w-full p-3 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                            placeholder: "Enter your name",
                                            value: name,
                                            onChange: function(e) {
                                                return setName(e.target.value);
                                            },
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $22qX1.jsx)("label", {
                                            className: "block text-lg text-gray-800 mb-2 dark:text-gray-200",
                                            htmlFor: "email",
                                            children: "Your Email"
                                        }),
                                        /*#__PURE__*/ (0, $22qX1.jsx)("input", {
                                            type: "email",
                                            id: "email",
                                            className: "w-full p-3 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                            placeholder: "Enter your email",
                                            value: email,
                                            onChange: function(e) {
                                                return setEmail(e.target.value);
                                            },
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $22qX1.jsx)("label", {
                                            className: "block text-lg text-gray-800 mb-2 dark:text-gray-200",
                                            htmlFor: "message",
                                            children: "Your Message"
                                        }),
                                        /*#__PURE__*/ (0, $22qX1.jsx)("textarea", {
                                            id: "message",
                                            className: "w-full p-3 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                                            rows: "4",
                                            placeholder: "Write your message here",
                                            value: message,
                                            onChange: function(e) {
                                                return setMessage(e.target.value);
                                            },
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                                    type: "submit",
                                    className: "w-full py-3 bg-indigo-600 text-white text-lg font-semibold rounded-md hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $59390c90ae638e0b$export$2e2bcd8739ae039 = $59390c90ae638e0b$var$Contact;



var $22qX1 = parcelRequire("22qX1");

var $ba9003b0ab5e1c94$var$Error = function() {
    var err = (0, $f0e056f577c778ce$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $22qX1.jsx)("h1", {
                children: " Ooopsseeeee! Tinke\uD83D\uDD7A Tinke\uD83D\uDD7A Tinke\uD83D\uDD7A Tinke\uD83D\uDD7A"
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("h1", {
                children: [
                    err.status,
                    " ",
                    err.statusText
                ]
            })
        ]
    });
};
var $ba9003b0ab5e1c94$export$2e2bcd8739ae039 = $ba9003b0ab5e1c94$var$Error;



var $axlKX = parcelRequire("axlKX");

var $22qX1 = parcelRequire("22qX1");


// import {useEffect,useState} from "react";
// import { MENU_API } from "../utils/constant.js";
// const useRestaurantMenu=(resId)=>{
//     const [resInfo, setResInfo] = useState(null);
//     useEffect(() => {
//         fetchMenu();
//       }, []);
//       const fetchMenu = async () => {
//         try {
//           const data = await fetch(
//             MENU_API(resId)
//           );
//           const json = await data.json();
//           console.log(json);
//           setResInfo(json.data);
//         } catch (error) {
//           console.error("Error fetching menu:", error);
//         }
//       };
//     return  resInfo;
// }
// export default useRestaurantMenu;

var $bq3K4 = parcelRequire("bq3K4");

var $axlKX = parcelRequire("axlKX");

var $m9tdn = parcelRequire("m9tdn");

var $eN0cn = parcelRequire("eN0cn");

var $90e57ff561124c41$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $eN0cn.useEffect)(function() {
        if (!resId) return; // avoid fetching if no restaurant ID
        fetchMenu();
    }, [
        resId
    ]); // run whenever resId changes
    var fetchMenu = /*#__PURE__*/ function() {
        var _ref = (0, $bq3K4._)(function() {
            var response, json, parseError, error;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            fetch((0, $7fb67fe6c69adf0e$export$b77c1aa4fb57bd1c)(resId))
                        ];
                    case 1:
                        response = _state.sent();
                        // Attempt to parse JSON safely
                        json = null;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        json = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        parseError = _state.sent();
                        console.warn("Menu API did not return valid JSON:", parseError);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        if (!json || !json.data) {
                            console.error("No menu data available");
                            setResInfo(null);
                            return [
                                2
                            ];
                        }
                        setResInfo(json.data); // set menu data
                        console.log("Fetched menu:", json.data);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error("Error fetching menu:", error);
                        setResInfo(null);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $90e57ff561124c41$export$2e2bcd8739ae039 = $90e57ff561124c41$var$useRestaurantMenu;



var $22qX1 = parcelRequire("22qX1");
parcelRequire("eN0cn");

var $axlKX = parcelRequire("axlKX");

var $22qX1 = parcelRequire("22qX1");

var $eN0cn = parcelRequire("eN0cn");



var $bq3K4 = parcelRequire("bq3K4");

var $dOTqn = parcelRequire("dOTqn");

var $gNNCA = parcelRequire("gNNCA");

var $hw4ub = parcelRequire("hw4ub");

var $9fiLN = parcelRequire("9fiLN");

var $eYH8F = parcelRequire("eYH8F");

var $hK71c = parcelRequire("hK71c");
function $08992f78e4b7d0b4$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $hK71c._)(object);
        if (object === null) break;
    }
    return object;
}


function $04b646a8ef722c68$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $04b646a8ef722c68$export$71511d61b312f219 = Reflect.get;
    else $04b646a8ef722c68$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $08992f78e4b7d0b4$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $04b646a8ef722c68$export$71511d61b312f219(target, property, receiver || target);
}



var $hK71c = parcelRequire("hK71c");

var $1594H = parcelRequire("1594H");

var $axlKX = parcelRequire("axlKX");

var $lJaNg = parcelRequire("lJaNg");

var $k4vcf = parcelRequire("k4vcf");

var $29eLC = parcelRequire("29eLC");

var $m9tdn = parcelRequire("m9tdn");
// src/utils/formatProdErrorMessage.ts

var $eYH8F = parcelRequire("eYH8F");

var $eYH8F = parcelRequire("eYH8F");
function $325c54a74d0595d2$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $eYH8F._)(target, key, source[key]);
        });
    }
    return target;
}


function $54452b47414234c9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54452b47414234c9$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $54452b47414234c9$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $lJaNg = parcelRequire("lJaNg");

var $k4vcf = parcelRequire("k4vcf");
function $e81e114265ee4dc3$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $e81e114265ee4dc3$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $e81e114265ee4dc3$var$symbol_observable_default = $e81e114265ee4dc3$var$$$observable;
// src/utils/actionTypes.ts
var $e81e114265ee4dc3$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $e81e114265ee4dc3$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($e81e114265ee4dc3$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($e81e114265ee4dc3$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($e81e114265ee4dc3$var$randomString());
    }
};
var $e81e114265ee4dc3$export$4219e499db7ca678 = $e81e114265ee4dc3$var$ActionTypes;
// src/utils/isPlainObject.ts
function $e81e114265ee4dc3$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $k4vcf._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $e81e114265ee4dc3$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $k4vcf._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($e81e114265ee4dc3$var$isDate(val)) return "date";
    if ($e81e114265ee4dc3$var$isError(val)) return "error";
    var constructorName = $e81e114265ee4dc3$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $e81e114265ee4dc3$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $e81e114265ee4dc3$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $e81e114265ee4dc3$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $e81e114265ee4dc3$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $k4vcf._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $e81e114265ee4dc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(1));
        return enhancer($e81e114265ee4dc3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners["delete"](listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$e81e114265ee4dc3$export$53b83ca8eaab0383(action)) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $e81e114265ee4dc3$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $eYH8F._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $k4vcf._)(observer)) !== "object" || observer === null) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $e81e114265ee4dc3$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $e81e114265ee4dc3$export$4219e499db7ca678.INIT
    });
    var store = (0, $eYH8F._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $e81e114265ee4dc3$var$symbol_observable_default, observable);
    return store;
}
function $e81e114265ee4dc3$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $e81e114265ee4dc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $e81e114265ee4dc3$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $e81e114265ee4dc3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $e81e114265ee4dc3$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$e81e114265ee4dc3$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($e81e114265ee4dc3$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $e81e114265ee4dc3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $e81e114265ee4dc3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $e81e114265ee4dc3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $e81e114265ee4dc3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(13));
    });
}
function $e81e114265ee4dc3$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $e81e114265ee4dc3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $e81e114265ee4dc3$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $e81e114265ee4dc3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $e81e114265ee4dc3$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $k4vcf._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $e81e114265ee4dc3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $e81e114265ee4dc3$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $lJaNg._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $e81e114265ee4dc3$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($e81e114265ee4dc3$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $lJaNg._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $e81e114265ee4dc3$export$f672e0b6f7222cd7.apply(void 0, (0, $lJaNg._)(chain))(store.dispatch);
            return (0, $54452b47414234c9$export$71511d61b312f219)((0, $325c54a74d0595d2$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $e81e114265ee4dc3$export$b956e38827fca970(action) {
    return $e81e114265ee4dc3$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $iLa78 = parcelRequire("iLa78");

var $gNNCA = parcelRequire("gNNCA");

var $9fiLN = parcelRequire("9fiLN");

var $axlKX = parcelRequire("axlKX");

var $lJaNg = parcelRequire("lJaNg");

var $k4vcf = parcelRequire("k4vcf");
var $84c39508ad4d9a30$var$__defProp = Object.defineProperty;
var $84c39508ad4d9a30$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $84c39508ad4d9a30$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $84c39508ad4d9a30$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $84c39508ad4d9a30$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $84c39508ad4d9a30$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $84c39508ad4d9a30$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($84c39508ad4d9a30$var$__hasOwnProp.call(b, prop)) $84c39508ad4d9a30$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($84c39508ad4d9a30$var$__getOwnPropSymbols) try {
        for(var _iterator = $84c39508ad4d9a30$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($84c39508ad4d9a30$var$__propIsEnum.call(b, prop)) $84c39508ad4d9a30$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $84c39508ad4d9a30$var$__publicField = function(obj, key, value) {
    $84c39508ad4d9a30$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $k4vcf._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $84c39508ad4d9a30$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $84c39508ad4d9a30$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $lJaNg._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $84c39508ad4d9a30$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $84c39508ad4d9a30$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($84c39508ad4d9a30$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $84c39508ad4d9a30$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $84c39508ad4d9a30$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $k4vcf._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $84c39508ad4d9a30$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $k4vcf._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $k4vcf._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $84c39508ad4d9a30$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $k4vcf._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $84c39508ad4d9a30$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $84c39508ad4d9a30$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $84c39508ad4d9a30$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $84c39508ad4d9a30$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $84c39508ad4d9a30$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $84c39508ad4d9a30$var$__spreadValues($84c39508ad4d9a30$var$__spreadValues({}, $84c39508ad4d9a30$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $84c39508ad4d9a30$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $84c39508ad4d9a30$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $84c39508ad4d9a30$var$$REVISION = 0;
var $84c39508ad4d9a30$var$CURRENT_TRACKER = null;
var $84c39508ad4d9a30$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $84c39508ad4d9a30$var$tripleEq;
        (0, $gNNCA._)(this, Cell);
        $84c39508ad4d9a30$var$__publicField(this, "revision", $84c39508ad4d9a30$var$$REVISION);
        $84c39508ad4d9a30$var$__publicField(this, "_value");
        $84c39508ad4d9a30$var$__publicField(this, "_lastValue");
        $84c39508ad4d9a30$var$__publicField(this, "_isEqual", $84c39508ad4d9a30$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $9fiLN._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $84c39508ad4d9a30$var$CURRENT_TRACKER == null || $84c39508ad4d9a30$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$84c39508ad4d9a30$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $84c39508ad4d9a30$var$tripleEq(a, b) {
    return a === b;
}
var $84c39508ad4d9a30$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $gNNCA._)(this, TrackingCache);
        $84c39508ad4d9a30$var$__publicField(this, "_cachedValue");
        $84c39508ad4d9a30$var$__publicField(this, "_cachedRevision", -1);
        $84c39508ad4d9a30$var$__publicField(this, "_deps", []);
        $84c39508ad4d9a30$var$__publicField(this, "hits", 0);
        $84c39508ad4d9a30$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $9fiLN._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $84c39508ad4d9a30$var$CURRENT_TRACKER;
                    $84c39508ad4d9a30$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $84c39508ad4d9a30$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $84c39508ad4d9a30$var$CURRENT_TRACKER == null || $84c39508ad4d9a30$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $lJaNg._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $84c39508ad4d9a30$var$getValue(cell) {
    if (!(cell instanceof $84c39508ad4d9a30$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $84c39508ad4d9a30$var$setValue(storage, value) {
    if (!(storage instanceof $84c39508ad4d9a30$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $84c39508ad4d9a30$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $84c39508ad4d9a30$var$tripleEq;
    return new $84c39508ad4d9a30$var$Cell(initialValue, isEqual);
}
function $84c39508ad4d9a30$var$createCache(fn) {
    $84c39508ad4d9a30$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $84c39508ad4d9a30$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $84c39508ad4d9a30$var$neverEq = function(a, b) {
    return false;
};
function $84c39508ad4d9a30$var$createTag() {
    return $84c39508ad4d9a30$var$createCell(null, $84c39508ad4d9a30$var$neverEq);
}
function $84c39508ad4d9a30$var$dirtyTag(tag, value) {
    $84c39508ad4d9a30$var$setValue(tag, value);
}
var $84c39508ad4d9a30$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $84c39508ad4d9a30$var$createTag();
    $84c39508ad4d9a30$var$getValue(tag);
};
var $84c39508ad4d9a30$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $84c39508ad4d9a30$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $84c39508ad4d9a30$var$REDUX_PROXY_LABEL = Symbol();
var $84c39508ad4d9a30$var$nextId = 0;
var $84c39508ad4d9a30$var$proto = Object.getPrototypeOf({});
var $84c39508ad4d9a30$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $gNNCA._)(this, ObjectTreeNode);
    this.value = value;
    $84c39508ad4d9a30$var$__publicField(this, "proxy", new Proxy(this, $84c39508ad4d9a30$var$objectProxyHandler));
    $84c39508ad4d9a30$var$__publicField(this, "tag", $84c39508ad4d9a30$var$createTag());
    $84c39508ad4d9a30$var$__publicField(this, "tags", {});
    $84c39508ad4d9a30$var$__publicField(this, "children", {});
    $84c39508ad4d9a30$var$__publicField(this, "collectionTag", null);
    $84c39508ad4d9a30$var$__publicField(this, "id", $84c39508ad4d9a30$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $84c39508ad4d9a30$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $k4vcf._)(key)) === "symbol") return childValue;
            if (key in $84c39508ad4d9a30$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $k4vcf._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $84c39508ad4d9a30$var$createNode(childValue);
                if (childNode.tag) $84c39508ad4d9a30$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $84c39508ad4d9a30$var$createTag();
                    tag.value = childValue;
                }
                $84c39508ad4d9a30$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $84c39508ad4d9a30$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $84c39508ad4d9a30$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $gNNCA._)(this, ArrayTreeNode);
    this.value = value;
    $84c39508ad4d9a30$var$__publicField(this, "proxy", new Proxy([
        this
    ], $84c39508ad4d9a30$var$arrayProxyHandler));
    $84c39508ad4d9a30$var$__publicField(this, "tag", $84c39508ad4d9a30$var$createTag());
    $84c39508ad4d9a30$var$__publicField(this, "tags", {});
    $84c39508ad4d9a30$var$__publicField(this, "children", {});
    $84c39508ad4d9a30$var$__publicField(this, "collectionTag", null);
    $84c39508ad4d9a30$var$__publicField(this, "id", $84c39508ad4d9a30$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $84c39508ad4d9a30$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $axlKX._)(param, 1), node = _param[0];
        if (key === "length") $84c39508ad4d9a30$var$consumeCollection(node);
        return $84c39508ad4d9a30$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $axlKX._)(param, 1), node = _param[0];
        return $84c39508ad4d9a30$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $axlKX._)(param, 1), node = _param[0];
        return $84c39508ad4d9a30$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $axlKX._)(param, 1), node = _param[0];
        return $84c39508ad4d9a30$var$objectProxyHandler.has(node, prop);
    }
};
function $84c39508ad4d9a30$var$createNode(value) {
    if (Array.isArray(value)) return new $84c39508ad4d9a30$var$ArrayTreeNode(value);
    return new $84c39508ad4d9a30$var$ObjectTreeNode(value);
}
function $84c39508ad4d9a30$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $84c39508ad4d9a30$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $84c39508ad4d9a30$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $84c39508ad4d9a30$var$dirtyCollection(node);
            $84c39508ad4d9a30$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $k4vcf._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $k4vcf._)(newChildValue1)) === "object" && newChildValue1 !== null) $84c39508ad4d9a30$var$updateNode(childNode, newChildValue1);
        else {
            $84c39508ad4d9a30$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $84c39508ad4d9a30$var$deleteNode(node) {
    if (node.tag) $84c39508ad4d9a30$var$dirtyTag(node.tag, null);
    $84c39508ad4d9a30$var$dirtyCollection(node);
    for(var key in node.tags)$84c39508ad4d9a30$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$84c39508ad4d9a30$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $84c39508ad4d9a30$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $84c39508ad4d9a30$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $84c39508ad4d9a30$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $84c39508ad4d9a30$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $84c39508ad4d9a30$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $84c39508ad4d9a30$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $84c39508ad4d9a30$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $84c39508ad4d9a30$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $k4vcf._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $84c39508ad4d9a30$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $84c39508ad4d9a30$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $84c39508ad4d9a30$var$createSingletonCache(comparator) : $84c39508ad4d9a30$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $84c39508ad4d9a30$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $84c39508ad4d9a30$export$c8f9cf88d9fdee55(func) {
    var node = $84c39508ad4d9a30$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $84c39508ad4d9a30$var$createCacheKeyComparator($84c39508ad4d9a30$export$3f025202a230c6dd);
    var cache = $84c39508ad4d9a30$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $84c39508ad4d9a30$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $84c39508ad4d9a30$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $gNNCA._)(this, StrongRef);
        this.value = value;
    }
    (0, $9fiLN._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $84c39508ad4d9a30$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $84c39508ad4d9a30$var$StrongRef;
var $84c39508ad4d9a30$var$UNTERMINATED = 0;
var $84c39508ad4d9a30$var$TERMINATED = 1;
function $84c39508ad4d9a30$var$createCacheNode() {
    return {
        s: $84c39508ad4d9a30$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $84c39508ad4d9a30$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $84c39508ad4d9a30$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $k4vcf._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $84c39508ad4d9a30$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $84c39508ad4d9a30$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $84c39508ad4d9a30$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $k4vcf._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $84c39508ad4d9a30$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $84c39508ad4d9a30$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $84c39508ad4d9a30$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $84c39508ad4d9a30$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $k4vcf._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $84c39508ad4d9a30$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $k4vcf._)(resultFunc), "]"));
        var combinedOptions = $84c39508ad4d9a30$var$__spreadValues($84c39508ad4d9a30$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $84c39508ad4d9a30$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $84c39508ad4d9a30$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $84c39508ad4d9a30$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $84c39508ad4d9a30$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $lJaNg._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $84c39508ad4d9a30$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $lJaNg._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $84c39508ad4d9a30$export$595d22ed68ca2841 = /* @__PURE__ */ $84c39508ad4d9a30$export$5943f4447f6ef248($84c39508ad4d9a30$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $84c39508ad4d9a30$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $84c39508ad4d9a30$export$595d22ed68ca2841;
    $84c39508ad4d9a30$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $k4vcf._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $84c39508ad4d9a30$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $6389e9b398f8baa2$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $6389e9b398f8baa2$export$dd164f5517779f15 = $6389e9b398f8baa2$var$createThunkMiddleware();
var $6389e9b398f8baa2$export$16d06542a1949d9e = $6389e9b398f8baa2$var$createThunkMiddleware;


var $4ae7404d3481fd55$exports = {};
// shim for using process in browser
var $4ae7404d3481fd55$var$process = $4ae7404d3481fd55$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4ae7404d3481fd55$var$cachedSetTimeout;
var $4ae7404d3481fd55$var$cachedClearTimeout;
function $4ae7404d3481fd55$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $4ae7404d3481fd55$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $4ae7404d3481fd55$var$cachedSetTimeout = setTimeout;
        else $4ae7404d3481fd55$var$cachedSetTimeout = $4ae7404d3481fd55$var$defaultSetTimout;
    } catch (e) {
        $4ae7404d3481fd55$var$cachedSetTimeout = $4ae7404d3481fd55$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $4ae7404d3481fd55$var$cachedClearTimeout = clearTimeout;
        else $4ae7404d3481fd55$var$cachedClearTimeout = $4ae7404d3481fd55$var$defaultClearTimeout;
    } catch (e) {
        $4ae7404d3481fd55$var$cachedClearTimeout = $4ae7404d3481fd55$var$defaultClearTimeout;
    }
})();
function $4ae7404d3481fd55$var$runTimeout(fun) {
    if ($4ae7404d3481fd55$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4ae7404d3481fd55$var$cachedSetTimeout === $4ae7404d3481fd55$var$defaultSetTimout || !$4ae7404d3481fd55$var$cachedSetTimeout) && setTimeout) {
        $4ae7404d3481fd55$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4ae7404d3481fd55$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4ae7404d3481fd55$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4ae7404d3481fd55$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4ae7404d3481fd55$var$runClearTimeout(marker) {
    if ($4ae7404d3481fd55$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4ae7404d3481fd55$var$cachedClearTimeout === $4ae7404d3481fd55$var$defaultClearTimeout || !$4ae7404d3481fd55$var$cachedClearTimeout) && clearTimeout) {
        $4ae7404d3481fd55$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4ae7404d3481fd55$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4ae7404d3481fd55$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4ae7404d3481fd55$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4ae7404d3481fd55$var$queue = [];
var $4ae7404d3481fd55$var$draining = false;
var $4ae7404d3481fd55$var$currentQueue;
var $4ae7404d3481fd55$var$queueIndex = -1;
function $4ae7404d3481fd55$var$cleanUpNextTick() {
    if (!$4ae7404d3481fd55$var$draining || !$4ae7404d3481fd55$var$currentQueue) return;
    $4ae7404d3481fd55$var$draining = false;
    if ($4ae7404d3481fd55$var$currentQueue.length) $4ae7404d3481fd55$var$queue = $4ae7404d3481fd55$var$currentQueue.concat($4ae7404d3481fd55$var$queue);
    else $4ae7404d3481fd55$var$queueIndex = -1;
    if ($4ae7404d3481fd55$var$queue.length) $4ae7404d3481fd55$var$drainQueue();
}
function $4ae7404d3481fd55$var$drainQueue() {
    if ($4ae7404d3481fd55$var$draining) return;
    var timeout = $4ae7404d3481fd55$var$runTimeout($4ae7404d3481fd55$var$cleanUpNextTick);
    $4ae7404d3481fd55$var$draining = true;
    var len = $4ae7404d3481fd55$var$queue.length;
    while(len){
        $4ae7404d3481fd55$var$currentQueue = $4ae7404d3481fd55$var$queue;
        $4ae7404d3481fd55$var$queue = [];
        while(++$4ae7404d3481fd55$var$queueIndex < len)if ($4ae7404d3481fd55$var$currentQueue) $4ae7404d3481fd55$var$currentQueue[$4ae7404d3481fd55$var$queueIndex].run();
        $4ae7404d3481fd55$var$queueIndex = -1;
        len = $4ae7404d3481fd55$var$queue.length;
    }
    $4ae7404d3481fd55$var$currentQueue = null;
    $4ae7404d3481fd55$var$draining = false;
    $4ae7404d3481fd55$var$runClearTimeout(timeout);
}
$4ae7404d3481fd55$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4ae7404d3481fd55$var$queue.push(new $4ae7404d3481fd55$var$Item(fun, args));
    if ($4ae7404d3481fd55$var$queue.length === 1 && !$4ae7404d3481fd55$var$draining) $4ae7404d3481fd55$var$runTimeout($4ae7404d3481fd55$var$drainQueue);
};
// v8 likes predictible objects
function $4ae7404d3481fd55$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4ae7404d3481fd55$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4ae7404d3481fd55$var$process.title = 'browser';
$4ae7404d3481fd55$var$process.browser = true;
$4ae7404d3481fd55$var$process.env = {};
$4ae7404d3481fd55$var$process.argv = [];
$4ae7404d3481fd55$var$process.version = ''; // empty string to avoid regexp issues
$4ae7404d3481fd55$var$process.versions = {};
function $4ae7404d3481fd55$var$noop() {}
$4ae7404d3481fd55$var$process.on = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.addListener = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.once = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.off = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.removeListener = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.removeAllListeners = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.emit = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.prependListener = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.prependOnceListener = $4ae7404d3481fd55$var$noop;
$4ae7404d3481fd55$var$process.listeners = function(name) {
    return [];
};
$4ae7404d3481fd55$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$4ae7404d3481fd55$var$process.cwd = function() {
    return '/';
};
$4ae7404d3481fd55$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$4ae7404d3481fd55$var$process.umask = function() {
    return 0;
};


var $dd0571002eb5e212$var$__defProp = Object.defineProperty;
var $dd0571002eb5e212$var$__defProps = Object.defineProperties;
var $dd0571002eb5e212$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dd0571002eb5e212$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dd0571002eb5e212$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dd0571002eb5e212$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dd0571002eb5e212$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $dd0571002eb5e212$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $dd0571002eb5e212$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($dd0571002eb5e212$var$__hasOwnProp.call(b, prop)) $dd0571002eb5e212$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($dd0571002eb5e212$var$__getOwnPropSymbols) try {
        for(var _iterator = $dd0571002eb5e212$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($dd0571002eb5e212$var$__propIsEnum.call(b, prop)) $dd0571002eb5e212$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $dd0571002eb5e212$var$__spreadProps = function(a, b) {
    return $dd0571002eb5e212$var$__defProps(a, $dd0571002eb5e212$var$__getOwnPropDescs(b));
};
var $dd0571002eb5e212$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($dd0571002eb5e212$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $dd0571002eb5e212$var$__getOwnPropSymbols) try {
        for(var _iterator = $dd0571002eb5e212$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $dd0571002eb5e212$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $dd0571002eb5e212$var$__publicField = function(obj, key, value) {
    return $dd0571002eb5e212$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $k4vcf._)(key)) !== "symbol" ? key + "" : key, value);
};
var $dd0571002eb5e212$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $84c39508ad4d9a30$export$5943f4447f6ef248).apply(void 0, (0, $lJaNg._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $lJaNg._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $iLa78.isDraft)(value) ? (0, $iLa78.current)(value) : value
            ].concat((0, $lJaNg._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $dd0571002eb5e212$export$a5d3c27355e35910 = /* @__PURE__ */ $dd0571002eb5e212$export$aab6de9e3dbb1473((0, $84c39508ad4d9a30$export$8402dc26d96f6902));
var $dd0571002eb5e212$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $k4vcf._)(arguments[0]) === "object") return 0, $e81e114265ee4dc3$export$f672e0b6f7222cd7;
    return (0, $e81e114265ee4dc3$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $dd0571002eb5e212$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $dd0571002eb5e212$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $dd0571002eb5e212$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $lJaNg._)(args));
            if (!prepared) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(0));
            return $dd0571002eb5e212$var$__spreadValues($dd0571002eb5e212$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $e81e114265ee4dc3$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $dd0571002eb5e212$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $dd0571002eb5e212$var$hasMatchFunction(action);
}
function $dd0571002eb5e212$export$ebd532f9034651f3(action) {
    return (0, $e81e114265ee4dc3$export$b956e38827fca970)(action) && Object.keys(action).every($dd0571002eb5e212$var$isValidKey);
}
function $dd0571002eb5e212$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $dd0571002eb5e212$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $dd0571002eb5e212$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $dd0571002eb5e212$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $dd0571002eb5e212$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $dd0571002eb5e212$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $1594H._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $gNNCA._)(this, _Tuple);
        var _this;
        _this = (0, $dOTqn._)(this, _Tuple, (0, $lJaNg._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $9fiLN._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $04b646a8ef722c68$export$71511d61b312f219)((0, $hK71c._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $hw4ub._)(_Tuple, (0, $lJaNg._)(arr[0].concat(this)));
                return (0, $hw4ub._)(_Tuple, (0, $lJaNg._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $29eLC._)(Array));
function $dd0571002eb5e212$var$freezeDraftable(val) {
    return (0, $iLa78.isDraftable)(val) ? (0, $iLa78.produce)(val, function() {}) : val;
}
function $dd0571002eb5e212$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $dd0571002eb5e212$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $dd0571002eb5e212$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $dd0571002eb5e212$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $dd0571002eb5e212$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $dd0571002eb5e212$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $dd0571002eb5e212$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $dd0571002eb5e212$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $dd0571002eb5e212$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $k4vcf._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $dd0571002eb5e212$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $dd0571002eb5e212$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $k4vcf._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $e81e114265ee4dc3$export$53b83ca8eaab0383)(val);
}
function $dd0571002eb5e212$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $dd0571002eb5e212$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $axlKX._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $k4vcf._)(nestedValue)) === "object") {
                foundNestedSerializable = $dd0571002eb5e212$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $k4vcf._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $dd0571002eb5e212$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $dd0571002eb5e212$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $k4vcf._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$dd0571002eb5e212$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $dd0571002eb5e212$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $dd0571002eb5e212$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $dd0571002eb5e212$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $dd0571002eb5e212$export$1908877435b1d5e9();
        if (thunk) {
            if ($dd0571002eb5e212$var$isBoolean(thunk)) middlewareArray.push((0, $6389e9b398f8baa2$export$dd164f5517779f15));
            else middlewareArray.push((0, $6389e9b398f8baa2$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $dd0571002eb5e212$export$8fb31c0f05df007b = "RTK_autoBatch";
var $dd0571002eb5e212$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $eYH8F._)({}, $dd0571002eb5e212$export$8fb31c0f05df007b, true)
        };
    };
};
var $dd0571002eb5e212$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $dd0571002eb5e212$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $dd0571002eb5e212$var$createQueueWithTimer(10);
var $dd0571002eb5e212$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $lJaNg._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $dd0571002eb5e212$var$rAF : options.type === "callback" ? options.queueNotification : $dd0571002eb5e212$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners["delete"](listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$dd0571002eb5e212$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $dd0571002eb5e212$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $dd0571002eb5e212$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($dd0571002eb5e212$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $k4vcf._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
function $dd0571002eb5e212$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $dd0571002eb5e212$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $e81e114265ee4dc3$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $e81e114265ee4dc3$export$66e4520cdb265d18)(reducer);
    else throw new Error($dd0571002eb5e212$export$378fa86b259c0280(1));
    var finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var finalCompose = (0, $e81e114265ee4dc3$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $dd0571002eb5e212$var$composeWithDevTools($dd0571002eb5e212$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, (typeof devTools === "undefined" ? "undefined" : (0, $k4vcf._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $e81e114265ee4dc3$export$9ff26e0402cc7b7).apply(void 0, (0, $lJaNg._)(finalMiddleware));
    var getDefaultEnhancers = $dd0571002eb5e212$var$buildGetDefaultEnhancers(middlewareEnhancer);
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    var composedEnhancer = finalCompose.apply(void 0, (0, $lJaNg._)(storeEnhancers));
    return (0, $e81e114265ee4dc3$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $dd0571002eb5e212$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $dd0571002eb5e212$var$isStateFunction(x) {
    return typeof x === "function";
}
function $dd0571002eb5e212$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $axlKX._)($dd0571002eb5e212$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($dd0571002eb5e212$var$isStateFunction(initialState)) getInitialState = function() {
        return $dd0571002eb5e212$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $dd0571002eb5e212$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $lJaNg._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $iLa78.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $iLa78.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result1;
                } else return (0, $iLa78.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $dd0571002eb5e212$var$matches = function(matcher, action) {
    if ($dd0571002eb5e212$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $dd0571002eb5e212$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $dd0571002eb5e212$var$matches(matcher, action);
        });
    };
}
function $dd0571002eb5e212$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $dd0571002eb5e212$var$matches(matcher, action);
        });
    };
}
function $dd0571002eb5e212$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $dd0571002eb5e212$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $dd0571002eb5e212$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd0571002eb5e212$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$dd0571002eb5e212$var$isAsyncThunkArray(asyncThunks)) return $dd0571002eb5e212$export$872dec21e9a69476()(asyncThunks[0]);
    return $dd0571002eb5e212$export$2c3435c7647f7b0d.apply(void 0, (0, $lJaNg._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $dd0571002eb5e212$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd0571002eb5e212$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$dd0571002eb5e212$var$isAsyncThunkArray(asyncThunks)) return $dd0571002eb5e212$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $dd0571002eb5e212$export$2c3435c7647f7b0d.apply(void 0, (0, $lJaNg._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $dd0571002eb5e212$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $dd0571002eb5e212$export$9dd1fb32974da385($dd0571002eb5e212$export$a5c5d27e3994c5be.apply(void 0, (0, $lJaNg._)(asyncThunks)), hasFlag);
    if (!$dd0571002eb5e212$var$isAsyncThunkArray(asyncThunks)) return $dd0571002eb5e212$export$fcc3388fb56de601()(asyncThunks[0]);
    return $dd0571002eb5e212$export$9dd1fb32974da385($dd0571002eb5e212$export$a5c5d27e3994c5be.apply(void 0, (0, $lJaNg._)(asyncThunks)), hasFlag);
}
function $dd0571002eb5e212$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd0571002eb5e212$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$dd0571002eb5e212$var$isAsyncThunkArray(asyncThunks)) return $dd0571002eb5e212$export$1da80a6ef1307441()(asyncThunks[0]);
    return $dd0571002eb5e212$export$2c3435c7647f7b0d.apply(void 0, (0, $lJaNg._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $dd0571002eb5e212$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd0571002eb5e212$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$dd0571002eb5e212$var$isAsyncThunkArray(asyncThunks)) return $dd0571002eb5e212$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $dd0571002eb5e212$export$2c3435c7647f7b0d.apply(void 0, (0, $lJaNg._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/nanoid.ts
var $dd0571002eb5e212$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $dd0571002eb5e212$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $dd0571002eb5e212$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $dd0571002eb5e212$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $dd0571002eb5e212$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $gNNCA._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $dd0571002eb5e212$var$__publicField(this, "_type");
};
var $dd0571002eb5e212$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $gNNCA._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $dd0571002eb5e212$var$__publicField(this, "_type");
};
var $dd0571002eb5e212$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $dd0571002eb5e212$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $dd0571002eb5e212$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $dd0571002eb5e212$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $dd0571002eb5e212$var$__spreadProps($dd0571002eb5e212$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $dd0571002eb5e212$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $dd0571002eb5e212$var$__spreadProps($dd0571002eb5e212$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $dd0571002eb5e212$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $dd0571002eb5e212$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $dd0571002eb5e212$var$__spreadProps($dd0571002eb5e212$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $dd0571002eb5e212$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $bq3K4._)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $m9tdn.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$dd0571002eb5e212$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $dd0571002eb5e212$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $dd0571002eb5e212$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $dd0571002eb5e212$var$RejectWithValue) throw result;
                                            if (result instanceof $dd0571002eb5e212$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $dd0571002eb5e212$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($dd0571002eb5e212$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $dd0571002eb5e212$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $dd0571002eb5e212$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $dd0571002eb5e212$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $k4vcf._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $dd0571002eb5e212$var$asyncThunkSymbol = /* @__PURE__ */ Symbol["for"]("rtk-slice-createasyncthunk");
var $dd0571002eb5e212$export$343355ed40c51c46 = (0, $eYH8F._)({}, $dd0571002eb5e212$var$asyncThunkSymbol, $dd0571002eb5e212$export$6abd22dc03e5063f);
var $dd0571002eb5e212$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($dd0571002eb5e212$export$23a094319a4b586 || {});
function $dd0571002eb5e212$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $dd0571002eb5e212$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$dd0571002eb5e212$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(11));
        typeof $4ae7404d3481fd55$exports === "undefined" ? "undefined" : (0, $k4vcf._)($4ae7404d3481fd55$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($dd0571002eb5e212$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $dd0571002eb5e212$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($dd0571002eb5e212$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $dd0571002eb5e212$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $dd0571002eb5e212$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $axlKX._)(typeof options.extraReducers === "function" ? $dd0571002eb5e212$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $dd0571002eb5e212$var$__spreadValues($dd0571002eb5e212$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $dd0571002eb5e212$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $dd0571002eb5e212$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $dd0571002eb5e212$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var _a2;
                        var map = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $axlKX._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $dd0571002eb5e212$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $dd0571002eb5e212$var$__spreadProps($dd0571002eb5e212$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $dd0571002eb5e212$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $dd0571002eb5e212$var$__spreadValues($dd0571002eb5e212$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $dd0571002eb5e212$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $lJaNg._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $dd0571002eb5e212$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $dd0571002eb5e212$export$affdea4146de9cf5();
function $dd0571002eb5e212$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $dd0571002eb5e212$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $eYH8F._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $lJaNg._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $dd0571002eb5e212$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$dd0571002eb5e212$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $dd0571002eb5e212$export$309c7a02b0b0bc62(type, prepareCallback) : $dd0571002eb5e212$export$309c7a02b0b0bc62(type));
}
function $dd0571002eb5e212$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $dd0571002eb5e212$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $dd0571002eb5e212$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $dd0571002eb5e212$var$noop,
        pending: pending || $dd0571002eb5e212$var$noop,
        rejected: rejected || $dd0571002eb5e212$var$noop,
        settled: settled || $dd0571002eb5e212$var$noop
    });
}
function $dd0571002eb5e212$var$noop() {}
// src/entities/entity_state.ts
function $dd0571002eb5e212$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $dd0571002eb5e212$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($dd0571002eb5e212$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $dd0571002eb5e212$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $dd0571002eb5e212$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $dd0571002eb5e212$var$isDraftTyped = (0, $iLa78.isDraft);
function $dd0571002eb5e212$var$createSingleArgumentStateOperator(mutator) {
    var operator = $dd0571002eb5e212$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $dd0571002eb5e212$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $dd0571002eb5e212$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($dd0571002eb5e212$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $iLa78.produce)(state, runMutator);
    };
}
function $dd0571002eb5e212$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $dd0571002eb5e212$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $dd0571002eb5e212$var$getCurrent(value) {
    return (0, $iLa78.isDraft)(value) ? (0, $iLa78.current)(value) : value;
}
function $dd0571002eb5e212$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $dd0571002eb5e212$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $dd0571002eb5e212$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $dd0571002eb5e212$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $dd0571002eb5e212$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $dd0571002eb5e212$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $dd0571002eb5e212$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $dd0571002eb5e212$var$__spreadValues($dd0571002eb5e212$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $dd0571002eb5e212$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $axlKX._)($dd0571002eb5e212$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $dd0571002eb5e212$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $dd0571002eb5e212$var$createStateOperator(addOneMutably),
        addMany: $dd0571002eb5e212$var$createStateOperator(addManyMutably),
        setOne: $dd0571002eb5e212$var$createStateOperator(setOneMutably),
        setMany: $dd0571002eb5e212$var$createStateOperator(setManyMutably),
        setAll: $dd0571002eb5e212$var$createStateOperator(setAllMutably),
        updateOne: $dd0571002eb5e212$var$createStateOperator(updateOneMutably),
        updateMany: $dd0571002eb5e212$var$createStateOperator(updateManyMutably),
        upsertOne: $dd0571002eb5e212$var$createStateOperator(upsertOneMutably),
        upsertMany: $dd0571002eb5e212$var$createStateOperator(upsertManyMutably),
        removeOne: $dd0571002eb5e212$var$createStateOperator(removeOneMutably),
        removeMany: $dd0571002eb5e212$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $dd0571002eb5e212$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $dd0571002eb5e212$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $dd0571002eb5e212$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $dd0571002eb5e212$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $dd0571002eb5e212$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $dd0571002eb5e212$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($dd0571002eb5e212$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $dd0571002eb5e212$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $axlKX._)($dd0571002eb5e212$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $dd0571002eb5e212$var$getCurrent(state.entities);
        var currentIds = $dd0571002eb5e212$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $dd0571002eb5e212$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $dd0571002eb5e212$var$createStateOperator(addOneMutably),
        updateOne: $dd0571002eb5e212$var$createStateOperator(updateOneMutably),
        upsertOne: $dd0571002eb5e212$var$createStateOperator(upsertOneMutably),
        setOne: $dd0571002eb5e212$var$createStateOperator(setOneMutably),
        setMany: $dd0571002eb5e212$var$createStateOperator(setManyMutably),
        setAll: $dd0571002eb5e212$var$createStateOperator(setAllMutably),
        addMany: $dd0571002eb5e212$var$createStateOperator(addManyMutably),
        updateMany: $dd0571002eb5e212$var$createStateOperator(updateManyMutably),
        upsertMany: $dd0571002eb5e212$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $dd0571002eb5e212$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $dd0571002eb5e212$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $dd0571002eb5e212$var$createSortedStateAdapter(selectId, sortComparer) : $dd0571002eb5e212$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $dd0571002eb5e212$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $dd0571002eb5e212$var$createSelectorsFactory();
    return $dd0571002eb5e212$var$__spreadValues($dd0571002eb5e212$var$__spreadValues($dd0571002eb5e212$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $dd0571002eb5e212$var$task = "task";
var $dd0571002eb5e212$var$listener = "listener";
var $dd0571002eb5e212$var$completed = "completed";
var $dd0571002eb5e212$var$cancelled = "cancelled";
var $dd0571002eb5e212$var$taskCancelled = "task-".concat($dd0571002eb5e212$var$cancelled);
var $dd0571002eb5e212$var$taskCompleted = "task-".concat($dd0571002eb5e212$var$completed);
var $dd0571002eb5e212$var$listenerCancelled = "".concat($dd0571002eb5e212$var$listener, "-").concat($dd0571002eb5e212$var$cancelled);
var $dd0571002eb5e212$var$listenerCompleted = "".concat($dd0571002eb5e212$var$listener, "-").concat($dd0571002eb5e212$var$completed);
var $dd0571002eb5e212$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $gNNCA._)(this, TaskAbortError);
    this.code = code;
    $dd0571002eb5e212$var$__publicField(this, "name", "TaskAbortError");
    $dd0571002eb5e212$var$__publicField(this, "message");
    this.message = "".concat($dd0571002eb5e212$var$task, " ").concat($dd0571002eb5e212$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $dd0571002eb5e212$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError($dd0571002eb5e212$export$378fa86b259c0280(32));
};
var $dd0571002eb5e212$var$noop2 = function() {};
var $dd0571002eb5e212$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $dd0571002eb5e212$var$noop2;
    promise["catch"](onError);
    return promise;
};
var $dd0571002eb5e212$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $dd0571002eb5e212$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $dd0571002eb5e212$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $dd0571002eb5e212$export$cb1bdac908fed7f(reason);
    }
};
function $dd0571002eb5e212$var$raceWithSignal(signal, promise) {
    var cleanup = $dd0571002eb5e212$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $dd0571002eb5e212$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $dd0571002eb5e212$var$addAbortSignalListener(signal, notifyRejection);
        promise["finally"](function() {
            return cleanup();
        }).then(resolve, reject);
    })["finally"](function() {
        cleanup = $dd0571002eb5e212$var$noop2;
    });
}
var $dd0571002eb5e212$var$runTask = /*#__PURE__*/ function() {
    var _ref = (0, $bq3K4._)(function(task2, cleanUp) {
        var value, error;
        return (0, $m9tdn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $dd0571002eb5e212$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $dd0571002eb5e212$var$createPause = function(signal) {
    return function(promise) {
        return $dd0571002eb5e212$var$catchRejection($dd0571002eb5e212$var$raceWithSignal(signal, promise).then(function(output) {
            $dd0571002eb5e212$var$validateActive(signal);
            return output;
        }));
    };
};
var $dd0571002eb5e212$var$createDelay = function(signal) {
    var pause = $dd0571002eb5e212$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $dd0571002eb5e212$var$assign = Object.assign;
var $dd0571002eb5e212$var$INTERNAL_NIL_TOKEN = {};
var $dd0571002eb5e212$var$alm = "listenerMiddleware";
var $dd0571002eb5e212$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $dd0571002eb5e212$var$addAbortSignalListener(parentAbortSignal, function() {
            return $dd0571002eb5e212$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $dd0571002eb5e212$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $dd0571002eb5e212$var$runTask(/*#__PURE__*/ (0, $bq3K4._)(function() {
            var result2;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $dd0571002eb5e212$var$validateActive(parentAbortSignal);
                        $dd0571002eb5e212$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $dd0571002eb5e212$var$createPause(childAbortController.signal),
                                delay: $dd0571002eb5e212$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $dd0571002eb5e212$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $dd0571002eb5e212$var$abortControllerWithReason(childAbortController, $dd0571002eb5e212$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result["catch"]($dd0571002eb5e212$var$noop2));
        return {
            result: $dd0571002eb5e212$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $dd0571002eb5e212$var$abortControllerWithReason(childAbortController, $dd0571002eb5e212$var$taskCancelled);
            }
        };
    };
};
var $dd0571002eb5e212$var$createTakePattern = function(startListening, signal) {
    var take = /*#__PURE__*/ function() {
        var _ref = (0, $bq3K4._)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $dd0571002eb5e212$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $dd0571002eb5e212$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $dd0571002eb5e212$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $dd0571002eb5e212$var$catchRejection(take(predicate, timeout));
    };
};
var $dd0571002eb5e212$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $dd0571002eb5e212$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($dd0571002eb5e212$export$378fa86b259c0280(21));
    $dd0571002eb5e212$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $dd0571002eb5e212$var$createListenerEntry = /* @__PURE__ */ $dd0571002eb5e212$var$assign(function(options) {
    var _getListenerEntryPropsFrom = $dd0571002eb5e212$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $dd0571002eb5e212$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($dd0571002eb5e212$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $dd0571002eb5e212$var$createListenerEntry;
    }
});
var $dd0571002eb5e212$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $dd0571002eb5e212$var$abortControllerWithReason(controller, $dd0571002eb5e212$var$listenerCancelled);
    });
};
var $dd0571002eb5e212$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($dd0571002eb5e212$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $dd0571002eb5e212$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $dd0571002eb5e212$export$f03a6b845d3fb58b = /* @__PURE__ */ $dd0571002eb5e212$var$assign(/* @__PURE__ */ $dd0571002eb5e212$export$309c7a02b0b0bc62("".concat($dd0571002eb5e212$var$alm, "/add")), {
    withTypes: function() {
        return $dd0571002eb5e212$export$f03a6b845d3fb58b;
    }
});
var $dd0571002eb5e212$export$b1b8022855fb2b71 = /* @__PURE__ */ $dd0571002eb5e212$export$309c7a02b0b0bc62("".concat($dd0571002eb5e212$var$alm, "/removeAll"));
var $dd0571002eb5e212$export$b03e9483f936dccb = /* @__PURE__ */ $dd0571002eb5e212$var$assign(/* @__PURE__ */ $dd0571002eb5e212$export$309c7a02b0b0bc62("".concat($dd0571002eb5e212$var$alm, "/remove")), {
    withTypes: function() {
        return $dd0571002eb5e212$export$b03e9483f936dccb;
    }
});
var $dd0571002eb5e212$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($dd0571002eb5e212$var$alm, "/error")
    ].concat((0, $lJaNg._)(args)));
};
var $dd0571002eb5e212$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $dd0571002eb5e212$var$defaultErrorHandler : _middlewareOptions_onError;
    $dd0571002eb5e212$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap["delete"](entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $dd0571002eb5e212$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $dd0571002eb5e212$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $dd0571002eb5e212$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $dd0571002eb5e212$var$assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $dd0571002eb5e212$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $dd0571002eb5e212$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $dd0571002eb5e212$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $dd0571002eb5e212$var$assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = /*#__PURE__*/ function() {
        var _ref = (0, $bq3K4._)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $dd0571002eb5e212$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $dd0571002eb5e212$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $dd0571002eb5e212$var$createDelay(internalTaskController.signal),
                                pause: $dd0571002eb5e212$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $dd0571002eb5e212$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $dd0571002eb5e212$var$abortControllerWithReason(controller, $dd0571002eb5e212$var$listenerCancelled);
                                            set["delete"](controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $dd0571002eb5e212$var$abortControllerWithReason(internalTaskController, $dd0571002eb5e212$var$listenerCancelled);
                                    entry.pending["delete"](internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $dd0571002eb5e212$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $dd0571002eb5e212$export$cb1bdac908fed7f)) $dd0571002eb5e212$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $dd0571002eb5e212$var$abortControllerWithReason(internalTaskController, $dd0571002eb5e212$var$listenerCompleted);
                        entry.pending["delete"](internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $dd0571002eb5e212$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $e81e114265ee4dc3$export$b956e38827fca970)(action)) return next(action);
                if ($dd0571002eb5e212$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($dd0571002eb5e212$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($dd0571002eb5e212$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $dd0571002eb5e212$var$INTERNAL_NIL_TOKEN) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $dd0571002eb5e212$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $dd0571002eb5e212$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $dd0571002eb5e212$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $dd0571002eb5e212$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $dd0571002eb5e212$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $dd0571002eb5e212$export$4bb1606a79445586 = function() {
    var instanceId = $dd0571002eb5e212$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($dd0571002eb5e212$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $dd0571002eb5e212$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $dd0571002eb5e212$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $dd0571002eb5e212$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $e81e114265ee4dc3$export$f672e0b6f7222cd7).apply(void 0, (0, $lJaNg._)(appliedMiddleware));
    };
    var isWithMiddleware = $dd0571002eb5e212$export$9dd1fb32974da385(withMiddleware, $dd0571002eb5e212$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $lJaNg._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $dd0571002eb5e212$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $dd0571002eb5e212$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $dd0571002eb5e212$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $dd0571002eb5e212$var$ORIGINAL_STATE = Symbol["for"]("rtk-state-proxy-original");
var $dd0571002eb5e212$var$isStateProxy = function(value) {
    return !!value && !!value[$dd0571002eb5e212$var$ORIGINAL_STATE];
};
var $dd0571002eb5e212$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $dd0571002eb5e212$var$createStateProxy = function(state, reducerMap) {
    return $dd0571002eb5e212$var$emplace($dd0571002eb5e212$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $dd0571002eb5e212$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $dd0571002eb5e212$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($dd0571002eb5e212$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $dd0571002eb5e212$var$original = function(state) {
    if (!$dd0571002eb5e212$var$isStateProxy(state)) throw new Error($dd0571002eb5e212$export$378fa86b259c0280(25));
    return state[$dd0571002eb5e212$var$ORIGINAL_STATE];
};
var $dd0571002eb5e212$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $dd0571002eb5e212$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($dd0571002eb5e212$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $e81e114265ee4dc3$export$66e4520cdb265d18)(reducerMap) : $dd0571002eb5e212$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $4ae7404d3481fd55$exports === "undefined" ? "undefined" : (0, $k4vcf._)($4ae7404d3481fd55$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $dd0571002eb5e212$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $lJaNg._)(args))) : state, reducerMap)
            ].concat((0, $lJaNg._)(args)));
        };
    }, {
        original: $dd0571002eb5e212$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $dd0571002eb5e212$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $a9eb891981334d6b$var$cartSlice = (0, $dd0571002eb5e212$export$4d8d9bd83c24ae8b)({
    name: 'cart',
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        removeItem: function(state) {
            state.items.pop();
        },
        clearCart: function(state) {
            state.items.length = 0;
        }
    }
});
var $a9eb891981334d6b$var$_cartSlice_actions = $a9eb891981334d6b$var$cartSlice.actions;
var $a9eb891981334d6b$export$fb9705de59d96855 = $a9eb891981334d6b$var$_cartSlice_actions.addItem, $a9eb891981334d6b$export$fe2d9b4e03920b4c = $a9eb891981334d6b$var$_cartSlice_actions.removeItem, $a9eb891981334d6b$export$810121176e3e3671 = $a9eb891981334d6b$var$_cartSlice_actions.clearCart;
var $a9eb891981334d6b$export$2e2bcd8739ae039 = $a9eb891981334d6b$var$cartSlice.reducer;


var $4205f186b4e859bb$var$Itemlist = function(param) {
    var items = param.items;
    var dispatch = (0, $130b58dab455a653$export$8ad76b76a4c905f8)();
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(null), 2), clickedItemId = _useState[0], setClickedItemId = _useState[1];
    var handleAddItem = function(item) {
        dispatch((0, $a9eb891981334d6b$export$fb9705de59d96855)(item));
        setClickedItemId(item.card.info.id);
        setTimeout(function() {
            return setClickedItemId(null);
        }, 500);
    };
    return /*#__PURE__*/ (0, $22qX1.jsx)("div", {
        className: "space-y-4",
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "p-4 border rounded-lg shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white dark:bg-gray-700",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $22qX1.jsx)("h3", {
                                className: "font-semibold text-gray-800 dark:text-white",
                                children: item.card.info.name
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("p", {
                                className: "text-sm text-gray-600 dark:text-gray-300 mt-1",
                                children: item.card.info.description
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsxs)("span", {
                                className: "block mt-2 font-bold text-green-600 dark:text-green-400",
                                children: [
                                    "\u20B9",
                                    " ",
                                    item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                        className: "flex flex-col items-center md:items-end",
                        children: [
                            item.card.info.imageId && /*#__PURE__*/ (0, $22qX1.jsx)("img", {
                                src: (0, $7fb67fe6c69adf0e$export$31adfacaf07ffe63) + item.card.info.imageId,
                                alt: "listImage",
                                className: "w-32 h-24 rounded-lg object-cover"
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                                className: "mt-2 px-4 py-1 rounded-lg font-bold shadow-md transition-all ".concat(clickedItemId === item.card.info.id ? "bg-green-500 text-white" : "bg-white text-green-600 border border-green-600"),
                                onClick: function() {
                                    return handleAddItem(item);
                                },
                                children: clickedItemId === item.card.info.id ? "\u2714 Added" : "ADD"
                            })
                        ]
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $4205f186b4e859bb$export$2e2bcd8739ae039 = $4205f186b4e859bb$var$Itemlist;


var $6464ecff9878a12c$var$RestaurantCategories = function(param) {
    var data = param.data, showItems = param.showItems, setShowIndex = param.setShowIndex;
    return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
        className: "w-11/12 mx-auto my-4 p-4 rounded-lg shadow-md bg-white dark:bg-gray-700 transition-all",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "flex justify-between items-center cursor-pointer",
                onClick: setShowIndex,
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsxs)("span", {
                        className: "font-bold text-lg dark:text-white",
                        children: [
                            data.title,
                            " (",
                            data.itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("span", {
                        className: "text-xl dark:text-white",
                        children: showItems ? "\u25B2" : "\u25BC"
                    })
                ]
            }),
            showItems && /*#__PURE__*/ (0, $22qX1.jsx)((0, $4205f186b4e859bb$export$2e2bcd8739ae039), {
                items: data.itemCards
            })
        ]
    });
};
var $6464ecff9878a12c$export$2e2bcd8739ae039 = $6464ecff9878a12c$var$RestaurantCategories;



var $eN0cn = parcelRequire("eN0cn");
var $81e52b98cf713463$var$RestaurantMenu = function() {
    var _resInfo_cards, _restaurantInfoCard_card_card, _restaurantInfoCard_card, _resInfo_cards1, _menuCard_groupedCard_cardGroupMap_REGULAR, _menuCard_groupedCard_cardGroupMap, _menuCard_groupedCard;
    var resId = (0, $f0e056f577c778ce$export$99eaa27ddbbb95ef)().resId;
    var resInfo = (0, $90e57ff561124c41$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(null), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    if (!resInfo) return /*#__PURE__*/ (0, $22qX1.jsx)((0, $4199897659dc45e5$export$2e2bcd8739ae039), {});
    var restaurantInfoCard = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards = resInfo.cards) === null || _resInfo_cards === void 0 ? void 0 : _resInfo_cards.find(function(c) {
        var _c_card_card, _c_card;
        return (c === null || c === void 0 ? void 0 : (_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.Restaurant";
    });
    var _ref = (restaurantInfoCard === null || restaurantInfoCard === void 0 ? void 0 : (_restaurantInfoCard_card = restaurantInfoCard.card) === null || _restaurantInfoCard_card === void 0 ? void 0 : (_restaurantInfoCard_card_card = _restaurantInfoCard_card.card) === null || _restaurantInfoCard_card_card === void 0 ? void 0 : _restaurantInfoCard_card_card.info) || {}, name = _ref.name, cuisines = _ref.cuisines, costForTwoMessage = _ref.costForTwoMessage, avgRating = _ref.avgRating, totalRatingsString = _ref.totalRatingsString;
    var menuCard = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards1 = resInfo.cards) === null || _resInfo_cards1 === void 0 ? void 0 : _resInfo_cards1.find(function(c) {
        return c === null || c === void 0 ? void 0 : c.groupedCard;
    });
    var categories = (menuCard === null || menuCard === void 0 ? void 0 : (_menuCard_groupedCard = menuCard.groupedCard) === null || _menuCard_groupedCard === void 0 ? void 0 : (_menuCard_groupedCard_cardGroupMap = _menuCard_groupedCard.cardGroupMap) === null || _menuCard_groupedCard_cardGroupMap === void 0 ? void 0 : (_menuCard_groupedCard_cardGroupMap_REGULAR = _menuCard_groupedCard_cardGroupMap.REGULAR) === null || _menuCard_groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _menuCard_groupedCard_cardGroupMap_REGULAR.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    })) || [];
    return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
        className: "dark:bg-gray-900 min-h-screen py-6 px-4 sm:px-8",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 mb-8",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsx)("h1", {
                        className: "font-extrabold text-2xl sm:text-3xl text-gray-800 dark:text-white",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)("p", {
                        className: "text-gray-600 dark:text-gray-300 mt-2",
                        children: cuisines === null || cuisines === void 0 ? void 0 : cuisines.join(", ")
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                        className: "flex flex-col sm:flex-row justify-between items-start sm:items-center mt-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $22qX1.jsxs)("p", {
                                className: "text-green-600 font-semibold bg-green-100 px-3 py-1 rounded-lg dark:bg-green-700 dark:text-green-200",
                                children: [
                                    "\u2B50 ",
                                    avgRating,
                                    " \u2022 ",
                                    totalRatingsString
                                ]
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsx)("p", {
                                className: "mt-2 sm:mt-0 font-medium text-gray-700 dark:text-gray-200",
                                children: costForTwoMessage
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $22qX1.jsx)("div", {
                className: "max-w-3xl mx-auto",
                children: categories.map(function(category, index) {
                    var _category_card, _category_card1;
                    return /*#__PURE__*/ (0, $22qX1.jsx)((0, $6464ecff9878a12c$export$2e2bcd8739ae039), {
                        data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                        index: index,
                        showItems: index === showIndex,
                        setShowIndex: function() {
                            return setShowIndex(index === showIndex ? null : index);
                        }
                    }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : _category_card1.card.title);
                })
            })
        ]
    });
};
var $81e52b98cf713463$export$2e2bcd8739ae039 = $81e52b98cf713463$var$RestaurantMenu;








var $4a17141f4f1c5acb$var$appStore = (0, $dd0571002eb5e212$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $a9eb891981334d6b$export$2e2bcd8739ae039)
    }
});
var $4a17141f4f1c5acb$export$2e2bcd8739ae039 = $4a17141f4f1c5acb$var$appStore;



var $bq3K4 = parcelRequire("bq3K4");

var $axlKX = parcelRequire("axlKX");

var $m9tdn = parcelRequire("m9tdn");

var $22qX1 = parcelRequire("22qX1");

var $eN0cn = parcelRequire("eN0cn");



var $fcc1ff75c8624710$var$Cart = function() {
    var cartItems = (0, $130b58dab455a653$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var totalAmount = cartItems.reduce(function(sum, item) {
        return sum + (item.card.info.price || item.card.info.defaultPrice) / 100;
    }, 0);
    var dispatch = (0, $130b58dab455a653$export$8ad76b76a4c905f8)();
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(false), 2), isProcessing = _useState[0], setIsProcessing = _useState[1];
    var handleClearCart = function() {
        dispatch((0, $a9eb891981334d6b$export$810121176e3e3671)());
    };
    var ensureRazorpayLoaded = function() {
        return new Promise(function(resolve, reject) {
            if (window.Razorpay) return resolve();
            var existing = document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]');
            if (existing) {
                if (existing.getAttribute("data-loaded") === "true") return resolve();
                existing.addEventListener("load", function() {
                    return resolve();
                });
                existing.addEventListener("error", function() {
                    return reject(new Error("Razorpay script failed to load"));
                });
                return;
            }
            var s = document.createElement("script");
            s.src = "https://checkout.razorpay.com/v1/checkout.js";
            s.async = true;
            s.onload = function() {
                s.setAttribute("data-loaded", "true");
                resolve();
            };
            s.onerror = function() {
                return reject(new Error("Razorpay script failed to load"));
            };
            document.body.appendChild(s);
        });
    };
    var handlePayment = /*#__PURE__*/ function() {
        var _ref = (0, $bq3K4._)(function() {
            var response, data, options, razorpay, err;
            return (0, $m9tdn.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isProcessing) return [
                            2
                        ]; // prevent duplicate calls
                        if (cartItems.length === 0) return [
                            2
                        ];
                        setIsProcessing(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        return [
                            4,
                            ensureRazorpayLoaded()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            fetch("http://localhost:3001/api/create-order", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    amount: totalAmount * 100,
                                    currency: "INR",
                                    receipt: "order_rcptid_11"
                                })
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        data = _state.sent();
                        options = {
                            key: (0, window.RAZORPAY_KEY),
                            amount: data.amount_due || data.amount || totalAmount * 100,
                            currency: data.currency || "INR",
                            order_id: data.id,
                            name: "Your App Name",
                            description: "Payment for Order",
                            handler: function handler(response) {
                                console.log("Payment successful: ", response);
                                alert("Payment successful!");
                            },
                            prefill: {
                                name: "Customer Name",
                                email: "customer@example.com",
                                contact: "1234567890"
                            },
                            notes: {
                                address: "Customer Address"
                            },
                            theme: {
                                color: "#F37254"
                            }
                        };
                        razorpay = new window.Razorpay(options);
                        razorpay.open();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        err = _state.sent();
                        console.error("Error in creating order or loading Razorpay: ", err);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsProcessing(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePayment() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
        className: "m-10 text-center dark:bg-gray-800 dark:text-white rounded-md",
        children: [
            /*#__PURE__*/ (0, $22qX1.jsx)("h1", {
                className: "text-2xl font-bold",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $22qX1.jsx)("button", {
                className: "p-2 m-2 bg-green-500 text-white rounded-lg hover:bg-green-600 dark:bg-green-700 dark:hover:bg-green-600",
                onClick: handleClearCart,
                children: "Clear Cart"
            }),
            cartItems.length === 0 && /*#__PURE__*/ (0, $22qX1.jsx)("h1", {
                className: "font-serif text-2xl",
                children: "Your cart is empty"
            }),
            /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsx)((0, $4205f186b4e859bb$export$2e2bcd8739ae039), {
                        items: cartItems
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $22qX1.jsxs)("h2", {
                                className: "font-bold text-lg w-6/12 m-auto",
                                children: [
                                    "Total: \u20B9",
                                    totalAmount
                                ]
                            }),
                            /*#__PURE__*/ (0, $22qX1.jsxs)("button", {
                                className: "p-2 bg-green-500 text-white rounded mt-4 hover:bg-green-600 dark:bg-green-700 dark:hover:bg-green-600",
                                onClick: handlePayment,
                                children: [
                                    "Proceed to Pay \u20B9",
                                    totalAmount
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fcc1ff75c8624710$export$2e2bcd8739ae039 = $fcc1ff75c8624710$var$Cart;



var $dd22fc45384075f8$var$Grocery = /*#__PURE__*/ (0, $eN0cn.lazy)(function() {
    return (parcelRequire("8d5DK"));
});
var $dd22fc45384075f8$var$AppLayout = function() {
    var _useState = (0, $axlKX._)((0, $eN0cn.useState)(), 2), userName = _useState[0], setUserName = _useState[1];
    var _useState1 = (0, $axlKX._)((0, $eN0cn.useState)(false), 2), darkMode = _useState1[0], setDarkMode = _useState1[1];
    (0, $eN0cn.useEffect)(function() {
        var data = {
            name: "Gagan Salian"
        };
        setUserName(data.name);
    }, []);
    var handleDarkModeToggle = function() {
        setDarkMode(!darkMode);
        if (darkMode) document.documentElement.classList.remove("dark");
        else document.documentElement.classList.add("dark");
    };
    return /*#__PURE__*/ (0, $22qX1.jsx)((0, $130b58dab455a653$export$2881499e37b75b9a), {
        store: (0, $4a17141f4f1c5acb$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $22qX1.jsx)((0, $ce4e95b53dbe8cd7$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $22qX1.jsxs)("div", {
                className: "bg-orange-100 app ".concat(darkMode ? "dark" : ""),
                children: [
                    /*#__PURE__*/ (0, $22qX1.jsx)((0, $37b06739dce8f517$export$2e2bcd8739ae039), {
                        toggleDarkMode: handleDarkModeToggle
                    }),
                    /*#__PURE__*/ (0, $22qX1.jsx)((0, $f0e056f577c778ce$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
};
var $dd22fc45384075f8$var$appRouter = (0, $df9553b03ed5684d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $22qX1.jsx)($dd22fc45384075f8$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $22qX1.jsx)((0, $718b5b3989e34d90$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $22qX1.jsx)((0, $b38f5e7923f6bc90$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $22qX1.jsx)((0, $59390c90ae638e0b$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $22qX1.jsx)((0, $eN0cn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $22qX1.jsx)((0, $4199897659dc45e5$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $22qX1.jsx)($dd22fc45384075f8$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $22qX1.jsx)((0, $81e52b98cf713463$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $22qX1.jsx)((0, $fcc1ff75c8624710$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $22qX1.jsx)((0, $ba9003b0ab5e1c94$export$2e2bcd8739ae039), {})
    }
]);
var $dd22fc45384075f8$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($446c27911db40913$exports))).createRoot(document.getElementById("root"));
$dd22fc45384075f8$var$root.render(/*#__PURE__*/ (0, $22qX1.jsx)((0, $df9553b03ed5684d$export$323e4fc2fa4753fb), {
    router: $dd22fc45384075f8$var$appRouter
}));

})();
//# sourceMappingURL=index.19057117.js.map
